// This file is auto-generated by @hey-api/openapi-ts
import type {
  Client,
  ClientMeta,
  Options as Options2,
  RequestResult,
  TDataShape,
} from './client'
import { client } from './client.gen'
import type {
  DeleteActivitiesByIdData,
  DeleteActivitiesByIdResponses,
  DeleteAdminExtraMenuItemsByIdData,
  DeleteAdminExtraMenuItemsByIdErrors,
  DeleteAdminExtraMenuItemsByIdResponses,
  DeleteAdminLiveEventsByIdData,
  DeleteAdminLiveEventsByIdErrors,
  DeleteAdminLiveEventsByIdResponses,
  DeleteAdminLiveEventsByIdSessionsBySessionIdData,
  DeleteAdminLiveEventsByIdSessionsBySessionIdErrors,
  DeleteAdminLiveEventsByIdSessionsBySessionIdResponses,
  DeleteAdsenseSlotsByIdData,
  DeleteAdsenseSlotsByIdErrors,
  DeleteAdsenseSlotsByIdResponses,
  DeleteBlocksByIdData,
  DeleteBlocksByIdResponses,
  DeleteBonusesByIdData,
  DeleteBonusesByIdErrors,
  DeleteBonusesByIdResponses,
  DeleteCommentsByIdUnlikeData,
  DeleteCommentsByIdUnlikeErrors,
  DeleteCommentsByIdUnlikeResponses,
  DeleteCustomBannersByIdData,
  DeleteCustomBannersByIdErrors,
  DeleteCustomBannersByIdResponses,
  DeleteDrawsByIdData,
  DeleteDrawsByIdErrors,
  DeleteDrawsByIdResponses,
  DeleteEndorsementsByIdData,
  DeleteEndorsementsByIdErrors,
  DeleteEndorsementsByIdResponses,
  DeleteMatchesByIdData,
  DeleteMatchesByIdErrors,
  DeleteMatchesByIdResponses,
  DeleteOfferCategoriesByIdData,
  DeleteOfferCategoriesByIdErrors,
  DeleteOfferCategoriesByIdResponses,
  DeleteOffersByIdData,
  DeleteOffersByIdErrors,
  DeleteOffersByIdResponses,
  DeletePositionedBannersByIdData,
  DeletePositionedBannersByIdResponses,
  DeletePostsByIdData,
  DeletePostsByIdErrors,
  DeletePostsByIdResponses,
  DeletePostsByIdUnlikeData,
  DeletePostsByIdUnlikeErrors,
  DeletePostsByIdUnlikeResponses,
  DeletePostsByPostIdCommentsByIdData,
  DeletePostsByPostIdCommentsByIdErrors,
  DeletePostsByPostIdCommentsByIdResponses,
  DeletePremiumTokensByIdData,
  DeletePremiumTokensByIdErrors,
  DeletePremiumTokensByIdResponses,
  DeleteReportsByIdDeleteTargetData,
  DeleteReportsByIdDeleteTargetErrors,
  DeleteReportsByIdDeleteTargetResponses,
  DeleteSavedCompetitionSearchData,
  DeleteSavedCompetitionSearchErrors,
  DeleteSavedCompetitionSearchResponses,
  DeleteSessionsByIdData,
  DeleteSessionsByIdResponses,
  DeleteSmartWatchWorkoutsByIdData,
  DeleteSmartWatchWorkoutsByIdErrors,
  DeleteSmartWatchWorkoutsByIdResponses,
  DeleteTrainingsByIdData,
  DeleteTrainingsByIdResponses,
  DeleteTrainingSchedulesByIdData,
  DeleteTrainingSchedulesByIdErrors,
  DeleteTrainingSchedulesByIdResponses,
  DeleteUpdateTasksByIdData,
  DeleteUpdateTasksByIdErrors,
  DeleteUpdateTasksByIdResponses,
  DeleteUserMatchesByIdData,
  DeleteUserMatchesByIdErrors,
  DeleteUserMatchesByIdRequestData,
  DeleteUserMatchesByIdRequestErrors,
  DeleteUserMatchesByIdRequestResponses,
  DeleteUserMatchesByIdResponses,
  DeleteUserMatchesByIdSeatData,
  DeleteUserMatchesByIdSeatErrors,
  DeleteUserMatchesByIdSeatResponses,
  DeleteUsersByIdData,
  DeleteUsersByIdErrors,
  DeleteUsersByIdResponses,
  DeleteUsersUpdatesNotificationsByIdData,
  DeleteUsersUpdatesNotificationsByIdErrors,
  DeleteUsersUpdatesNotificationsByIdResponses,
  GetActivitiesByIdData,
  GetActivitiesByIdErrors,
  GetActivitiesByIdResponses,
  GetActivitiesData,
  GetActivitiesResponses,
  GetActivitiesStreakData,
  GetActivitiesStreakErrors,
  GetActivitiesStreakResponses,
  GetAdminExtraMenuItemsData,
  GetAdminExtraMenuItemsErrors,
  GetAdminExtraMenuItemsResponses,
  GetAdminLiveEventsByIdData,
  GetAdminLiveEventsByIdErrors,
  GetAdminLiveEventsByIdLeaderboardData,
  GetAdminLiveEventsByIdLeaderboardErrors,
  GetAdminLiveEventsByIdLeaderboardResponses,
  GetAdminLiveEventsByIdQueueData,
  GetAdminLiveEventsByIdQueueErrors,
  GetAdminLiveEventsByIdQueueResponses,
  GetAdminLiveEventsByIdResponses,
  GetAdminLiveEventsByIdSessionsData,
  GetAdminLiveEventsByIdSessionsErrors,
  GetAdminLiveEventsByIdSessionsResponses,
  GetAdminLiveEventsData,
  GetAdminLiveEventsErrors,
  GetAdminLiveEventsResponses,
  GetAdsenseSlotsAllData,
  GetAdsenseSlotsAllResponses,
  GetAdsenseSlotsByIdData,
  GetAdsenseSlotsByIdErrors,
  GetAdsenseSlotsByIdResponses,
  GetAdsenseSlotsData,
  GetAdsenseSlotsResponses,
  GetAppVersionData,
  GetAppVersionResponses,
  GetBonusesData,
  GetBonusesErrors,
  GetBonusesResponses,
  GetCardinalityData,
  GetCardinalityResponses,
  GetClubManagerProfilesData,
  GetClubManagerProfilesErrors,
  GetClubManagerProfilesResponses,
  GetClubsByIdData,
  GetClubsByIdErrors,
  GetClubsByIdFeedData,
  GetClubsByIdFeedErrors,
  GetClubsByIdFeedResponses,
  GetClubsByIdResponses,
  GetClubsIdByFitClubIdByFitClubIdData,
  GetClubsIdByFitClubIdByFitClubIdErrors,
  GetClubsIdByFitClubIdByFitClubIdResponses,
  GetClubsNearbyData,
  GetClubsNearbyErrors,
  GetClubsNearbyResponses,
  GetCommunityFeedData,
  GetCommunityFeedErrors,
  GetCommunityFeedResponses,
  GetCompetitionsByIdData,
  GetCompetitionsByIdErrors,
  GetCompetitionsByIdResponses,
  GetCompetitionsSearchData,
  GetCompetitionsSearchResponses,
  GetCustomBannersAllData,
  GetCustomBannersAllResponses,
  GetCustomBannersByIdData,
  GetCustomBannersByIdErrors,
  GetCustomBannersByIdResponses,
  GetCustomBannersData,
  GetCustomBannersResponses,
  GetDailyReportsData,
  GetDailyReportsErrors,
  GetDailyReportsOverviewData,
  GetDailyReportsOverviewErrors,
  GetDailyReportsOverviewResponses,
  GetDailyReportsResponses,
  GetDailyReportsSourcesData,
  GetDailyReportsSourcesErrors,
  GetDailyReportsSourcesResponses,
  GetDailyReportsUpcomingRenewalsData,
  GetDailyReportsUpcomingRenewalsErrors,
  GetDailyReportsUpcomingRenewalsResponses,
  GetDrawsByIdData,
  GetDrawsByIdErrors,
  GetDrawsByIdResponses,
  GetEditProfileProfilesData,
  GetEditProfileProfilesErrors,
  GetEditProfileProfilesResponses,
  GetExtraMenuItemsData,
  GetExtraMenuItemsResponses,
  GetFakeRouteToTestLoginCheckData,
  GetFakeRouteToTestLoginCheckErrors,
  GetFakeRouteToTestLoginCheckResponses,
  GetFeedNewsData,
  GetFeedNewsResponses,
  GetFitPlayerProfileRequestsData,
  GetFitPlayerProfileRequestsErrors,
  GetFitPlayerProfileRequestsResponses,
  GetFitPlayerProfilesAdvancedSearchFiltersData,
  GetFitPlayerProfilesAdvancedSearchFiltersResponses,
  GetFitPlayerProfilesByIdChartExtractData,
  GetFitPlayerProfilesByIdChartExtractErrors,
  GetFitPlayerProfilesByIdChartExtractResponses,
  GetFitPlayerProfilesByIdConnectionsData,
  GetFitPlayerProfilesByIdConnectionsErrors,
  GetFitPlayerProfilesByIdConnectionsReducedData,
  GetFitPlayerProfilesByIdConnectionsReducedErrors,
  GetFitPlayerProfilesByIdConnectionsReducedResponses,
  GetFitPlayerProfilesByIdConnectionsResponses,
  GetFitPlayerProfilesByIdData,
  GetFitPlayerProfilesByIdEndorsementsData,
  GetFitPlayerProfilesByIdEndorsementsResponses,
  GetFitPlayerProfilesByIdErrors,
  GetFitPlayerProfilesByIdEvaluationData,
  GetFitPlayerProfilesByIdEvaluationResponses,
  GetFitPlayerProfilesByIdFeedData,
  GetFitPlayerProfilesByIdFeedResponses,
  GetFitPlayerProfilesByIdHarmonizationData,
  GetFitPlayerProfilesByIdHarmonizationErrors,
  GetFitPlayerProfilesByIdHarmonizationResponses,
  GetFitPlayerProfilesByIdMatchSimulatorData,
  GetFitPlayerProfilesByIdMatchSimulatorErrors,
  GetFitPlayerProfilesByIdMatchSimulatorResponses,
  GetFitPlayerProfilesByIdRankData,
  GetFitPlayerProfilesByIdRankResponses,
  GetFitPlayerProfilesByIdRanksWithYearData,
  GetFitPlayerProfilesByIdRanksWithYearErrors,
  GetFitPlayerProfilesByIdRanksWithYearResponses,
  GetFitPlayerProfilesByIdReducedData,
  GetFitPlayerProfilesByIdReducedErrors,
  GetFitPlayerProfilesByIdReducedResponses,
  GetFitPlayerProfilesByIdResponses,
  GetFitPlayerProfilesByIdSimulatorData,
  GetFitPlayerProfilesByIdSimulatorErrors,
  GetFitPlayerProfilesByIdSimulatorResponses,
  GetFitPlayerProfilesByIdStatsData,
  GetFitPlayerProfilesByIdStatsResponses,
  GetFitPlayerProfilesByIdStrengthsAndWeaknessesData,
  GetFitPlayerProfilesByIdStrengthsAndWeaknessesErrors,
  GetFitPlayerProfilesByIdStrengthsAndWeaknessesResponses,
  GetFitPlayerProfilesByIdUserInfoData,
  GetFitPlayerProfilesByIdUserInfoResponses,
  GetFitPlayerProfilesByIdVisitorsData,
  GetFitPlayerProfilesByIdVisitorsErrors,
  GetFitPlayerProfilesByIdVisitorsResponses,
  GetFitPlayerProfilesByIdVisitsData,
  GetFitPlayerProfilesByIdVisitsResponses,
  GetFitPlayerProfilesByIdWrappedData,
  GetFitPlayerProfilesByIdWrappedResponses,
  GetFitPlayerProfilesCardToIdByCardNumberData,
  GetFitPlayerProfilesCardToIdByCardNumberErrors,
  GetFitPlayerProfilesCardToIdByCardNumberResponses,
  GetFitPlayerProfilesFollowersListByIdData,
  GetFitPlayerProfilesFollowersListByIdResponses,
  GetFitPlayerProfilesMostVisitedData,
  GetFitPlayerProfilesMostVisitedResponses,
  GetFitPlayerProfilesSearchData,
  GetFitPlayerProfilesSearchForMergeByQData,
  GetFitPlayerProfilesSearchForMergeByQResponses,
  GetFitPlayerProfilesSearchForMergeData,
  GetFitPlayerProfilesSearchForMergeErrors,
  GetFitPlayerProfilesSearchForMergeResponses,
  GetFitPlayerProfilesSearchResponses,
  GetHomeBackofficeNumbersData,
  GetHomeBackofficeNumbersErrors,
  GetHomeBackofficeNumbersResponses,
  GetHomeData,
  GetHomeMatchesNumbersData,
  GetHomeMatchesNumbersResponses,
  GetHomeNotificationsData,
  GetHomeNotificationsResponses,
  GetHomeNumbersData,
  GetHomeNumbersResponses,
  GetHomeRateData,
  GetHomeRateResponses,
  GetHomeResponses,
  GetIntercomMessengerTokenData,
  GetIntercomMessengerTokenErrors,
  GetIntercomMessengerTokenResponses,
  GetLiveEventsBySlugData,
  GetLiveEventsBySlugErrors,
  GetLiveEventsBySlugLeaderboardData,
  GetLiveEventsBySlugLeaderboardErrors,
  GetLiveEventsBySlugLeaderboardResponses,
  GetLiveEventsBySlugResponses,
  GetLiveEventsBySlugSessionsByIdData,
  GetLiveEventsBySlugSessionsByIdErrors,
  GetLiveEventsBySlugSessionsByIdResponses,
  GetMatchesByIdData,
  GetMatchesByIdErrors,
  GetMatchesByIdResponses,
  GetMatchesData,
  GetMatchesResponses,
  GetMessagesBackofficeData,
  GetMessagesBackofficeErrors,
  GetMessagesBackofficeResponses,
  GetMessagesConversationData,
  GetMessagesConversationResponses,
  GetOfferCategoriesBackofficeData,
  GetOfferCategoriesBackofficeResponses,
  GetOfferCategoriesChildrenData,
  GetOfferCategoriesChildrenResponses,
  GetOfferCategoriesData,
  GetOfferCategoriesResponses,
  GetOffersByIdData,
  GetOffersByIdErrors,
  GetOffersByIdResponses,
  GetOffersPrivatesData,
  GetOffersPrivatesErrors,
  GetOffersPrivatesResponses,
  GetOffersShopsData,
  GetOffersShopsResponses,
  GetPositionedBannersByIdByIdData,
  GetPositionedBannersByIdByIdErrors,
  GetPositionedBannersByIdByIdResponses,
  GetPositionedBannersBySlotAllData,
  GetPositionedBannersBySlotAllErrors,
  GetPositionedBannersBySlotAllResponses,
  GetPositionedBannersBySlotData,
  GetPositionedBannersBySlotErrors,
  GetPositionedBannersBySlotResponses,
  GetPositionedBannersData,
  GetPositionedBannersResponses,
  GetPostsByIdData,
  GetPostsByIdErrors,
  GetPostsByIdResponses,
  GetPostsData,
  GetPostsErrors,
  GetPostsLastBlogData,
  GetPostsLastBlogResponses,
  GetPostsResponses,
  GetPremiumCheckoutByRefData,
  GetPremiumPaymentMethodByRefData,
  GetPremiumStatusData,
  GetPremiumStatusErrors,
  GetPremiumStatusResponses,
  GetPremiumTokensByIdData,
  GetPremiumTokensByIdErrors,
  GetPremiumTokensByIdResponses,
  GetPremiumTokensData,
  GetPremiumTokensErrors,
  GetPremiumTokensResponses,
  GetReportsByIdData,
  GetReportsByIdResponses,
  GetReportsClosedData,
  GetReportsClosedResponses,
  GetReportsData,
  GetReportsErrors,
  GetReportsPendingData,
  GetReportsPendingResponses,
  GetReportsResponses,
  GetSavedCompetitionSearchData,
  GetSavedCompetitionSearchErrors,
  GetSavedCompetitionSearchResponses,
  GetSearchData,
  GetSearchErrors,
  GetSearchResponses,
  GetShopProfilesByIdData,
  GetShopProfilesByIdErrors,
  GetShopProfilesByIdResponses,
  GetSmartWatchWorkoutsByIdData,
  GetSmartWatchWorkoutsByIdErrors,
  GetSmartWatchWorkoutsByIdResponses,
  GetSmartWatchWorkoutsData,
  GetSmartWatchWorkoutsResponses,
  GetSocialFeedData,
  GetSocialFeedResponses,
  GetTournamentsByIdData,
  GetTournamentsByIdErrors,
  GetTournamentsByIdResponses,
  GetTrainingsByIdData,
  GetTrainingsByIdResponses,
  GetTrainingSchedulesData,
  GetTrainingSchedulesResponses,
  GetTrainingsData,
  GetTrainingsResponses,
  GetTweProductBrandsData,
  GetTweProductBrandsResponses,
  GetTweProductCategoriesData,
  GetTweProductCategoriesResponses,
  GetTweProductsByIdClicksData,
  GetTweProductsByIdClicksResponses,
  GetTweProductsByIdDailyClicksData,
  GetTweProductsByIdDailyClicksErrors,
  GetTweProductsByIdDailyClicksResponses,
  GetTweProductsByIdData,
  GetTweProductsByIdErrors,
  GetTweProductsByIdResponses,
  GetTweProductsData,
  GetTweProductsFeaturedData,
  GetTweProductsFeaturedResponses,
  GetTweProductsForMeData,
  GetTweProductsForMeResponses,
  GetTweProductsMostClickedData,
  GetTweProductsMostClickedErrors,
  GetTweProductsMostClickedResponses,
  GetTweProductsResponses,
  GetUpdateTasksByIdTweProductsData,
  GetUpdateTasksByIdTweProductsResponses,
  GetUpdateTasksData,
  GetUpdateTasksResponses,
  GetUserMatchesByIdData,
  GetUserMatchesByIdErrors,
  GetUserMatchesByIdResponses,
  GetUserMatchesData,
  GetUserMatchesMineData,
  GetUserMatchesMineResponses,
  GetUserMatchesOpenData,
  GetUserMatchesOpenErrors,
  GetUserMatchesOpenResponses,
  GetUserMatchesPlayersNearbyData,
  GetUserMatchesPlayersNearbyResponses,
  GetUserMatchesResponses,
  GetUsersAdvancedSearchFiltersData,
  GetUsersAdvancedSearchFiltersErrors,
  GetUsersAdvancedSearchFiltersResponses,
  GetUsersByIdAdminDetailsData,
  GetUsersByIdAdminDetailsErrors,
  GetUsersByIdAdminDetailsResponses,
  GetUsersByIdAdminNotificationsData,
  GetUsersByIdAdminNotificationsErrors,
  GetUsersByIdAdminNotificationsResponses,
  GetUsersByIdAdminTimelineData,
  GetUsersByIdAdminTimelineErrors,
  GetUsersByIdAdminTimelineResponses,
  GetUsersByIdData,
  GetUsersByIdPostsData,
  GetUsersByIdPostsResponses,
  GetUsersByIdPreviewData,
  GetUsersByIdPreviewResponses,
  GetUsersByIdResponses,
  GetUsersByTokenFitPlayerIdData,
  GetUsersByTokenFitPlayerIdResponses,
  GetUsersCheckStatusData,
  GetUsersCheckStatusResponses,
  GetUsersConfirmAccountByTokenData,
  GetUsersConfirmAccountByTokenResponses,
  GetUsersData,
  GetUsersErrors,
  GetUsersFacebookInfoByTokenData,
  GetUsersFacebookInfoByTokenResponses,
  GetUsersFeedData,
  GetUsersFeedMatchesData,
  GetUsersFeedMatchesResponses,
  GetUsersFeedNewsData,
  GetUsersFeedNewsResponses,
  GetUsersFeedOffersData,
  GetUsersFeedOffersResponses,
  GetUsersFeedPostsData,
  GetUsersFeedPostsResponses,
  GetUsersFeedResponses,
  GetUsersFollowersListByIdData,
  GetUsersFollowersListByIdResponses,
  GetUsersMessagesCounterpartsData,
  GetUsersMessagesCounterpartsResponses,
  GetUsersNearbyData,
  GetUsersNearbyErrors,
  GetUsersNearbyResponses,
  GetUsersNotificationsData,
  GetUsersNotificationsDropdownData,
  GetUsersNotificationsDropdownResponses,
  GetUsersNotificationsResponses,
  GetUsersPreferredSurfacesData,
  GetUsersPreferredSurfacesResponses,
  GetUsersResponses,
  GetUsersSearchData,
  GetUsersSearchErrors,
  GetUsersSearchResponses,
  GetUsersTeacherQualificationsData,
  GetUsersTeacherQualificationsResponses,
  GetUsersTrainerQualificationsData,
  GetUsersTrainerQualificationsResponses,
  GetUsersUpdatesConversationsData,
  GetUsersUpdatesConversationsResponses,
  GetUsersUpdatesCountersData,
  GetUsersUpdatesCountersErrors,
  GetUsersUpdatesCountersResponses,
  GetUsersUpdatesNotificationsData,
  GetUsersUpdatesNotificationsResponses,
  GetUsersUserMatchesData,
  GetUsersUserMatchesResponses,
  PatchActivitiesByIdData,
  PatchActivitiesByIdErrors,
  PatchActivitiesByIdResponses,
  PatchAdsenseSlotsByIdData,
  PatchAdsenseSlotsByIdResponses,
  PatchCustomBannersByIdData,
  PatchCustomBannersByIdErrors,
  PatchCustomBannersByIdResponses,
  PatchOfferCategoriesByIdData,
  PatchOfferCategoriesByIdResponses,
  PatchOffersByIdData,
  PatchOffersByIdErrors,
  PatchOffersByIdResponses,
  PatchPostsByIdData,
  PatchPostsByIdErrors,
  PatchPostsByIdResponses,
  PatchPostsByPostIdCommentsByIdData,
  PatchPostsByPostIdCommentsByIdResponses,
  PatchReportsByIdData,
  PatchReportsByIdErrors,
  PatchReportsByIdResponses,
  PatchSmartWatchWorkoutsByIdData,
  PatchSmartWatchWorkoutsByIdErrors,
  PatchSmartWatchWorkoutsByIdResponses,
  PatchTrainingSchedulesByIdData,
  PatchTrainingSchedulesByIdErrors,
  PatchTrainingSchedulesByIdResponses,
  PatchUsersByIdData,
  PatchUsersByIdErrors,
  PatchUsersByIdResponses,
  PostAdminExtraMenuItemsData,
  PostAdminExtraMenuItemsErrors,
  PostAdminExtraMenuItemsResponses,
  PostAdminLiveEventsData,
  PostAdminLiveEventsErrors,
  PostAdminLiveEventsResponses,
  PostAdsenseSlotsData,
  PostAdsenseSlotsErrors,
  PostAdsenseSlotsResponses,
  PostBlocksData,
  PostBlocksErrors,
  PostBlocksResponses,
  PostBonusesData,
  PostBonusesErrors,
  PostBonusesResponses,
  PostCardinalitySaveData,
  PostCardinalitySaveErrors,
  PostCardinalitySaveResponses,
  PostClubManagerProfilesData,
  PostClubManagerProfilesResponses,
  PostClubsAdvancedSearchData,
  PostClubsAdvancedSearchResponses,
  PostCommentsByIdLikeData,
  PostCommentsByIdLikeErrors,
  PostCommentsByIdLikeResponses,
  PostCompetitionsAdvancedSearchData,
  PostCompetitionsAdvancedSearchResponses,
  PostContactsData,
  PostContactsResponses,
  PostCustomBannersData,
  PostCustomBannersErrors,
  PostCustomBannersResponses,
  PostDebugSlackData,
  PostDebugSlackErrors,
  PostDebugSlackResponses,
  PostEndorsementsData,
  PostEndorsementsResponses,
  PostFitPlayerProfilesAdvancedSearchData,
  PostFitPlayerProfilesAdvancedSearchErrors,
  PostFitPlayerProfilesAdvancedSearchResponses,
  PostFitPlayerProfilesCheckFitCardNumberData,
  PostFitPlayerProfilesCheckFitCardNumberResponses,
  PostFollowsData,
  PostFollowsResponses,
  PostHomeInlineSearchData,
  PostHomeInlineSearchPlayersData,
  PostHomeInlineSearchPlayersResponses,
  PostHomeInlineSearchResponses,
  PostHomeInvitationData,
  PostHomeInvitationResponses,
  PostHomeSendAllNotificationsData,
  PostHomeSendAllNotificationsResponses,
  PostLiveEventsBySlugSessionsByIdCancelData,
  PostLiveEventsBySlugSessionsByIdCancelErrors,
  PostLiveEventsBySlugSessionsByIdCancelResponses,
  PostLiveEventsBySlugSessionsByIdFinishData,
  PostLiveEventsBySlugSessionsByIdFinishErrors,
  PostLiveEventsBySlugSessionsByIdFinishResponses,
  PostLiveEventsBySlugSessionsByIdStartData,
  PostLiveEventsBySlugSessionsByIdStartErrors,
  PostLiveEventsBySlugSessionsByIdStartResponses,
  PostLiveEventsBySlugSessionsData,
  PostLiveEventsBySlugSessionsErrors,
  PostLiveEventsBySlugSessionsResponses,
  PostMatchesData,
  PostMatchesResponses,
  PostMessagesData,
  PostMessagesErrors,
  PostMessagesResponses,
  PostOfferCategoriesData,
  PostOfferCategoriesErrors,
  PostOfferCategoriesResponses,
  PostOffersData,
  PostOffersErrors,
  PostOffersResponses,
  PostOffersSearchData,
  PostOffersSearchResponses,
  PostPositionedBannersData,
  PostPositionedBannersErrors,
  PostPositionedBannersResponses,
  PostPostsByIdLikeData,
  PostPostsByIdLikeErrors,
  PostPostsByIdLikeResponses,
  PostPostsByPostIdCommentsData,
  PostPostsByPostIdCommentsResponses,
  PostPostsData,
  PostPostsErrors,
  PostPostsResponses,
  PostPremiumCheckoutData,
  PostPremiumCheckoutErrors,
  PostPremiumCheckoutResponses,
  PostPremiumTokensCreateTicketForNotActivatedMembershipData,
  PostPremiumTokensCreateTicketForNotActivatedMembershipResponses,
  PostPremiumTokensData,
  PostPremiumTokensErrors,
  PostPremiumTokensMembershipEmailData,
  PostPremiumTokensMembershipEmailErrors,
  PostPremiumTokensMembershipEmailResponses,
  PostPremiumTokensResponses,
  PostRechargeWebhookData,
  PostRechargeWebhookErrors,
  PostRechargeWebhookResponses,
  PostRemoveFollowData,
  PostRemoveFollowErrors,
  PostRemoveFollowResponses,
  PostReportsData,
  PostReportsResponses,
  PostSavedCompetitionSearchData,
  PostSavedCompetitionSearchErrors,
  PostSavedCompetitionSearchResponses,
  PostSearchClubsData,
  PostSearchClubsResponses,
  PostSearchCompetitionsData,
  PostSearchCompetitionsResponses,
  PostSearchFitTeachersData,
  PostSearchFitTeachersResponses,
  PostSearchOtherProfilesData,
  PostSearchOtherProfilesResponses,
  PostSearchPlayersData,
  PostSearchPlayersResponses,
  PostSessionsAppleWebAuthData,
  PostSessionsAppleWebAuthResponses,
  PostSessionsBackofficeData,
  PostSessionsBackofficeResponses,
  PostSessionsData,
  PostSessionsFacebookData,
  PostSessionsFacebookLimitedData,
  PostSessionsFacebookLimitedResponses,
  PostSessionsFacebookResponses,
  PostSessionsGoogleAuthData,
  PostSessionsGoogleAuthResponses,
  PostSessionsResponses,
  PostShopifyOrderData,
  PostShopifyOrderErrors,
  PostShopifyOrderResponses,
  PostSmartWatchWorkoutsBulkData,
  PostSmartWatchWorkoutsBulkResponses,
  PostSmartWatchWorkoutsData,
  PostSmartWatchWorkoutsErrors,
  PostSmartWatchWorkoutsResponses,
  PostTrainingsByTrainingIdTrainingSchedulesData,
  PostTrainingsByTrainingIdTrainingSchedulesErrors,
  PostTrainingsByTrainingIdTrainingSchedulesResponses,
  PostTrainingsData,
  PostTrainingsResponses,
  PostTweProductsByIdClickData,
  PostTweProductsByIdClickErrors,
  PostTweProductsByIdClickResponses,
  PostUpdateTasksByIdRerunData,
  PostUpdateTasksByIdRerunErrors,
  PostUpdateTasksByIdRerunResponses,
  PostUpdateTasksCacheFlushAllData,
  PostUpdateTasksCacheFlushAllErrors,
  PostUpdateTasksCacheFlushAllResponses,
  PostUpdateTasksCacheRefreshData,
  PostUpdateTasksCacheRefreshResponses,
  PostUpdateTasksData,
  PostUpdateTasksResponses,
  PostUpdateTasksRestartServersData,
  PostUpdateTasksRestartServersResponses,
  PostUpdateTasksRunAsyncJobData,
  PostUpdateTasksRunAsyncJobErrors,
  PostUpdateTasksRunAsyncJobResponses,
  PostUpdateTasksRunRestoreDumpData,
  PostUpdateTasksRunRestoreDumpResponses,
  PostUserMatchesByIdAcceptData,
  PostUserMatchesByIdAcceptErrors,
  PostUserMatchesByIdAcceptResponses,
  PostUserMatchesByIdCancelData,
  PostUserMatchesByIdCancelErrors,
  PostUserMatchesByIdCancelResponses,
  PostUserMatchesByIdCelebratedData,
  PostUserMatchesByIdCelebratedErrors,
  PostUserMatchesByIdCelebratedResponses,
  PostUserMatchesByIdDeclineData,
  PostUserMatchesByIdDeclineErrors,
  PostUserMatchesByIdDeclineResponses,
  PostUserMatchesByIdRequestAcceptData,
  PostUserMatchesByIdRequestAcceptErrors,
  PostUserMatchesByIdRequestAcceptResponses,
  PostUserMatchesByIdRequestData,
  PostUserMatchesByIdRequestErrors,
  PostUserMatchesByIdRequestRejectData,
  PostUserMatchesByIdRequestRejectErrors,
  PostUserMatchesByIdRequestRejectResponses,
  PostUserMatchesByIdRequestResponses,
  PostUserMatchesData,
  PostUserMatchesErrors,
  PostUserMatchesResponses,
  PostUsersAccountConfirmationEmailData,
  PostUsersAccountConfirmationEmailResponses,
  PostUsersAdvancedSearchData,
  PostUsersAdvancedSearchErrors,
  PostUsersAdvancedSearchResponses,
  PostUsersByIdPremiumizeData,
  PostUsersByIdPremiumizeResponses,
  PostUsersCheckFitClubIdData,
  PostUsersCheckFitClubIdResponses,
  PostUsersCompleteProfileData,
  PostUsersCompleteProfileErrors,
  PostUsersCompleteProfileResponses,
  PostUsersMarketData,
  PostUsersMarketResponses,
  PostUsersSignUpAdditionalInfoData,
  PostUsersSignUpAdditionalInfoErrors,
  PostUsersSignUpAdditionalInfoResponses,
  PostUsersSignUpData,
  PostUsersSignUpResponses,
  PostUsersSyncContactsData,
  PostUsersSyncContactsErrors,
  PostUsersSyncContactsResponses,
  PostUsersUserMatchesData,
  PostUsersUserMatchesResponses,
  PutAdminExtraMenuItemsByIdData,
  PutAdminExtraMenuItemsByIdErrors,
  PutAdminExtraMenuItemsByIdResponses,
  PutAdminLiveEventsByIdData,
  PutAdminLiveEventsByIdErrors,
  PutAdminLiveEventsByIdResponses,
  PutAdminLiveEventsByIdScreenData,
  PutAdminLiveEventsByIdScreenErrors,
  PutAdminLiveEventsByIdScreenResponses,
  PutAdminLiveEventsByIdSessionsBySessionIdInvalidateData,
  PutAdminLiveEventsByIdSessionsBySessionIdInvalidateErrors,
  PutAdminLiveEventsByIdSessionsBySessionIdInvalidateResponses,
  PutAdminLiveEventsByIdSessionsBySessionIdRestoreData,
  PutAdminLiveEventsByIdSessionsBySessionIdRestoreErrors,
  PutAdminLiveEventsByIdSessionsBySessionIdRestoreResponses,
  PutClubManagerProfilesByIdApproveData,
  PutClubManagerProfilesByIdApproveErrors,
  PutClubManagerProfilesByIdApproveResponses,
  PutClubManagerProfilesByIdRejectData,
  PutClubManagerProfilesByIdRejectErrors,
  PutClubManagerProfilesByIdRejectResponses,
  PutCustomBannersByIdData,
  PutCustomBannersByIdErrors,
  PutCustomBannersByIdResponses,
  PutDrawsByIdChangeBestLoserRankingData,
  PutDrawsByIdChangeBestLoserRankingErrors,
  PutDrawsByIdChangeBestLoserRankingResponses,
  PutDrawsByIdChangeWinnerData,
  PutDrawsByIdChangeWinnerErrors,
  PutDrawsByIdChangeWinnerResponses,
  PutDrawsByIdDeleteMatchesData,
  PutDrawsByIdDeleteMatchesErrors,
  PutDrawsByIdDeleteMatchesResponses,
  PutEditProfileAccountInfoData,
  PutEditProfileAccountInfoErrors,
  PutEditProfileAccountInfoResponses,
  PutEditProfileAppTokenInfoData,
  PutEditProfileAppTokenInfoErrors,
  PutEditProfileAppTokenInfoResponses,
  PutEditProfileDeleteProfileData,
  PutEditProfileDeleteProfileErrors,
  PutEditProfileDeleteProfileResponses,
  PutEditProfileGeneralInfoData,
  PutEditProfileGeneralInfoErrors,
  PutEditProfileGeneralInfoResponses,
  PutEditProfileProfilesInfoData,
  PutEditProfileProfilesInfoErrors,
  PutEditProfileProfilesInfoResponses,
  PutEditProfileRemovePlayerProfileAssociationsData,
  PutEditProfileRemovePlayerProfileAssociationsErrors,
  PutEditProfileRemovePlayerProfileAssociationsResponses,
  PutEditProfileRemovePlayerProfileData,
  PutEditProfileRemovePlayerProfileErrors,
  PutEditProfileRemovePlayerProfileResponses,
  PutFitPlayerProfileRequestsByIdApproveData,
  PutFitPlayerProfileRequestsByIdApproveErrors,
  PutFitPlayerProfileRequestsByIdApproveResponses,
  PutFitPlayerProfileRequestsByIdRejectData,
  PutFitPlayerProfileRequestsByIdRejectErrors,
  PutFitPlayerProfileRequestsByIdRejectResponses,
  PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdData,
  PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdErrors,
  PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdResponses,
  PutMatchesByIdData,
  PutMatchesByIdErrors,
  PutMatchesByIdResponses,
  PutMatchesByIdResultData,
  PutMatchesByIdResultErrors,
  PutMatchesByIdResultResponses,
  PutMessagesByIdBlockData,
  PutMessagesByIdBlockResponses,
  PutOffersByIdData,
  PutOffersByIdResponses,
  PutPositionedBannersByIdData,
  PutPositionedBannersByIdResponses,
  PutPremiumTokensByIdData,
  PutPremiumTokensByIdErrors,
  PutPremiumTokensByIdResponses,
  PutResetPasswordData,
  PutResetPasswordRequestData,
  PutResetPasswordRequestResponses,
  PutResetPasswordResponses,
  PutTrainingsByIdData,
  PutTrainingsByIdErrors,
  PutTrainingsByIdResponses,
  PutUpdateTasksByIdRunData,
  PutUpdateTasksByIdRunResponses,
  PutUpdateTasksByIdSetPendingData,
  PutUpdateTasksByIdSetPendingResponses,
  PutUserMatchesByIdConfirmData,
  PutUserMatchesByIdConfirmErrors,
  PutUserMatchesByIdConfirmResponses,
  PutUserMatchesByIdData,
  PutUserMatchesByIdErrors,
  PutUserMatchesByIdRejectData,
  PutUserMatchesByIdRejectErrors,
  PutUserMatchesByIdRejectResponses,
  PutUserMatchesByIdReminderData,
  PutUserMatchesByIdReminderErrors,
  PutUserMatchesByIdReminderResponses,
  PutUserMatchesByIdResponses,
  PutUserMatchesByIdResultData,
  PutUserMatchesByIdResultErrors,
  PutUserMatchesByIdResultResponses,
  PutUsersByIdBanData,
  PutUsersByIdBanErrors,
  PutUsersByIdBanResponses,
  PutUsersByIdMarkAsHiddenResultsData,
  PutUsersByIdMarkAsHiddenResultsErrors,
  PutUsersByIdMarkAsHiddenResultsResponses,
  PutUsersByIdMarkAsPremiumUserData,
  PutUsersByIdMarkAsPremiumUserErrors,
  PutUsersByIdMarkAsPremiumUserResponses,
  PutUsersByIdMarkAsPremiumUserWithExpirationDateData,
  PutUsersByIdMarkAsPremiumUserWithExpirationDateErrors,
  PutUsersByIdMarkAsPremiumUserWithExpirationDateResponses,
  PutUsersByIdSetPremiumExpirationDateData,
  PutUsersByIdSetPremiumExpirationDateErrors,
  PutUsersByIdSetPremiumExpirationDateResponses,
  PutUsersByIdUnbanData,
  PutUsersByIdUnbanErrors,
  PutUsersByIdUnbanResponses,
  PutUsersClearNotificationsByTypeData,
  PutUsersClearNotificationsByTypeErrors,
  PutUsersClearNotificationsByTypeResponses,
  PutUsersMarketConditionAcceptedData,
  PutUsersMarketConditionAcceptedResponses,
  PutUsersReadNotificationData,
  PutUsersReadNotificationErrors,
  PutUsersReadNotificationResponses,
  PutUsersUpdatesNotificationsByIdMuteData,
  PutUsersUpdatesNotificationsByIdMuteErrors,
  PutUsersUpdatesNotificationsByIdMuteResponses,
  PutUsersUpdatesNotificationsByIdReadData,
  PutUsersUpdatesNotificationsByIdReadErrors,
  PutUsersUpdatesNotificationsByIdReadResponses,
  PutUsersUpdatesNotificationsByIdRestoreData,
  PutUsersUpdatesNotificationsByIdRestoreErrors,
  PutUsersUpdatesNotificationsByIdRestoreResponses,
  PutUsersUpdatesNotificationsByIdUnreadData,
  PutUsersUpdatesNotificationsByIdUnreadErrors,
  PutUsersUpdatesNotificationsByIdUnreadResponses,
  PutUsersUpdatesNotificationsReadAllData,
  PutUsersUpdatesNotificationsReadAllResponses,
  PutUsersUpdatesNotificationsReadByDestinationData,
  PutUsersUpdatesNotificationsReadByDestinationResponses,
  PutUsersUpdatesNotificationsSeenData,
  PutUsersUpdatesNotificationsSeenResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta
}

/**
 * get activities list
 *
 * Paginated activity feed backing an Activity/Match/Training/UserMatch stream. Every
 * Match, UserMatch, Training and SmartWatchWorkout the caller is entitled to see shows
 * up here as one Activity, newest first (20 per page).
 * Trainings dated after today (recurring lessons are generated 14 days ahead) are left out
 * of the list and of the counts; `GET /activities/{id}` and the streak calendar still return them.
 *
 * With no filter, returns the current user's own activities (including their own
 * hidden/`visible: false` ones). `user_id`/`player_id` switch the feed to another
 * user or FIT player profile: only their *public* activities are returned unless that
 * target happens to be the caller themselves. `type` narrows to a single activatable
 * kind.
 *
 */
export const getActivities = <ThrowOnError extends boolean = false>(
  options: Options<GetActivitiesData, ThrowOnError>
): RequestResult<GetActivitiesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetActivitiesResponses, unknown, ThrowOnError>(
    {
      security: [{ name: 'X-Api-Key', type: 'apiKey' }],
      url: '/activities',
      ...options,
    }
  )

/**
 * delete activity
 *
 * Deletes one of the caller's own activities. This only removes the Activity feed entry, not the underlying Match/Training/UserMatch record.
 */
export const deleteActivitiesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteActivitiesByIdData, ThrowOnError>
): RequestResult<DeleteActivitiesByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteActivitiesByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/activities/{id}',
    ...options,
  })

/**
 * get activity by id
 *
 * Returns any activity by id. Visible to anyone if `visible: true`; otherwise only to the activity's own owner.
 */
export const getActivitiesById = <ThrowOnError extends boolean = false>(
  options: Options<GetActivitiesByIdData, ThrowOnError>
): RequestResult<
  GetActivitiesByIdResponses,
  GetActivitiesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetActivitiesByIdResponses,
    GetActivitiesByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/activities/{id}',
    ...options,
  })

/**
 * update note and visible on own activity
 *
 * Updates the personal note and/or visibility of one of the caller's own activities. Only the owner can update it — an activity belonging to someone else (or a non-existent id) returns 404.
 */
export const patchActivitiesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchActivitiesByIdData, ThrowOnError>
): RequestResult<
  PatchActivitiesByIdResponses,
  PatchActivitiesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchActivitiesByIdResponses,
    PatchActivitiesByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/activities/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * get current user activity streak
 *
 * Computes the caller's activity streak (consecutive weeks with at least one activity),
 * plus totals for this week/month/all-time and a per-day breakdown of activity types
 * for `from`..`to` (default: the trailing 365 days). The streak/total counters always
 * cover *all* of the caller's history regardless of `from`/`to` — those two params only
 * bound the `days` breakdown. The requested range can span at most 365 days.
 *
 */
export const getActivitiesStreak = <ThrowOnError extends boolean = false>(
  options: Options<GetActivitiesStreakData, ThrowOnError>
): RequestResult<
  GetActivitiesStreakResponses,
  GetActivitiesStreakErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetActivitiesStreakResponses,
    GetActivitiesStreakErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/activities/streak',
    ...options,
  })

/**
 * List live events
 *
 * All live events (also inactive), newest first, 20 per page. Admin roles only.
 */
export const getAdminLiveEvents = <ThrowOnError extends boolean = false>(
  options?: Options<GetAdminLiveEventsData, ThrowOnError>
): RequestResult<
  GetAdminLiveEventsResponses,
  GetAdminLiveEventsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAdminLiveEventsResponses,
    GetAdminLiveEventsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events',
    ...options,
  })

/**
 * Create a live event
 *
 * Creates an event. `game_config` and `theme` store only overrides of the TennisTalker defaults (a branded event changes at most the logo and three colours); the logo is a base64 data URI.
 */
export const postAdminLiveEvents = <ThrowOnError extends boolean = false>(
  options?: Options<PostAdminLiveEventsData, ThrowOnError>
): RequestResult<
  PostAdminLiveEventsResponses,
  PostAdminLiveEventsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostAdminLiveEventsResponses,
    PostAdminLiveEventsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Delete a live event
 *
 * Soft-deletes the event (and its games).
 */
export const deleteAdminLiveEventsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdminLiveEventsByIdData, ThrowOnError>
): RequestResult<
  DeleteAdminLiveEventsByIdResponses,
  DeleteAdminLiveEventsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAdminLiveEventsByIdResponses,
    DeleteAdminLiveEventsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events/{id}',
    ...options,
  })

/**
 * Get a live event
 *
 * One event with secrets (`live_key`) and raw settings.
 */
export const getAdminLiveEventsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdminLiveEventsByIdData, ThrowOnError>
): RequestResult<
  GetAdminLiveEventsByIdResponses,
  GetAdminLiveEventsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAdminLiveEventsByIdResponses,
    GetAdminLiveEventsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events/{id}',
    ...options,
  })

/**
 * Update a live event
 *
 * Partial update: only the given keys change. `game_config` and `theme` are replaced as a whole when given.
 */
export const putAdminLiveEventsById = <ThrowOnError extends boolean = false>(
  options: Options<PutAdminLiveEventsByIdData, ThrowOnError>
): RequestResult<
  PutAdminLiveEventsByIdResponses,
  PutAdminLiveEventsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutAdminLiveEventsByIdResponses,
    PutAdminLiveEventsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Turn the big screen on or off
 *
 * On: live games go through the queue and the first one is mirrored on the screen. Off: everybody in the queue can play immediately, off screen.
 */
export const putAdminLiveEventsByIdScreen = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutAdminLiveEventsByIdScreenData, ThrowOnError>
): RequestResult<
  PutAdminLiveEventsByIdScreenResponses,
  PutAdminLiveEventsByIdScreenErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutAdminLiveEventsByIdScreenResponses,
    PutAdminLiveEventsByIdScreenErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events/{id}/screen',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get the big screen queue
 *
 * Who holds the big screen and the first 10 players waiting. Also advances the queue. Live updates are pushed on the websocket `LiveEventScreenChannel`.
 */
export const getAdminLiveEventsByIdQueue = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLiveEventsByIdQueueData, ThrowOnError>
): RequestResult<
  GetAdminLiveEventsByIdQueueResponses,
  GetAdminLiveEventsByIdQueueErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAdminLiveEventsByIdQueueResponses,
    GetAdminLiveEventsByIdQueueErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events/{id}/queue',
    ...options,
  })

/**
 * List game sessions
 *
 * All games of the event, newest first, 50 per page, with moderation filters.
 */
export const getAdminLiveEventsByIdSessions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLiveEventsByIdSessionsData, ThrowOnError>
): RequestResult<
  GetAdminLiveEventsByIdSessionsResponses,
  GetAdminLiveEventsByIdSessionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAdminLiveEventsByIdSessionsResponses,
    GetAdminLiveEventsByIdSessionsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events/{id}/sessions',
    ...options,
  })

/**
 * Invalidate a game
 *
 * Excludes the game from leaderboards (reversible with restore). An active game is also cancelled, removing the player from the queue.
 */
export const putAdminLiveEventsByIdSessionsBySessionIdInvalidate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutAdminLiveEventsByIdSessionsBySessionIdInvalidateData,
    ThrowOnError
  >
): RequestResult<
  PutAdminLiveEventsByIdSessionsBySessionIdInvalidateResponses,
  PutAdminLiveEventsByIdSessionsBySessionIdInvalidateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutAdminLiveEventsByIdSessionsBySessionIdInvalidateResponses,
    PutAdminLiveEventsByIdSessionsBySessionIdInvalidateErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events/{id}/sessions/{session_id}/invalidate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Restore a game
 *
 * Undoes an invalidation and/or a deletion: the game counts again.
 */
export const putAdminLiveEventsByIdSessionsBySessionIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutAdminLiveEventsByIdSessionsBySessionIdRestoreData,
    ThrowOnError
  >
): RequestResult<
  PutAdminLiveEventsByIdSessionsBySessionIdRestoreResponses,
  PutAdminLiveEventsByIdSessionsBySessionIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutAdminLiveEventsByIdSessionsBySessionIdRestoreResponses,
    PutAdminLiveEventsByIdSessionsBySessionIdRestoreErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events/{id}/sessions/{session_id}/restore',
    ...options,
  })

/**
 * Delete a game or remove a player from the queue
 *
 * Soft-deletes the game (restorable). An active game is cancelled first, so this is also how an admin removes someone from the queue.
 */
export const deleteAdminLiveEventsByIdSessionsBySessionId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAdminLiveEventsByIdSessionsBySessionIdData,
    ThrowOnError
  >
): RequestResult<
  DeleteAdminLiveEventsByIdSessionsBySessionIdResponses,
  DeleteAdminLiveEventsByIdSessionsBySessionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAdminLiveEventsByIdSessionsBySessionIdResponses,
    DeleteAdminLiveEventsByIdSessionsBySessionIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events/{id}/sessions/{session_id}',
    ...options,
  })

/**
 * Get the full leaderboard
 *
 * Same ranking as the public leaderboard, up to 200 rows by default; `me` is always null.
 */
export const getAdminLiveEventsByIdLeaderboard = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAdminLiveEventsByIdLeaderboardData, ThrowOnError>
): RequestResult<
  GetAdminLiveEventsByIdLeaderboardResponses,
  GetAdminLiveEventsByIdLeaderboardErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAdminLiveEventsByIdLeaderboardResponses,
    GetAdminLiveEventsByIdLeaderboardErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/live-events/{id}/leaderboard',
    ...options,
  })

/**
 * Lista tutti gli adsense slots
 *
 * Lista completa (non paginata) di tutti gli AdsenseSlot configurati, piu' recenti
 * prima. Nota: nonostante l'`X-Api-Key` sia documentato come required qui, il
 * controller non ha alcun controllo di autenticazione o autorizzazione — l'header
 * non viene verificato lato server.
 *
 */
export const getAdsenseSlotsAll = <ThrowOnError extends boolean = false>(
  options: Options<GetAdsenseSlotsAllData, ThrowOnError>
): RequestResult<GetAdsenseSlotsAllResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetAdsenseSlotsAllResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/adsense_slots/all',
    ...options,
  })

/**
 * Lista paginata degli adsense slots
 *
 * Lista paginata degli AdsenseSlot (configurazione slot pubblicitari mostrati in
 * app), 20 per pagina. Nessun controllo di autenticazione a livello di controller.
 *
 */
export const getAdsenseSlots = <ThrowOnError extends boolean = false>(
  options: Options<GetAdsenseSlotsData, ThrowOnError>
): RequestResult<GetAdsenseSlotsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetAdsenseSlotsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/adsense_slots',
    ...options,
  })

/**
 * Crea un nuovo adsense slot
 *
 * Crea un AdsenseSlot. Riservato a admin/banner_manager/censor_manager.
 *
 */
export const postAdsenseSlots = <ThrowOnError extends boolean = false>(
  options: Options<PostAdsenseSlotsData, ThrowOnError>
): RequestResult<
  PostAdsenseSlotsResponses,
  PostAdsenseSlotsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostAdsenseSlotsResponses,
    PostAdsenseSlotsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/adsense_slots',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Elimina un adsense slot
 *
 * Elimina definitivamente un AdsenseSlot. Nessun controllo di autenticazione o
 * autorizzazione a livello di controller.
 *
 */
export const deleteAdsenseSlotsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAdsenseSlotsByIdData, ThrowOnError>
): RequestResult<
  DeleteAdsenseSlotsByIdResponses,
  DeleteAdsenseSlotsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAdsenseSlotsByIdResponses,
    DeleteAdsenseSlotsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/adsense_slots/{id}',
    ...options,
  })

/**
 * Mostra un adsense slot
 *
 * Dettaglio di un singolo AdsenseSlot. Nessun controllo di autenticazione a livello
 * di controller.
 *
 */
export const getAdsenseSlotsById = <ThrowOnError extends boolean = false>(
  options: Options<GetAdsenseSlotsByIdData, ThrowOnError>
): RequestResult<
  GetAdsenseSlotsByIdResponses,
  GetAdsenseSlotsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetAdsenseSlotsByIdResponses,
    GetAdsenseSlotsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/adsense_slots/{id}',
    ...options,
  })

/**
 * Aggiorna un adsense slot
 *
 * Aggiorna un AdsenseSlot esistente (`find` per ID, quindi `404` se non esiste).
 * Riservato a admin/banner_manager/censor_manager.
 *
 */
export const patchAdsenseSlotsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchAdsenseSlotsByIdData, ThrowOnError>
): RequestResult<PatchAdsenseSlotsByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    PatchAdsenseSlotsByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/adsense_slots/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Logs out a user
 *
 * Destroys a session by its token, logging the associated user out. Requires the caller's own X-Api-Key, and only the caller's own sessions are destroyed: the token of another user's session is ignored.
 */
export const deleteSessionsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSessionsByIdData, ThrowOnError>
): RequestResult<DeleteSessionsByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteSessionsByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/sessions/{id}',
    ...options,
  })

/**
 * Logs in a user with Facebook
 *
 * Signs in (or signs up) via Facebook's standard OAuth token. `token` is verified
 * server-side against the Graph API: it must be issued to one of the TennisTalker Facebook
 * apps, and the user is the one Facebook returns (id and email). `uid` and `email` are
 * only accepted when they match it; a Facebook account without an email can't log in.
 * On success a new Session is created for the matching (or newly created) User and
 * returned. No X-Api-Key needed.
 *
 */
export const postSessionsFacebook = <ThrowOnError extends boolean = false>(
  options?: Options<PostSessionsFacebookData, ThrowOnError>
): RequestResult<PostSessionsFacebookResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSessionsFacebookResponses,
    unknown,
    ThrowOnError
  >({
    url: '/sessions/facebook',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Logs in a user with Facebook with JWT instead of old normal token
 *
 * Signs in via Facebook Limited Login (iOS), which returns a signed JWT instead of a
 * classic access token. `token` is the JWT: its signature is verified against Facebook's
 * published JWKS, and its issuer, audience (one of the TennisTalker Facebook apps) and
 * expiry are checked before its subject id and email are used. No X-Api-Key needed.
 *
 */
export const postSessionsFacebookLimited = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostSessionsFacebookLimitedData, ThrowOnError>
): RequestResult<PostSessionsFacebookLimitedResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSessionsFacebookLimitedResponses,
    unknown,
    ThrowOnError
  >({
    url: '/sessions/facebook_limited',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Logs in a user with Apple (web)
 *
 * A token not signed by one of the keys in Apple's JWKS (e.g. forged by an attacker) is rejected rather than trusted, proving the signature is actually verified.
 */
export const postSessionsAppleWebAuth = <ThrowOnError extends boolean = false>(
  options?: Options<PostSessionsAppleWebAuthData, ThrowOnError>
): RequestResult<PostSessionsAppleWebAuthResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSessionsAppleWebAuthResponses,
    unknown,
    ThrowOnError
  >({
    url: '/sessions/apple-web-auth',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Logs in a backoffice user
 *
 * Email/password login restricted to staff accounts (role admin, banner_manager or
 * censor_manager) — a regular user's credentials are always rejected here even if
 * correct. The account must also be confirmed. No X-Api-Key needed.
 *
 */
export const postSessionsBackoffice = <ThrowOnError extends boolean = false>(
  options?: Options<PostSessionsBackofficeData, ThrowOnError>
): RequestResult<PostSessionsBackofficeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSessionsBackofficeResponses,
    unknown,
    ThrowOnError
  >({
    url: '/sessions/backoffice',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Tests login check
 *
 * Diagnostic endpoint to verify that an X-Api-Key resolves to a logged-in user; returns that user's id. Not part of the app's product surface.
 */
export const getFakeRouteToTestLoginCheck = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetFakeRouteToTestLoginCheckData, ThrowOnError>
): RequestResult<
  GetFakeRouteToTestLoginCheckResponses,
  GetFakeRouteToTestLoginCheckErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetFakeRouteToTestLoginCheckResponses,
    GetFakeRouteToTestLoginCheckErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fake-route-to-test-login-check',
    ...options,
  })

/**
 * Block another user
 */
export const postBlocks = <ThrowOnError extends boolean = false>(
  options?: Options<PostBlocksData, ThrowOnError>
): RequestResult<PostBlocksResponses, PostBlocksErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    PostBlocksResponses,
    PostBlocksErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/blocks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Remove a block (id is the blocked USER id)
 */
export const deleteBlocksById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteBlocksByIdData, ThrowOnError>
): RequestResult<DeleteBlocksByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteBlocksByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/blocks/{id}',
    ...options,
  })

/**
 * List club manager profile requests
 *
 * Paginated list of club manager profile requests (a user asking to become the
 * manager of a club), most recent first. Restricted to admin/banner_manager/censor_manager
 * roles (backoffice); other users get 401.
 *
 */
export const getClubManagerProfiles = <ThrowOnError extends boolean = false>(
  options: Options<GetClubManagerProfilesData, ThrowOnError>
): RequestResult<
  GetClubManagerProfilesResponses,
  GetClubManagerProfilesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetClubManagerProfilesResponses,
    GetClubManagerProfilesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/club-manager-profiles',
    ...options,
  })

/**
 * Create a club manager profile request
 *
 * Files a request for the current user to become the manager of the given club.
 * Stays pending until an admin/banner_manager/censor_manager calls the approve or
 * reject endpoint below. Validation errors (e.g. missing/invalid club) come back as
 * `200` with `success: false`, not `422` — check `success` in the body.
 *
 */
export const postClubManagerProfiles = <ThrowOnError extends boolean = false>(
  options: Options<PostClubManagerProfilesData, ThrowOnError>
): RequestResult<PostClubManagerProfilesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    PostClubManagerProfilesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/club-manager-profiles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Approve a club manager profile request
 *
 * Approves a pending club manager profile request, making the requesting user the
 * manager of that club. Restricted to admin/banner_manager/censor_manager roles
 * (CanCan `load_and_authorize_resource`); any other caller gets `401`.
 *
 */
export const putClubManagerProfilesByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutClubManagerProfilesByIdApproveData, ThrowOnError>
): RequestResult<
  PutClubManagerProfilesByIdApproveResponses,
  PutClubManagerProfilesByIdApproveErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutClubManagerProfilesByIdApproveResponses,
    PutClubManagerProfilesByIdApproveErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/club-manager-profiles/{id}/approve',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Reject a club manager profile request
 *
 * Rejects a pending club manager profile request. Restricted to
 * admin/banner_manager/censor_manager roles (CanCan `load_and_authorize_resource`);
 * any other caller gets `401`.
 *
 */
export const putClubManagerProfilesByIdReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutClubManagerProfilesByIdRejectData, ThrowOnError>
): RequestResult<
  PutClubManagerProfilesByIdRejectResponses,
  PutClubManagerProfilesByIdRejectErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutClubManagerProfilesByIdRejectResponses,
    PutClubManagerProfilesByIdRejectErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/club-manager-profiles/{id}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Advanced search for clubs with filters
 *
 * Paginated club search combining free-text (`q`, matched against club name),
 * geography (`region`/`province`, or `lat`/`lng`/`radius` for a PostGIS nearby
 * filter), and school typology. Results and counts are cached per unique filter
 * combination. If the caller is authenticated and passes `lat`/`lng`, their own
 * address is updated with that location as a side effect. Public endpoint, but
 * an `X-Api-Key` header (not modeled as a parameter here) is honored if present.
 *
 */
export const postClubsAdvancedSearch = <ThrowOnError extends boolean = false>(
  options?: Options<PostClubsAdvancedSearchData, ThrowOnError>
): RequestResult<PostClubsAdvancedSearchResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostClubsAdvancedSearchResponses,
    unknown,
    ThrowOnError
  >({
    url: '/clubs/advanced-search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * get active clubs near a point
 *
 * Returns the 20 closest active clubs to a point, using a PostGIS distance query.
 * Simpler and faster than /clubs/advanced-search's geo filter, and doesn't require
 * authentication. Distances are computed server-side; the response's `search_point`
 * just echoes back the coordinates that were searched.
 *
 */
export const getClubsNearby = <ThrowOnError extends boolean = false>(
  options: Options<GetClubsNearbyData, ThrowOnError>
): RequestResult<GetClubsNearbyResponses, GetClubsNearbyErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetClubsNearbyResponses,
    GetClubsNearbyErrors,
    ThrowOnError
  >({ url: '/clubs/nearby', ...options })

/**
 * get club by id
 *
 * Full club profile: members, teachers, active competitions, a 5-item activity feed,
 * and its draws. `X-Api-Key` is optional — if present, `followed`/`managed` reflect
 * the caller's relationship to the club; if absent they default to false.
 *
 */
export const getClubsById = <ThrowOnError extends boolean = false>(
  options: Options<GetClubsByIdData, ThrowOnError>
): RequestResult<GetClubsByIdResponses, GetClubsByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetClubsByIdResponses,
    GetClubsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/clubs/{id}',
    ...options,
  })

/**
 * get club feed
 *
 * Paginated activity feed for the club (posts/activities from its members).
 * `X-Api-Key` is optional.
 *
 */
export const getClubsByIdFeed = <ThrowOnError extends boolean = false>(
  options: Options<GetClubsByIdFeedData, ThrowOnError>
): RequestResult<
  GetClubsByIdFeedResponses,
  GetClubsByIdFeedErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetClubsByIdFeedResponses,
    GetClubsByIdFeedErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/clubs/{id}/feed',
    ...options,
  })

/**
 * get club id by fit club id
 *
 * Resolves a club's internal `id` from its FIT (Federazione Italiana Tennis) club id,
 * used when integrating with FIT data feeds that only carry the FIT identifier.
 *
 */
export const getClubsIdByFitClubIdByFitClubId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetClubsIdByFitClubIdByFitClubIdData, ThrowOnError>
): RequestResult<
  GetClubsIdByFitClubIdByFitClubIdResponses,
  GetClubsIdByFitClubIdByFitClubIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetClubsIdByFitClubIdByFitClubIdResponses,
    GetClubsIdByFitClubIdByFitClubIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/clubs/id-by-fit-club-id/{fit_club_id}',
    ...options,
  })

/**
 * Likes a comment
 *
 * Records a like from the caller on the given comment and returns the updated comment.
 */
export const postCommentsByIdLike = <ThrowOnError extends boolean = false>(
  options: Options<PostCommentsByIdLikeData, ThrowOnError>
): RequestResult<
  PostCommentsByIdLikeResponses,
  PostCommentsByIdLikeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostCommentsByIdLikeResponses,
    PostCommentsByIdLikeErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/comments/{id}/like',
    ...options,
  })

/**
 * Unlikes a comment
 *
 * Removes the caller's like from the given comment and returns the updated comment.
 */
export const deleteCommentsByIdUnlike = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCommentsByIdUnlikeData, ThrowOnError>
): RequestResult<
  DeleteCommentsByIdUnlikeResponses,
  DeleteCommentsByIdUnlikeErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteCommentsByIdUnlikeResponses,
    DeleteCommentsByIdUnlikeErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/comments/{id}/unlike',
    ...options,
  })

/**
 * Get competition details
 *
 * A competition is the overall club event (e.g. "Rome Open"); it groups one or
 * more tournaments, each a single gender/category/surface bracket (e.g. "Men
 * Singles", clay, category 1) with its own draw(s) — see GET /tournaments/{id}.
 * Returns the competition plus its tournaments (see Schemas::CompetitionResponse).
 * Public endpoint; `X-Api-Key` is optional and only affects follow/visitor-style
 * personalization, if any.
 *
 */
export const getCompetitionsById = <ThrowOnError extends boolean = false>(
  options: Options<GetCompetitionsByIdData, ThrowOnError>
): RequestResult<
  GetCompetitionsByIdResponses,
  GetCompetitionsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetCompetitionsByIdResponses,
    GetCompetitionsByIdErrors,
    ThrowOnError
  >({ url: '/competitions/{id}', ...options })

/**
 * Search competitions by query
 *
 * Lightweight text search over competition names, for the top-level search bar/tab.
 * Renders a smaller shape (SearchCompetition) than /competitions/advanced-search —
 * no filters, no pagination metadata, just a flat array of matches. An empty or
 * missing `query` returns an empty array rather than all competitions.
 *
 */
export const getCompetitionsSearch = <ThrowOnError extends boolean = false>(
  options?: Options<GetCompetitionsSearchData, ThrowOnError>
): RequestResult<GetCompetitionsSearchResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetCompetitionsSearchResponses,
    unknown,
    ThrowOnError
  >({ url: '/competitions/search', ...options })

/**
 * Advanced search for competitions with filters
 *
 * Paginated, multi-filter competition search — the backend for the app's search
 * screen filter panel. Combines text query, geography (region/province, or
 * lat/lng/radius for a nearby search), tournament attributes (gender, surface,
 * rankings/age category) and a computed `status` (completed/running/scheduled,
 * derived from the competition's date range). When only `gender` or only
 * `region`+`status` are passed, results are `CompetitionSearch` items; the
 * unfiltered/query-only case returns a slightly different inline shape (see the
 * response examples below) — both represent the same underlying competition.
 *
 */
export const postCompetitionsAdvancedSearch = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostCompetitionsAdvancedSearchData, ThrowOnError>
): RequestResult<
  PostCompetitionsAdvancedSearchResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostCompetitionsAdvancedSearchResponses,
    unknown,
    ThrowOnError
  >({
    url: '/competitions/advanced-search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Daily report history of a source (admin only)
 *
 * Day-by-day KPIs recorded every night by DailyReportJob (data of two days before) for
 * one source, read from the database: the same data and aggregation rules as the MCP
 * `daily_report` tool. With a `week`/`month`/`year` granularity, and in `summary`,
 * each metric is combined by its `aggregation` (`sum`, `last`, `avg`). `from`/`to`
 * take precedence over `preset` (default `last_30_days`). Daily rows: max 400 days.
 * Admin only.
 *
 */
export const getDailyReports = <ThrowOnError extends boolean = false>(
  options: Options<GetDailyReportsData, ThrowOnError>
): RequestResult<
  GetDailyReportsResponses,
  GetDailyReportsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetDailyReportsResponses,
    GetDailyReportsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/daily-reports',
    ...options,
  })

/**
 * Daily report history of every source (admin only)
 *
 * The same as `GET /daily-reports` for every source at once, over the same period:
 * the backoffice dashboard overview in one call. Same period parameters and rules.
 * Admin only.
 *
 */
export const getDailyReportsOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetDailyReportsOverviewData, ThrowOnError>
): RequestResult<
  GetDailyReportsOverviewResponses,
  GetDailyReportsOverviewErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetDailyReportsOverviewResponses,
    GetDailyReportsOverviewErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/daily-reports/overview',
    ...options,
  })

/**
 * Premium renewals expected in the coming days (admin only)
 *
 * Charges queued on Recharge in the period (live from the Recharge API) matched by email
 * with the app users whose premium expires in the period: the same data as the MCP
 * `upcoming_renewals` tool. Default: today and the next 7 days, max
 * 92 days. Admin only.
 *
 */
export const getDailyReportsUpcomingRenewals = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetDailyReportsUpcomingRenewalsData, ThrowOnError>
): RequestResult<
  GetDailyReportsUpcomingRenewalsResponses,
  GetDailyReportsUpcomingRenewalsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetDailyReportsUpcomingRenewalsResponses,
    GetDailyReportsUpcomingRenewalsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/daily-reports/upcoming-renewals',
    ...options,
  })

/**
 * Daily report sources and metrics catalog (admin only)
 *
 * Every daily report source with its metrics: key, Italian label, unit and
 * aggregation rule. Admin only.
 *
 */
export const getDailyReportsSources = <ThrowOnError extends boolean = false>(
  options?: Options<GetDailyReportsSourcesData, ThrowOnError>
): RequestResult<
  GetDailyReportsSourcesResponses,
  GetDailyReportsSourcesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetDailyReportsSourcesResponses,
    GetDailyReportsSourcesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/daily-reports/sources',
    ...options,
  })

/**
 * Delete draw and all its matches
 *
 * Permanently deletes the draw and every match in it. Admin-only (`authorize! :manage`).
 *
 */
export const deleteDrawsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDrawsByIdData, ThrowOnError>
): RequestResult<
  DeleteDrawsByIdResponses,
  DeleteDrawsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteDrawsByIdResponses,
    DeleteDrawsByIdErrors,
    ThrowOnError
  >({ url: '/draws/{id}', ...options })

/**
 * Get draw details
 *
 * A draw is one elimination bracket within a Tournament (e.g. the main draw, or a
 * qualifying draw) — its `matches` are the individual games that make up the
 * bracket. Includes bracket metadata (`entries_count`, `round_count`,
 * `best_loser_ranking` — the ranking assigned to a "lucky loser" reinstated after
 * an early exit), the current `winner` if decided, and the parent tournament/
 * competition. Public endpoint; `X-Api-Key` is optional.
 *
 */
export const getDrawsById = <ThrowOnError extends boolean = false>(
  options: Options<GetDrawsByIdData, ThrowOnError>
): RequestResult<GetDrawsByIdResponses, GetDrawsByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetDrawsByIdResponses,
    GetDrawsByIdErrors,
    ThrowOnError
  >({ url: '/draws/{id}', ...options })

/**
 * Delete all matches in a draw
 *
 * Deletes every match in the draw but keeps the draw itself (unlike DELETE
 * /draws/{id}, which removes both) — used to reset a bracket without losing its
 * metadata. Admin-only (`authorize! :manage`).
 *
 */
export const putDrawsByIdDeleteMatches = <ThrowOnError extends boolean = false>(
  options: Options<PutDrawsByIdDeleteMatchesData, ThrowOnError>
): RequestResult<
  PutDrawsByIdDeleteMatchesResponses,
  PutDrawsByIdDeleteMatchesErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutDrawsByIdDeleteMatchesResponses,
    PutDrawsByIdDeleteMatchesErrors,
    ThrowOnError
  >({ url: '/draws/{id}/delete-matches', ...options })

/**
 * Change the winner of a draw
 *
 * Manually sets (or, with a blank `winner_id`, clears) the draw's winner — a manual
 * correction tool for cases the automatic match-result pipeline got wrong. Also
 * busts any cached data keyed by the affected player id(s). Admin-only
 * (`authorize! :manage`).
 *
 */
export const putDrawsByIdChangeWinner = <ThrowOnError extends boolean = false>(
  options: Options<PutDrawsByIdChangeWinnerData, ThrowOnError>
): RequestResult<
  PutDrawsByIdChangeWinnerResponses,
  PutDrawsByIdChangeWinnerErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutDrawsByIdChangeWinnerResponses,
    PutDrawsByIdChangeWinnerErrors,
    ThrowOnError
  >({
    url: '/draws/{id}/change-winner',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Change the best loser ranking of a draw
 *
 * Manually sets the draw's "best loser" ranking — the ranking value assigned to a
 * player reinstated into the draw despite an early loss, used to reseed/reorder
 * the bracket. Admin-only (`authorize! :manage`).
 *
 */
export const putDrawsByIdChangeBestLoserRanking = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutDrawsByIdChangeBestLoserRankingData, ThrowOnError>
): RequestResult<
  PutDrawsByIdChangeBestLoserRankingResponses,
  PutDrawsByIdChangeBestLoserRankingErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutDrawsByIdChangeBestLoserRankingResponses,
    PutDrawsByIdChangeBestLoserRankingErrors,
    ThrowOnError
  >({
    url: '/draws/{id}/change-best-loser-ranking',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * get user profiles
 *
 * Returns the current user's attached role-specific profiles (fit player, teacher, trainer, nutritionist, mental coach, shop, club manager) — each null if the user hasn't set one up.
 */
export const getEditProfileProfiles = <ThrowOnError extends boolean = false>(
  options: Options<GetEditProfileProfilesData, ThrowOnError>
): RequestResult<
  GetEditProfileProfilesResponses,
  GetEditProfileProfilesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetEditProfileProfilesResponses,
    GetEditProfileProfilesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/profiles',
    ...options,
  })

/**
 * update general info
 *
 * Updates the current user's basic profile fields (name, bio, photo, address, preferred surface, ...). As a side effect, destroys every other active session for this user, so other logged-in devices are signed out.
 */
export const putEditProfileGeneralInfo = <ThrowOnError extends boolean = false>(
  options: Options<PutEditProfileGeneralInfoData, ThrowOnError>
): RequestResult<
  PutEditProfileGeneralInfoResponses,
  PutEditProfileGeneralInfoErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutEditProfileGeneralInfoResponses,
    PutEditProfileGeneralInfoErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/general-info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * update account info
 *
 * Updates account-level settings for the current user: email/password and notification
 * preferences. Accepts notification prefs either as the legacy flat boolean fields
 * (`notifications_for_posts`, `notifications_for_comments`) or as the newer
 * `notification_settings` object — sending one keeps the other in sync, since both are
 * still read by different parts of the app during the migration between the two.
 * `notification_settings.magazine_newsletter_opt_in` is the magazine newsletter consent;
 * the old `email` and `magazine_newsletter` keys are ignored.
 *
 */
export const putEditProfileAccountInfo = <ThrowOnError extends boolean = false>(
  options: Options<PutEditProfileAccountInfoData, ThrowOnError>
): RequestResult<
  PutEditProfileAccountInfoResponses,
  PutEditProfileAccountInfoErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutEditProfileAccountInfoResponses,
    PutEditProfileAccountInfoErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/account-info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * update profiles info
 *
 * Same-controller sibling of POST /users/complete-profile, for editing existing role-specific profiles after onboarding rather than creating them for the first time. Only the sub-objects present in the payload are saved; omit a profile to leave it untouched. A FIT card is only linked to a user with a real first name, last name and birth date: otherwise the whole request is refused with 422 and nothing is saved.
 */
export const putEditProfileProfilesInfo = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutEditProfileProfilesInfoData, ThrowOnError>
): RequestResult<
  PutEditProfileProfilesInfoResponses,
  PutEditProfileProfilesInfoErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutEditProfileProfilesInfoResponses,
    PutEditProfileProfilesInfoErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/profiles-info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * update app token info
 *
 * Registers (or transfers) a push-notification device token for the current user.
 * If the token already belongs to another user it's reassigned to the caller, unless it
 * was already registered to the caller under a different record, in which case the call
 * is a no-op success.
 *
 */
export const putEditProfileAppTokenInfo = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutEditProfileAppTokenInfoData, ThrowOnError>
): RequestResult<
  PutEditProfileAppTokenInfoResponses,
  PutEditProfileAppTokenInfoErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutEditProfileAppTokenInfoResponses,
    PutEditProfileAppTokenInfoErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/app-token-info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * delete profile
 *
 * Permanently deletes one of the current user's secondary (role-specific) profiles —
 * NOT the fit player profile, which has its own dedicated
 * `PUT /remove-player-profile`. Reassigns or removes the profile's messages, comments,
 * posts, follows and offers before destroying it, then returns the updated user.
 *
 * `amateur_profile` deletes the self-assessment («Non gioco più a tennis»): the user becomes
 * `fan` unless they have other profiles. Refused with 422 while a FIT card is linked, because
 * a card holder already plays: they leave official tournaments first.
 *
 */
export const putEditProfileDeleteProfile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutEditProfileDeleteProfileData, ThrowOnError>
): RequestResult<
  PutEditProfileDeleteProfileResponses,
  PutEditProfileDeleteProfileErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutEditProfileDeleteProfileResponses,
    PutEditProfileDeleteProfileErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/delete-profile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * remove player profile
 *
 * Unlinks the fit player profile from the CURRENT user (the FitPlayerProfile record
 * itself is kept, just detached), reassigning its messages/comments/posts/follows/offers
 * back to the user. Returns 404 if the current user has no fit player profile linked.
 *
 * Optional `amateur_profile`: the self-assessment of a user leaving official tournaments
 * who never gave one. Unlinking and saving it happen in one transaction, so the user ends
 * up `amatoriale`, never `fan` by accident; an empty self-assessment rolls back with 422
 * and the card stays linked. Without a body the behaviour is unchanged.
 *
 */
export const putEditProfileRemovePlayerProfile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutEditProfileRemovePlayerProfileData, ThrowOnError>
): RequestResult<
  PutEditProfileRemovePlayerProfileResponses,
  PutEditProfileRemovePlayerProfileErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutEditProfileRemovePlayerProfileResponses,
    PutEditProfileRemovePlayerProfileErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/remove-player-profile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * remove player profile associations
 *
 * Unlinks a fit player profile (looked up by `fit_card_number`, NOT necessarily the
 * caller's own) from whichever user it's currently linked to, reassigning its
 * messages/comments/posts/follows/offers back to that user and clearing related Redis
 * caches. Only requires a valid session, not ownership of the target profile. Returns
 * 204 with no body if no profile matches that card number, and 404 if the matched
 * profile isn't linked to any user.
 *
 */
export const putEditProfileRemovePlayerProfileAssociations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutEditProfileRemovePlayerProfileAssociationsData,
    ThrowOnError
  >
): RequestResult<
  PutEditProfileRemovePlayerProfileAssociationsResponses,
  PutEditProfileRemovePlayerProfileAssociationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutEditProfileRemovePlayerProfileAssociationsResponses,
    PutEditProfileRemovePlayerProfileAssociationsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/remove-player-profile-associations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List the extra menu items
 *
 * Active extra entries of the hamburger menu, in menu order. Public: the app asks for them once per session, also before login. An empty list means the usual menu.
 */
export const getExtraMenuItems = <ThrowOnError extends boolean = false>(
  options?: Options<GetExtraMenuItemsData, ThrowOnError>
): RequestResult<GetExtraMenuItemsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetExtraMenuItemsResponses,
    unknown,
    ThrowOnError
  >({ url: '/extra-menu-items', ...options })

/**
 * List all extra menu items (backoffice)
 *
 * All items, inactive ones included, in menu order. Admin roles only.
 */
export const getAdminExtraMenuItems = <ThrowOnError extends boolean = false>(
  options?: Options<GetAdminExtraMenuItemsData, ThrowOnError>
): RequestResult<
  GetAdminExtraMenuItemsResponses,
  GetAdminExtraMenuItemsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAdminExtraMenuItemsResponses,
    GetAdminExtraMenuItemsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/extra-menu-items',
    ...options,
  })

/**
 * Create an extra menu item
 *
 * `url` is an app path starting with `/` or an http(s) URL.
 */
export const postAdminExtraMenuItems = <ThrowOnError extends boolean = false>(
  options?: Options<PostAdminExtraMenuItemsData, ThrowOnError>
): RequestResult<
  PostAdminExtraMenuItemsResponses,
  PostAdminExtraMenuItemsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostAdminExtraMenuItemsResponses,
    PostAdminExtraMenuItemsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/extra-menu-items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Delete an extra menu item
 *
 * Deletes the item for good (set `active: false` to hide it instead).
 */
export const deleteAdminExtraMenuItemsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAdminExtraMenuItemsByIdData, ThrowOnError>
): RequestResult<
  DeleteAdminExtraMenuItemsByIdResponses,
  DeleteAdminExtraMenuItemsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteAdminExtraMenuItemsByIdResponses,
    DeleteAdminExtraMenuItemsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/extra-menu-items/{id}',
    ...options,
  })

/**
 * Update an extra menu item
 *
 * Partial update: only the given keys change.
 */
export const putAdminExtraMenuItemsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutAdminExtraMenuItemsByIdData, ThrowOnError>
): RequestResult<
  PutAdminExtraMenuItemsByIdResponses,
  PutAdminExtraMenuItemsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutAdminExtraMenuItemsByIdResponses,
    PutAdminExtraMenuItemsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/admin/extra-menu-items/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get fit player profile details
 *
 * The main profile page payload for a FIT player: registry data, current/simulated
 * rank, recent matches, active competitions, and social state (followed, premium).
 * Requires X-Api-Key.
 *
 */
export const getFitPlayerProfilesById = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdResponses,
  GetFitPlayerProfilesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdResponses,
    GetFitPlayerProfilesByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}',
    ...options,
  })

/**
 * Get fit player profile wrapped data
 *
 * A "year in review" summary of the player's season (matches won/lost, best rank,
 * category/region/province standing), gated behind the profile's `enable_wrapped`
 * flag. Returns 404 if the profile is hidden. Requires X-Api-Key.
 *
 */
export const getFitPlayerProfilesByIdWrapped = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdWrappedData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdWrappedResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdWrappedResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/wrapped',
    ...options,
  })

/**
 * Search fit player profiles
 *
 * Lightweight typeahead search by player full name, limited to 10 results, excluding
 * hidden profiles. For filtered/paginated search see POST advanced-search. Public
 * endpoint: does not require X-Api-Key.
 *
 */
export const getFitPlayerProfilesSearch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesSearchData, ThrowOnError>
): RequestResult<GetFitPlayerProfilesSearchResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesSearchResponses,
    unknown,
    ThrowOnError
  >({ url: '/fit-player-profiles/search', ...options })

/**
 * Advanced search for fit player profiles
 *
 * Paginated, filterable player search. Filtering by `ranks`, `region`, `province`,
 * `age_categories` or `simulatedRankOrder` is a premium feature and returns 403 for
 * non-premium users; a plain `query` (name) search with no other filters is free.
 * Requires X-Api-Key.
 *
 */
export const postFitPlayerProfilesAdvancedSearch = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostFitPlayerProfilesAdvancedSearchData, ThrowOnError>
): RequestResult<
  PostFitPlayerProfilesAdvancedSearchResponses,
  PostFitPlayerProfilesAdvancedSearchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostFitPlayerProfilesAdvancedSearchResponses,
    PostFitPlayerProfilesAdvancedSearchErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/advanced-search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Get advanced search filters
 *
 * The valid age-category and rank filter values for POST advanced-search, so a client
 * can build the filter UI without hardcoding the enums.
 *
 */
export const getFitPlayerProfilesAdvancedSearchFilters = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetFitPlayerProfilesAdvancedSearchFiltersData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesAdvancedSearchFiltersResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetFitPlayerProfilesAdvancedSearchFiltersResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/advanced-search/filters',
    ...options,
  })

/**
 * Get player rank for specific year
 *
 * The player's official FIT rank for the given year (current fit_year if omitted).
 *
 */
export const getFitPlayerProfilesByIdRank = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdRankData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdRankResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdRankResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/rank',
    ...options,
  })

/**
 * Get player statistics
 *
 * The player's stats dashboard: rank history chart, win/loss breakdown by opponent
 * strength/set count/surface/court type, and distance from their best-ever rank.
 *
 */
export const getFitPlayerProfilesByIdStats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdStatsData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdStatsResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdStatsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/stats',
    ...options,
  })

/**
 * Get player rank simulator
 *
 * "What if" rank simulation for the player's matches in a given year. The base call
 * (no `simulated_rank`/`is_super_simulation`) is free; passing either of those to
 * simulate from a hypothetical starting rank, or run the fuller simulation, is a
 * premium feature and returns 403 otherwise. Requires X-Api-Key.
 *
 */
export const getFitPlayerProfilesByIdSimulator = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdSimulatorData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdSimulatorResponses,
  GetFitPlayerProfilesByIdSimulatorErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdSimulatorResponses,
    GetFitPlayerProfilesByIdSimulatorErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/simulator',
    ...options,
  })

/**
 * Get player rank harmonization
 *
 * Where the player stands among all players who share their rank nationally
 * (`position`/`total_players`), plus the point thresholds to move up/down a rank.
 * Premium feature: returns 403 for non-premium users.
 *
 */
export const getFitPlayerProfilesByIdHarmonization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdHarmonizationData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdHarmonizationResponses,
  GetFitPlayerProfilesByIdHarmonizationErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdHarmonizationResponses,
    GetFitPlayerProfilesByIdHarmonizationErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/harmonization',
    ...options,
  })

/**
 * Get player endorsements
 *
 * The full catalogue of endorsement types (skills) for this player. `endorsement_id`
 * is set when the calling user has already given that endorsement to this player
 * (the ID of their Endorsement record), null otherwise. Requires X-Api-Key.
 *
 */
export const getFitPlayerProfilesByIdEndorsements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdEndorsementsData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdEndorsementsResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdEndorsementsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/endorsements',
    ...options,
  })

/**
 * Get player visit count
 *
 * Total number of profile page views for this player.
 */
export const getFitPlayerProfilesByIdVisits = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdVisitsData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdVisitsResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdVisitsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/visits',
    ...options,
  })

/**
 * Get player feed
 *
 * This player's own posts, paginated. Requires X-Api-Key.
 */
export const getFitPlayerProfilesByIdFeed = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdFeedData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdFeedResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdFeedResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/feed',
    ...options,
  })

/**
 * Get player visitors
 *
 * Up to the last 100 distinct users who visited this profile. Restricted to admin/banner_manager/censor_manager roles (backoffice).
 */
export const getFitPlayerProfilesByIdVisitors = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdVisitorsData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdVisitorsResponses,
  GetFitPlayerProfilesByIdVisitorsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdVisitorsResponses,
    GetFitPlayerProfilesByIdVisitorsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/visitors',
    ...options,
  })

/**
 * Get player followers list
 *
 * The player's followers and who they follow back.
 */
export const getFitPlayerProfilesFollowersListById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesFollowersListByIdData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesFollowersListByIdResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesFollowersListByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/followers_list/{id}',
    ...options,
  })

/**
 * Get player user information
 *
 * The app-account details of the User linked to this FIT profile. Returns an empty
 * object (`{}`) when the profile has no linked user. Public endpoint: does not
 * require X-Api-Key.
 *
 */
export const getFitPlayerProfilesByIdUserInfo = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdUserInfoData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdUserInfoResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdUserInfoResponses,
    unknown,
    ThrowOnError
  >({ url: '/fit-player-profiles/{id}/user-info', ...options })

/**
 * Get player profile for crawlers
 *
 * The same payload as GET /fit-player-profiles/{id}, for search-engine crawlers and the
 * frontend prerender: it records no visit, so the profile's visit counter counts people
 * only. Hidden profiles answer 404, like the full endpoint.
 *
 */
export const getFitPlayerProfilesByIdReduced = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdReducedData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdReducedResponses,
  GetFitPlayerProfilesByIdReducedErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdReducedResponses,
    GetFitPlayerProfilesByIdReducedErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/reduced',
    ...options,
  })

/**
 * Get most visited player profiles
 *
 * The top 10 most-viewed player profiles, with their view counts.
 */
export const getFitPlayerProfilesMostVisited = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetFitPlayerProfilesMostVisitedData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesMostVisitedResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetFitPlayerProfilesMostVisitedResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/most_visited',
    ...options,
  })

/**
 * Check FIT card number availability
 *
 * Called during profile linking: checks whether a FIT card number is free, already
 * linked to another user, or already linked to the caller. Always returns 200 with a
 * `success`/`error` body (never a 4xx) describing the outcome; the client branches on
 * `reassign_old_card`/`remove_associations`/`pick_player` to guide the user through
 * the linking flow. Requires X-Api-Key.
 *
 */
export const postFitPlayerProfilesCheckFitCardNumber = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostFitPlayerProfilesCheckFitCardNumberData, ThrowOnError>
): RequestResult<
  PostFitPlayerProfilesCheckFitCardNumberResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostFitPlayerProfilesCheckFitCardNumberResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/check-fit-card-number',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Get player ID by card number
 *
 * Resolves a FIT card number (`fit_player_id`) to the corresponding FitPlayerProfile
 * ID. Public endpoint: does not require X-Api-Key.
 *
 */
export const getFitPlayerProfilesCardToIdByCardNumber = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesCardToIdByCardNumberData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesCardToIdByCardNumberResponses,
  GetFitPlayerProfilesCardToIdByCardNumberErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesCardToIdByCardNumberResponses,
    GetFitPlayerProfilesCardToIdByCardNumberErrors,
    ThrowOnError
  >({ url: '/fit-player-profiles/card-to-id/{card_number}', ...options })

/**
 * Search players for merging
 *
 * Admin utility: finds candidate duplicate profiles by name, fit_player_id or
 * anagrafica_code, ahead of PUT merge/{source}/{destination}. Limited to 10 results.
 * Restricted to admin/banner_manager/censor_manager roles.
 *
 */
export const getFitPlayerProfilesSearchForMerge = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetFitPlayerProfilesSearchForMergeData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesSearchForMergeResponses,
  GetFitPlayerProfilesSearchForMergeErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetFitPlayerProfilesSearchForMergeResponses,
    GetFitPlayerProfilesSearchForMergeErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/search-for-merge',
    ...options,
  })

/**
 * Merge two player profiles
 *
 * Admin utility: reassigns all matches, draws, visit events and activities from the
 * source profile to the destination profile, then permanently destroys the source
 * profile. Irreversible.
 *
 */
export const putFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdData,
    ThrowOnError
  >
): RequestResult<
  PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdResponses,
  PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdResponses,
    PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/merge/{source_player_id}/{destination_player_id}',
    ...options,
  })

/**
 * Get player strengths and weaknesses
 *
 * A computed list of the player's strengths and weaknesses, derived from their match
 * history (optionally filtered by year/surface). Premium feature: returns 403 for
 * non-premium users.
 *
 */
export const getFitPlayerProfilesByIdStrengthsAndWeaknesses = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetFitPlayerProfilesByIdStrengthsAndWeaknessesData,
    ThrowOnError
  >
): RequestResult<
  GetFitPlayerProfilesByIdStrengthsAndWeaknessesResponses,
  GetFitPlayerProfilesByIdStrengthsAndWeaknessesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdStrengthsAndWeaknessesResponses,
    GetFitPlayerProfilesByIdStrengthsAndWeaknessesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/strengths-and-weaknesses',
    ...options,
  })

/**
 * Get the three players around this one in the ranking
 *
 * A slice of the national ranking list centered on this player, used to render the
 * ranking-chart excerpt on their profile. Premium feature: returns 403 for
 * non-premium users.
 *
 */
export const getFitPlayerProfilesByIdChartExtract = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdChartExtractData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdChartExtractResponses,
  GetFitPlayerProfilesByIdChartExtractErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdChartExtractResponses,
    GetFitPlayerProfilesByIdChartExtractErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/chart_extract',
    ...options,
  })

/**
 * Get a computed ranking evaluation for the player
 *
 * A single computed evaluation score for the player's current (or a hypothetical
 * `simulated_rank`) ranking standing, for the current FIT season year.
 *
 */
export const getFitPlayerProfilesByIdEvaluation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdEvaluationData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdEvaluationResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdEvaluationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/evaluation',
    ...options,
  })

/**
 * Get player ranks for a specific year, across all rank types
 *
 * The player's position within seven different ranking scopes for the given year
 * (national/regional/provincial/club, each with and without age category). Each
 * value is a numeric position, or the string "ND" if the player has no ranking in
 * that scope. Premium feature: returns 403 for non-premium users.
 *
 */
export const getFitPlayerProfilesByIdRanksWithYear = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdRanksWithYearData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdRanksWithYearResponses,
  GetFitPlayerProfilesByIdRanksWithYearErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdRanksWithYearResponses,
    GetFitPlayerProfilesByIdRanksWithYearErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/ranks-with-year',
    ...options,
  })

/**
 * Get home feed
 *
 * The main feed shown on the app's home screen: recent posts (excluding news/magazine
 * content and posts from banned/blocked authors) plus a separate magazine carousel.
 * X-Api-Key is optional — if present it personalizes exclusions, but anonymous
 * callers get a response too.
 *
 */
export const getHome = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomeData, ThrowOnError>
): RequestResult<GetHomeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetHomeResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/home',
    ...options,
  })

/**
 * Get home statistics numbers
 *
 * Public, headline platform stats (total matches/players/competitions) shown on the
 * home screen. No authentication required.
 *
 */
export const getHomeNumbers = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomeNumbersData, ThrowOnError>
): RequestResult<GetHomeNumbersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetHomeNumbersResponses,
    unknown,
    ThrowOnError
  >({ url: '/home/numbers', ...options })

/**
 * Get matches counts for current FIT year and week
 *
 * Count of matches recorded this FIT year and in the last 7 days. No authentication
 * required.
 *
 */
export const getHomeMatchesNumbers = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomeMatchesNumbersData, ThrowOnError>
): RequestResult<GetHomeMatchesNumbersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetHomeMatchesNumbersResponses,
    unknown,
    ThrowOnError
  >({ url: '/home/matches-numbers', ...options })

/**
 * Get user notifications count
 *
 * Unread notification and unread message counters for the current user, shown as
 * badge counts on the home screen.
 *
 */
export const getHomeNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomeNotificationsData, ThrowOnError>
): RequestResult<GetHomeNotificationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetHomeNotificationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/home/notifications',
    ...options,
  })

/**
 * Get backoffice statistics (admin only)
 *
 * Aggregate admin dashboard numbers: user counts, activity windows, pending
 * update tasks/reports, membership code redemption trends. Admin/banner_manager/
 * censor_manager only.
 *
 */
export const getHomeBackofficeNumbers = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomeBackofficeNumbersData, ThrowOnError>
): RequestResult<
  GetHomeBackofficeNumbersResponses,
  GetHomeBackofficeNumbersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetHomeBackofficeNumbersResponses,
    GetHomeBackofficeNumbersErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/home/backoffice_numbers',
    ...options,
  })

/**
 * Perform inline search across multiple entities
 *
 * Quick cross-entity search (players, clubs, posts, etc.) for the home screen's
 * search bar, capped at `limit` results per category. No authentication required.
 *
 */
export const postHomeInlineSearch = <ThrowOnError extends boolean = false>(
  options?: Options<PostHomeInlineSearchData, ThrowOnError>
): RequestResult<PostHomeInlineSearchResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostHomeInlineSearchResponses,
    unknown,
    ThrowOnError
  >({
    url: '/home/inline-search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Perform inline search for players only
 *
 * Same as the multi-entity inline search but scoped to fit player profiles only.
 * No authentication required.
 *
 */
export const postHomeInlineSearchPlayers = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostHomeInlineSearchPlayersData, ThrowOnError>
): RequestResult<PostHomeInlineSearchPlayersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostHomeInlineSearchPlayersResponses,
    unknown,
    ThrowOnError
  >({
    url: '/home/inline-search-players',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Send invitation email to a user
 *
 * Sends an invitation email on behalf of the current user, inviting a non-user to
 * join TennisTalker. Responds `success: true` with a message if the email already
 * belongs to an existing user (no email is sent in that case).
 *
 */
export const postHomeInvitation = <ThrowOnError extends boolean = false>(
  options?: Options<PostHomeInvitationData, ThrowOnError>
): RequestResult<PostHomeInvitationResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostHomeInvitationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/home/invitation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Get app rating
 *
 * Current app store rating shown to prompt users for a review. No authentication
 * required.
 *
 */
export const getHomeRate = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomeRateData, ThrowOnError>
): RequestResult<GetHomeRateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetHomeRateResponses, unknown, ThrowOnError>({
    url: '/home/rate',
    ...options,
  })

/**
 * Send notifications to all users (admin only)
 *
 * Broadcasts a push/in-app notification with the given title, content and optional
 * destination URL to every user. Requires the same `authorize! :manage, UpdateTask`
 * permission as the Update Tasks admin endpoints.
 *
 */
export const postHomeSendAllNotifications = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostHomeSendAllNotificationsData, ThrowOnError>
): RequestResult<
  PostHomeSendAllNotificationsResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostHomeSendAllNotificationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/home/send_all_notifications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * JWT del Messenger Intercom per l'utente loggato
 *
 * Firma l'identità dell'utente per il Messenger Intercom (chat e help center in app e sul sito). Il token vale 30 giorni: il client lo chiede all'avvio e di nuovo dopo `expires_at`.
 */
export const getIntercomMessengerToken = <ThrowOnError extends boolean = false>(
  options?: Options<GetIntercomMessengerTokenData, ThrowOnError>
): RequestResult<
  GetIntercomMessengerTokenResponses,
  GetIntercomMessengerTokenErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetIntercomMessengerTokenResponses,
    GetIntercomMessengerTokenErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/intercom/messenger-token',
    ...options,
  })

/**
 * Likes a post
 *
 * Records a like from the caller on the given post and returns the updated post (with its new like count).
 */
export const postPostsByIdLike = <ThrowOnError extends boolean = false>(
  options: Options<PostPostsByIdLikeData, ThrowOnError>
): RequestResult<
  PostPostsByIdLikeResponses,
  PostPostsByIdLikeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostPostsByIdLikeResponses,
    PostPostsByIdLikeErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{id}/like',
    ...options,
  })

/**
 * Unlikes a post
 *
 * Removes the caller's like from the given post and returns the updated post.
 */
export const deletePostsByIdUnlike = <ThrowOnError extends boolean = false>(
  options: Options<DeletePostsByIdUnlikeData, ThrowOnError>
): RequestResult<
  DeletePostsByIdUnlikeResponses,
  DeletePostsByIdUnlikeErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePostsByIdUnlikeResponses,
    DeletePostsByIdUnlikeErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{id}/unlike',
    ...options,
  })

/**
 * Get a live event
 *
 * Branding, game settings and state of an active event. Public, so the web landing can render the brand; with a valid X-Api-Key it also returns the caller's active game/queue place and best scores.
 */
export const getLiveEventsBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetLiveEventsBySlugData, ThrowOnError>
): RequestResult<
  GetLiveEventsBySlugResponses,
  GetLiveEventsBySlugErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetLiveEventsBySlugResponses,
    GetLiveEventsBySlugErrors,
    ThrowOnError
  >({ url: '/live-events/{slug}', ...options })

/**
 * Get a live event leaderboard
 *
 * Best valid score per player for one mode (ties: the earliest wins). Games invalidated or deleted by an admin are excluded. Public; with X-Api-Key `me` carries the caller's row even when outside the returned page.
 */
export const getLiveEventsBySlugLeaderboard = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLiveEventsBySlugLeaderboardData, ThrowOnError>
): RequestResult<
  GetLiveEventsBySlugLeaderboardResponses,
  GetLiveEventsBySlugLeaderboardErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetLiveEventsBySlugLeaderboardResponses,
    GetLiveEventsBySlugLeaderboardErrors,
    ThrowOnError
  >({ url: '/live-events/{slug}/leaderboard', ...options })

/**
 * Start a game or join the big-screen queue
 *
 * Creates a game for the caller, cancelling any other active one (so replaying puts you back at the end of the queue). `home` games and `live` games with the big screen off come back `called` (playable now). `live` games with the screen on come back `queued`, or `called` + `on_screen` when the screen is free. `live` requires the `live_key` of the official QR when the event has one.
 */
export const postLiveEventsBySlugSessions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostLiveEventsBySlugSessionsData, ThrowOnError>
): RequestResult<
  PostLiveEventsBySlugSessionsResponses,
  PostLiveEventsBySlugSessionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostLiveEventsBySlugSessionsResponses,
    PostLiveEventsBySlugSessionsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/live-events/{slug}/sessions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get one of your games
 *
 * Current status and queue position of one of the caller's games. Also advances the queue (expired turns) and, for an active game, counts as a presence ping. Polling fallback for the websocket `LiveEventPlayerChannel`.
 */
export const getLiveEventsBySlugSessionsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetLiveEventsBySlugSessionsByIdData, ThrowOnError>
): RequestResult<
  GetLiveEventsBySlugSessionsByIdResponses,
  GetLiveEventsBySlugSessionsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetLiveEventsBySlugSessionsByIdResponses,
    GetLiveEventsBySlugSessionsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/live-events/{slug}/sessions/{id}',
    ...options,
  })

/**
 * Start a called game
 *
 * Moves a `called` game to `playing`. Fails with `not_your_turn` otherwise.
 */
export const postLiveEventsBySlugSessionsByIdStart = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostLiveEventsBySlugSessionsByIdStartData, ThrowOnError>
): RequestResult<
  PostLiveEventsBySlugSessionsByIdStartResponses,
  PostLiveEventsBySlugSessionsByIdStartErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostLiveEventsBySlugSessionsByIdStartResponses,
    PostLiveEventsBySlugSessionsByIdStartErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/live-events/{slug}/sessions/{id}/start',
    ...options,
  })

/**
 * Finish a game and save the score
 *
 * Saves the result of a `playing` game (also accepted for a game that expired because of a lost connection after it started) and frees the big screen. Inconsistent results are saved but flagged `stats.suspicious` for admins; out-of-range values (negative or above 2147483647) fail with `invalid_result`.
 */
export const postLiveEventsBySlugSessionsByIdFinish = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostLiveEventsBySlugSessionsByIdFinishData, ThrowOnError>
): RequestResult<
  PostLiveEventsBySlugSessionsByIdFinishResponses,
  PostLiveEventsBySlugSessionsByIdFinishErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostLiveEventsBySlugSessionsByIdFinishResponses,
    PostLiveEventsBySlugSessionsByIdFinishErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/live-events/{slug}/sessions/{id}/finish',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Leave the queue or give up a game
 *
 * Cancels an active game (queued/called/playing) and advances the queue. Finished games are returned unchanged.
 */
export const postLiveEventsBySlugSessionsByIdCancel = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostLiveEventsBySlugSessionsByIdCancelData, ThrowOnError>
): RequestResult<
  PostLiveEventsBySlugSessionsByIdCancelResponses,
  PostLiveEventsBySlugSessionsByIdCancelErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostLiveEventsBySlugSessionsByIdCancelResponses,
    PostLiveEventsBySlugSessionsByIdCancelErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/live-events/{slug}/sessions/{id}/cancel',
    ...options,
  })

/**
 * Get matches list
 *
 * Officially recorded matches (as opposed to user-reported UserMatches). Any
 * authenticated user can read this list.
 *
 */
export const getMatches = <ThrowOnError extends boolean = false>(
  options: Options<GetMatchesData, ThrowOnError>
): RequestResult<GetMatchesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetMatchesResponses, unknown, ThrowOnError>({
    url: '/matches',
    ...options,
  })

/**
 * Create a new match
 *
 * Manually records an official match result within a draw. `first_winner`/
 * `first_loser` are required (singles); `second_winner`/`second_loser` are for
 * doubles. Admin/banner_manager/censor_manager only (CanCan `:manage, Match`).
 *
 */
export const postMatches = <ThrowOnError extends boolean = false>(
  options: Options<PostMatchesData, ThrowOnError>
): RequestResult<PostMatchesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PostMatchesResponses, unknown, ThrowOnError>({
    url: '/matches',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete match
 *
 * Admin/banner_manager/censor_manager only (CanCan `:manage, Match`).
 */
export const deleteMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMatchesByIdData, ThrowOnError>
): RequestResult<
  DeleteMatchesByIdResponses,
  DeleteMatchesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteMatchesByIdResponses,
    DeleteMatchesByIdErrors,
    ThrowOnError
  >({ url: '/matches/{id}', ...options })

/**
 * Get match details
 *
 * Any authenticated user can read a single match.
 */
export const getMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<GetMatchesByIdData, ThrowOnError>
): RequestResult<GetMatchesByIdResponses, GetMatchesByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetMatchesByIdResponses,
    GetMatchesByIdErrors,
    ThrowOnError
  >({ url: '/matches/{id}', ...options })

/**
 * Update match
 *
 * Updates any subset of a match's fields (same shape as POST /matches). Admin/
 * banner_manager/censor_manager only (CanCan `:manage, Match`) — contrast with
 * PUT /matches/{id}/result below, which is open to any authenticated user but
 * only touches the result fields.
 *
 */
export const putMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<PutMatchesByIdData, ThrowOnError>
): RequestResult<PutMatchesByIdResponses, PutMatchesByIdErrors, ThrowOnError> =>
  (options.client ?? client).put<
    PutMatchesByIdResponses,
    PutMatchesByIdErrors,
    ThrowOnError
  >({
    url: '/matches/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update match result
 *
 * Corrects just the result of a match (unlike PUT /matches/{id}, which can edit
 * any field but is admin-only). Authorization is per-match via
 * `Match#editable_by?`, not the blanket CanCan role check — typically one of the
 * players involved, or an admin. Recomputes ranking points for every player in
 * the match as a side effect.
 *
 */
export const putMatchesByIdResult = <ThrowOnError extends boolean = false>(
  options: Options<PutMatchesByIdResultData, ThrowOnError>
): RequestResult<
  PutMatchesByIdResultResponses,
  PutMatchesByIdResultErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutMatchesByIdResultResponses,
    PutMatchesByIdResultErrors,
    ThrowOnError
  >({
    url: '/matches/{id}/result',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Crea un checkout identificato della membership
 *
 * Creates the opaque reference of an identified checkout for the current user and returns the
 * link that opens the Shopify checkout with that reference as the `tt_ref` cart attribute, so
 * the order activates the membership on this account. Open `checkout_url` with a plain link
 * (on native, in the system browser).
 *
 */
export const postPremiumCheckout = <ThrowOnError extends boolean = false>(
  options?: Options<PostPremiumCheckoutData, ThrowOnError>
): RequestResult<
  PostPremiumCheckoutResponses,
  PostPremiumCheckoutErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostPremiumCheckoutResponses,
    PostPremiumCheckoutErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium/checkout',
    ...options,
  })

/**
 * Apre il checkout Shopify identificato
 *
 * Public: the reference is the credential. Creates a Shopify cart for the annual membership with
 * the `tt_ref` attribute (and the account email, unless it is an Apple private relay address) and
 * redirects to its checkout. An unknown, expired or used reference, or a Storefront API error,
 * redirects to the plain Recharge checkout instead, where the membership arrives as a code by email.
 *
 */
export const getPremiumCheckoutByRef = <ThrowOnError extends boolean = false>(
  options: Options<GetPremiumCheckoutByRefData, ThrowOnError>
): RequestResult<unknown, unknown, ThrowOnError> =>
  (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    url: '/premium/checkout/{ref}',
    ...options,
  })

/**
 * Apre il portale Recharge da una notifica di rinnovo fallito o carta in scadenza
 *
 * Public: the reference is the credential, and the link works for 60 days. Link of the passive
 * churn notifications (renewal failed, card expiring). Redirects to the Recharge customer portal,
 * where the member signs in with the purchase email and updates the payment method: Recharge
 * gives no personal portal link. An unknown or expired reference redirects there too.
 *
 */
export const getPremiumPaymentMethodByRef = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPremiumPaymentMethodByRefData, ThrowOnError>
): RequestResult<unknown, unknown, ThrowOnError> =>
  (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    url: '/premium/payment_method/{ref}',
    ...options,
  })

/**
 * Stato premium dell'utente corrente
 *
 * Premium flag, expiration and role of the current user, to refresh the saved user after a purchase without logging in again.
 */
export const getPremiumStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetPremiumStatusData, ThrowOnError>
): RequestResult<
  GetPremiumStatusResponses,
  GetPremiumStatusErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPremiumStatusResponses,
    GetPremiumStatusErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium/status',
    ...options,
  })

/**
 * List top-level offer categories with their children
 *
 * Lists the top-level (parent) offer categories, each with its nested children.
 * Used to build the category picker when browsing/creating marketplace offers.
 * Public endpoint: does not require X-Api-Key.
 *
 */
export const getOfferCategories = <ThrowOnError extends boolean = false>(
  options?: Options<GetOfferCategoriesData, ThrowOnError>
): RequestResult<GetOfferCategoriesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetOfferCategoriesResponses,
    unknown,
    ThrowOnError
  >({ url: '/offer-categories', ...options })

/**
 * Create an offer category
 *
 * Creates a new offer category. Admin/banner_manager/censor_manager only.
 */
export const postOfferCategories = <ThrowOnError extends boolean = false>(
  options: Options<PostOfferCategoriesData, ThrowOnError>
): RequestResult<
  PostOfferCategoriesResponses,
  PostOfferCategoriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostOfferCategoriesResponses,
    PostOfferCategoriesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offer-categories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete an offer category without children
 *
 * Deletes a leaf offer category (one with no children). Admin/banner_manager/
 * censor_manager only. A category that still has children responds 404, since it
 * can't be resolved as a leaf category — delete or reassign its children first.
 *
 */
export const deleteOfferCategoriesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOfferCategoriesByIdData, ThrowOnError>
): RequestResult<
  DeleteOfferCategoriesByIdResponses,
  DeleteOfferCategoriesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteOfferCategoriesByIdResponses,
    DeleteOfferCategoriesByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offer-categories/{id}',
    ...options,
  })

/**
 * Update an offer category
 *
 * Updates an offer category. Admin/banner_manager/censor_manager only.
 */
export const patchOfferCategoriesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchOfferCategoriesByIdData, ThrowOnError>
): RequestResult<PatchOfferCategoriesByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<
    PatchOfferCategoriesByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offer-categories/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List child offer categories
 *
 * Lists all leaf (child) offer categories, flattened, regardless of their parent.
 * Public endpoint: does not require X-Api-Key.
 *
 */
export const getOfferCategoriesChildren = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetOfferCategoriesChildrenData, ThrowOnError>
): RequestResult<GetOfferCategoriesChildrenResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetOfferCategoriesChildrenResponses,
    unknown,
    ThrowOnError
  >({ url: '/offer-categories/children', ...options })

/**
 * List all offer categories with backoffice details
 *
 * Admin listing of every top-level category with its children and extra
 * moderation/admin fields not present in the public listing.
 * Admin/banner_manager/censor_manager only.
 *
 */
export const getOfferCategoriesBackoffice = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOfferCategoriesBackofficeData, ThrowOnError>
): RequestResult<
  GetOfferCategoriesBackofficeResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOfferCategoriesBackofficeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offer-categories/backoffice',
    ...options,
  })

/**
 * Delete offer
 *
 * Deletes an offer. Only the offer owner or an admin may delete it.
 */
export const deleteOffersById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOffersByIdData, ThrowOnError>
): RequestResult<
  DeleteOffersByIdResponses,
  DeleteOffersByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteOffersByIdResponses,
    DeleteOffersByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/{id}',
    ...options,
  })

/**
 * Get offer details
 *
 * Returns a single marketplace offer (private user listing or shop listing) by id,
 * including its images. Requires authentication.
 *
 */
export const getOffersById = <ThrowOnError extends boolean = false>(
  options: Options<GetOffersByIdData, ThrowOnError>
): RequestResult<GetOffersByIdResponses, GetOffersByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetOffersByIdResponses,
    GetOffersByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/{id}',
    ...options,
  })

/**
 * Update offer
 *
 * Updates an existing offer. Only the offer's owner may update it, except admins who may
 * update any offer. Any `images` entry without an `id` is added as a new image.
 *
 */
export const patchOffersById = <ThrowOnError extends boolean = false>(
  options: Options<PatchOffersByIdData, ThrowOnError>
): RequestResult<
  PatchOffersByIdResponses,
  PatchOffersByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchOffersByIdResponses,
    PatchOffersByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update offer
 *
 * Identical to PATCH /offers/{id}; both verbs are accepted for updates.
 */
export const putOffersById = <ThrowOnError extends boolean = false>(
  options: Options<PutOffersByIdData, ThrowOnError>
): RequestResult<PutOffersByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PutOffersByIdResponses, unknown, ThrowOnError>(
    {
      security: [{ name: 'X-Api-Key', type: 'apiKey' }],
      url: '/offers/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  )

/**
 * Search offers
 *
 * Full-text and filtered search across all marketplace offers (private and shop).
 * Public endpoint: does not require X-Api-Key.
 *
 */
export const postOffersSearch = <ThrowOnError extends boolean = false>(
  options?: Options<PostOffersSearchData, ThrowOnError>
): RequestResult<PostOffersSearchResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostOffersSearchResponses,
    unknown,
    ThrowOnError
  >({
    url: '/offers/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Get private offers
 *
 * Lists all offers listed by individual (non-shop) users. Requires authentication.
 */
export const getOffersPrivates = <ThrowOnError extends boolean = false>(
  options?: Options<GetOffersPrivatesData, ThrowOnError>
): RequestResult<
  GetOffersPrivatesResponses,
  GetOffersPrivatesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetOffersPrivatesResponses,
    GetOffersPrivatesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/privates',
    ...options,
  })

/**
 * Get shop offers
 *
 * Lists all offers listed by shop profiles (tennis shops/clubs). Requires authentication.
 */
export const getOffersShops = <ThrowOnError extends boolean = false>(
  options: Options<GetOffersShopsData, ThrowOnError>
): RequestResult<GetOffersShopsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetOffersShopsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/shops',
    ...options,
  })

/**
 * Create offer
 *
 * Creates a new marketplace offer owned by the current user. `masqueraded_type`/
 * `masqueraded_id` identify who the offer is posted as (the user themself, or a
 * ShopProfile they manage).
 *
 */
export const postOffers = <ThrowOnError extends boolean = false>(
  options?: Options<PostOffersData, ThrowOnError>
): RequestResult<PostOffersResponses, PostOffersErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    PostOffersResponses,
    PostOffersErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Lists posts for a masqueraded profile
 *
 * Lists posts authored under a given "masqueraded" profile (e.g. a User or a Club the
 * caller manages), newest first, 10 per page. The caller must actually manage the
 * given `type`/`id` profile — otherwise this returns `401`.
 *
 */
export const getPosts = <ThrowOnError extends boolean = false>(
  options: Options<GetPostsData, ThrowOnError>
): RequestResult<GetPostsResponses, GetPostsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetPostsResponses,
    GetPostsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts',
    ...options,
  })

/**
 * Creates a new post
 *
 * Creates a post in the social feed, authored by (or on behalf of) the caller.
 *
 * The `masqueraded_id`/`masqueraded_type` pair identifies who the post is published
 * as (the caller's own User, or an entity they manage, e.g. a Club they're the
 * manager of). The post can optionally reference a `shareable` (currently only
 * `Activity`) to share, or another post via `shared_post_id` to repost it.
 *
 * `as_tennistalker: true` publishes on behalf of the official TennisTalker account and
 * is restricted to non-`simple_user` roles (admin/banner_manager/censor_manager/etc.) —
 * a `simple_user` attempting it gets a `401`. A banned caller's request is silently
 * accepted (`{ success: true }`) without actually creating a post.
 *
 */
export const postPosts = <ThrowOnError extends boolean = false>(
  options?: Options<PostPostsData, ThrowOnError>
): RequestResult<PostPostsResponses, PostPostsErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    PostPostsResponses,
    PostPostsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Returns the latest blog post
 *
 * Public. Returns the most recent official TennisTalker blog post (a news-flagged post authored by the TennisTalker editorial account).
 */
export const getPostsLastBlog = <ThrowOnError extends boolean = false>(
  options?: Options<GetPostsLastBlogData, ThrowOnError>
): RequestResult<GetPostsLastBlogResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetPostsLastBlogResponses,
    unknown,
    ThrowOnError
  >({ url: '/posts/last_blog', ...options })

/**
 * Deletes a post
 *
 * Deletes one of the caller's own posts (also unlinks any post that was sharing it). Returns 404 if the post doesn't exist or isn't owned by the caller.
 */
export const deletePostsById = <ThrowOnError extends boolean = false>(
  options: Options<DeletePostsByIdData, ThrowOnError>
): RequestResult<
  DeletePostsByIdResponses,
  DeletePostsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePostsByIdResponses,
    DeletePostsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{id}',
    ...options,
  })

/**
 * Shows a post
 *
 * Public — X-Api-Key is optional and, when present, only affects `liked_by_current_user`/`is_author` on the response.
 */
export const getPostsById = <ThrowOnError extends boolean = false>(
  options: Options<GetPostsByIdData, ThrowOnError>
): RequestResult<GetPostsByIdResponses, GetPostsByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetPostsByIdResponses,
    GetPostsByIdErrors,
    ThrowOnError
  >({ url: '/posts/{id}', ...options })

/**
 * Updates a post
 *
 * Updates the caller's own post (content/video only — the author/masquerade cannot be
 * changed). Returns 404 for a post of another author, unless the caller is staff. `as_tennistalker` posts can only be edited by non-`simple_user` roles.
 *
 * Image handling is driven by the top-level `images` array, not the nested `post`
 * object: an entry with an existing `id` is kept, one with `_destroy: true` removes
 * that image, and an entry with no `id` adds a new image.
 *
 */
export const patchPostsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchPostsByIdData, ThrowOnError>
): RequestResult<PatchPostsByIdResponses, PatchPostsByIdErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    PatchPostsByIdResponses,
    PatchPostsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Riceve un webhook Recharge (rinnovi e subscription)
 *
 * Webhook registered on Recharge for `charge/failed`, `charge/paid`, `charge/max_retries_reached`
 * and `subscription/cancelled` (passive churn). Not part of the app client API: authenticated by
 * `X-Recharge-Hmac-Sha256`, the hex SHA-256 of the API client secret followed by the raw body.
 * Every event is recorded once and processed in background; ignored topics and redeliveries
 * also get 200, since Recharge deletes a webhook after repeated errors.
 *
 */
export const postRechargeWebhook = <ThrowOnError extends boolean = false>(
  options: Options<PostRechargeWebhookData, ThrowOnError>
): RequestResult<
  PostRechargeWebhookResponses,
  PostRechargeWebhookErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostRechargeWebhookResponses,
    PostRechargeWebhookErrors,
    ThrowOnError
  >({
    url: '/recharge/webhook',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * user registration
 *
 * Step 1 of sign-up: creates a User from just email + password and sends a confirmation
 * email. The account is created with placeholder name/details ("Talker"/"Anonimo") to be
 * filled in via `POST /users/sign-up/additional-info` once the user confirms their email
 * and continues onboarding. Validation errors are returned with a 200 status and
 * `success: false` (not 422/400) — check the `success` field, not just the HTTP status.
 *
 */
export const postUsersSignUp = <ThrowOnError extends boolean = false>(
  options?: Options<PostUsersSignUpData, ThrowOnError>
): RequestResult<PostUsersSignUpResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostUsersSignUpResponses,
    unknown,
    ThrowOnError
  >({
    url: '/users/sign-up',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * update user additional information
 *
 * Step 2 of sign-up: fills in the profile details for the user identified by
 * `confirmation_token` (the token emailed after `POST /users/sign-up`) or, for social
 * sign-ups that never get one, by the `X-Api-Key` session (which wins when both are
 * sent). Returns 401 if neither a valid session nor a `confirmation_token` is sent,
 * 404 if the `confirmation_token` doesn't match a user.
 *
 */
export const postUsersSignUpAdditionalInfo = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostUsersSignUpAdditionalInfoData, ThrowOnError>
): RequestResult<
  PostUsersSignUpAdditionalInfoResponses,
  PostUsersSignUpAdditionalInfoErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostUsersSignUpAdditionalInfoResponses,
    PostUsersSignUpAdditionalInfoErrors,
    ThrowOnError
  >({
    url: '/users/sign-up/additional-info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * complete user profile with professional profiles
 *
 * Step 3 (final) of sign-up: attaches the role-specific profile(s) the user picked
 * during onboarding — at most one is typically meaningful per user, but any combination
 * of `teacher_profile`, `amateur_profile`, `trainer_profile`, `nutritionist_profile`,
 * `mental_coach_profile`, `club_manager_profile`, `shop_profile` and/or
 * `fit_player_profile` (FIT card linking) can be sent. `token` is the same
 * confirmation_token used in the previous step; social sign-ups send the `X-Api-Key`
 * session instead (which wins when both are sent). Returns 401 if neither a valid
 * session nor a `token` is sent, 404 if the `token` doesn't match a user. Sub-objects the client doesn't want
 * to fill in should be omitted or sent empty — see the controller's
 * `OPTIONAL_PROFILE_SAVERS` for exactly which keys are safely skippable.
 * A FIT card (`fit_player_profile` with a card number or a selected player) is only
 * linked to a user with a real first name, last name and birth date: otherwise the
 * whole request is refused with 422 and nothing is saved.
 *
 */
export const postUsersCompleteProfile = <ThrowOnError extends boolean = false>(
  options?: Options<PostUsersCompleteProfileData, ThrowOnError>
): RequestResult<
  PostUsersCompleteProfileResponses,
  PostUsersCompleteProfileErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostUsersCompleteProfileResponses,
    PostUsersCompleteProfileErrors,
    ThrowOnError
  >({
    url: '/users/complete-profile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List reports
 *
 * Paginated list of all reports (moderation flags users file against a Post, Comment
 * or User), most recent first. Restricted to admin/banner_manager/censor_manager
 * roles — `Ability` explicitly denies `:read` on Report to simple/premium users, who
 * get `401`.
 *
 */
export const getReports = <ThrowOnError extends boolean = false>(
  options: Options<GetReportsData, ThrowOnError>
): RequestResult<GetReportsResponses, GetReportsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetReportsResponses,
    GetReportsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reports',
    ...options,
  })

/**
 * Create a report
 *
 * Files a report (moderation flag) against a Post, Comment, User or UserMatch on behalf of the
 * current user. Open to any authenticated user (no admin/reporting-role restriction).
 * Validation errors (e.g. missing/invalid reportable) come back as `200` with
 * `success: false`, not `422` — check `success` in the body.
 *
 */
export const postReports = <ThrowOnError extends boolean = false>(
  options: Options<PostReportsData, ThrowOnError>
): RequestResult<PostReportsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PostReportsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reports',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get report details
 *
 * Full detail for a single report. Restricted to admin/banner_manager/censor_manager
 * roles, same as the index endpoint.
 *
 */
export const getReportsById = <ThrowOnError extends boolean = false>(
  options: Options<GetReportsByIdData, ThrowOnError>
): RequestResult<GetReportsByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetReportsByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reports/{id}',
    ...options,
  })

/**
 * Respond to a report (closes it with an admin note)
 *
 * Closes a report, attaching an optional admin note. This only updates the report's
 * own status — it does not touch the reported content. To also remove the offending
 * content, call `DELETE /reports/{id}/delete-target` instead. Restricted to
 * admin/banner_manager/censor_manager roles.
 *
 */
export const patchReportsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchReportsByIdData, ThrowOnError>
): RequestResult<
  PatchReportsByIdResponses,
  PatchReportsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchReportsByIdResponses,
    PatchReportsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reports/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete the reported content and mark the report resolved
 *
 * Deletes the content the report points at (Post, Comment, or User; a UserMatch gets `422`) and, for posts
 * and comments, cascades to their shared-post/nested-comment cleanup. The report
 * itself is not deleted, only the reported content. Restricted to
 * admin/banner_manager/censor_manager roles.
 *
 */
export const deleteReportsByIdDeleteTarget = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteReportsByIdDeleteTargetData, ThrowOnError>
): RequestResult<
  DeleteReportsByIdDeleteTargetResponses,
  DeleteReportsByIdDeleteTargetErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteReportsByIdDeleteTargetResponses,
    DeleteReportsByIdDeleteTargetErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reports/{id}/delete-target',
    ...options,
  })

/**
 * List pending reports
 *
 * Shorthand for the index, pre-filtered to `status: pending` (open reports awaiting
 * review), 100 per page instead of 20. Restricted to
 * admin/banner_manager/censor_manager roles.
 *
 */
export const getReportsPending = <ThrowOnError extends boolean = false>(
  options: Options<GetReportsPendingData, ThrowOnError>
): RequestResult<GetReportsPendingResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetReportsPendingResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reports/pending',
    ...options,
  })

/**
 * List closed reports
 *
 * Shorthand for the index, pre-filtered to `status: closed` (already handled
 * reports), 100 per page instead of 20. Restricted to
 * admin/banner_manager/censor_manager roles.
 *
 */
export const getReportsClosed = <ThrowOnError extends boolean = false>(
  options: Options<GetReportsClosedData, ThrowOnError>
): RequestResult<GetReportsClosedResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetReportsClosedResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reports/closed',
    ...options,
  })

/**
 * Ricerca generale
 *
 * Global search across FIT players (first and last name), users (full name, nickname or
 * the name of their linked FIT player profile, unless hidden),
 * clubs (name, or the full name of their region/province: "lombardia", "milano"),
 * competitions (name, club name, or the full name of the club region/province) and user
 * posts (content; news, magazine and official TennisTalker posts are excluded, and so
 * are the posts of banned and shadow-banned users, as in the feeds). One
 * section per type, each paginated with its own total: players keep the players search
 * order (active card holders first, then by ranking); users and clubs are sorted by
 * similarity (clubs: active first); competitions by similarity, then most recent; posts
 * newest first. Text is matched ignoring case, accents and apostrophes, and every word of
 * the query must match. Authentication is optional.
 *
 */
export const getSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetSearchData, ThrowOnError>
): RequestResult<GetSearchResponses, GetSearchErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetSearchResponses,
    GetSearchErrors,
    ThrowOnError
  >({ url: '/search', ...options })

/**
 * Ricerca giocatori
 *
 * One of four tab-specific search endpoints (players/clubs/competitions/
 * other_profiles) behind the app's global search bar. Every one of the four
 * endpoints returns `results_numbers` — the match count across ALL four
 * categories, not just this one — so the UI can badge the other tabs without
 * four separate requests. Page 1 results for a query are cached.
 *
 */
export const postSearchPlayers = <ThrowOnError extends boolean = false>(
  options?: Options<PostSearchPlayersData, ThrowOnError>
): RequestResult<PostSearchPlayersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSearchPlayersResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/search/players',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Ricerca club
 *
 * Clubs tab of the global search. See POST /search/players for the shared
 * `results_numbers` badge-count behavior.
 *
 */
export const postSearchClubs = <ThrowOnError extends boolean = false>(
  options?: Options<PostSearchClubsData, ThrowOnError>
): RequestResult<PostSearchClubsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSearchClubsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/search/clubs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Ricerca competizioni
 *
 * Competitions tab of the global search. See POST /search/players for the shared
 * `results_numbers` badge-count behavior.
 *
 */
export const postSearchCompetitions = <ThrowOnError extends boolean = false>(
  options?: Options<PostSearchCompetitionsData, ThrowOnError>
): RequestResult<PostSearchCompetitionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSearchCompetitionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/search/competitions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Ricerca altri profili
 *
 * "Other profiles" tab of the global search: users identified by a professional
 * role (teacher, trainer, nutritionist, mental coach, shop) rather than a
 * FitPlayerProfile. `profile_filter` narrows to one of those role types. Only
 * users are returned: FIT players with a teacher qualification are teachers
 * through the teacher profile created when their card is linked, so each
 * teacher is listed and counted once. See POST /search/players for the shared
 * `results_numbers` badge-count behavior.
 *
 */
export const postSearchOtherProfiles = <ThrowOnError extends boolean = false>(
  options?: Options<PostSearchOtherProfilesData, ThrowOnError>
): RequestResult<PostSearchOtherProfilesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSearchOtherProfilesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/search/other_profiles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Ricerca maestri FIT senza utente
 *
 * Teacher picker of activities: FIT cards with a teacher qualification that are not
 * linked to any user, matched by name. Registered teachers (users with a teacher
 * profile) come from POST /search/other_profiles with `profile_filter: teacher_profile`.
 * A blank `q` returns no results.
 *
 */
export const postSearchFitTeachers = <ThrowOnError extends boolean = false>(
  options?: Options<PostSearchFitTeachersData, ThrowOnError>
): RequestResult<PostSearchFitTeachersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSearchFitTeachersResponses,
    unknown,
    ThrowOnError
  >({
    url: '/search/fit_teachers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Logs in a user with email and password
 *
 * Classic email/password login. Fails if the account is not confirmed yet (and re-sends the confirmation email), or the password is wrong. On success, creates and returns a new Session. No X-Api-Key needed.
 */
export const postSessions = <ThrowOnError extends boolean = false>(
  options?: Options<PostSessionsData, ThrowOnError>
): RequestResult<PostSessionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSessionsResponses,
    unknown,
    ThrowOnError
  >({
    url: '/sessions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Logs in a user with Google
 *
 * Signs in (or signs up) via Google OAuth. `token` is a Google access token (or an ID
 * token, a JWT, when the platform only provides that), verified server-side against
 * Google's tokeninfo endpoint. The token must have been issued to one of the
 * TennisTalker OAuth clients (`aud`/`azp`) and carry a Google-verified email. The
 * account is the one the token proves: `uid` and `email`, when sent, must BOTH match
 * it, otherwise the login fails. `photo` is downloaded only from public http(s)
 * addresses. On success a new Session is created for the matching (or newly created)
 * User and returned. No X-Api-Key needed.
 *
 */
export const postSessionsGoogleAuth = <ThrowOnError extends boolean = false>(
  options?: Options<PostSessionsGoogleAuthData, ThrowOnError>
): RequestResult<PostSessionsGoogleAuthResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostSessionsGoogleAuthResponses,
    unknown,
    ThrowOnError
  >({
    url: '/sessions/google-auth',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Mostra un profilo negozio
 *
 * Public profile page for a shop-type user (a tennis shop/club selling marketplace
 * offers), including its active offers. Public endpoint: X-Api-Key is optional — when
 * present, the response also includes `managed`/`followed` flags for the current user.
 *
 */
export const getShopProfilesById = <ThrowOnError extends boolean = false>(
  options: Options<GetShopProfilesByIdData, ThrowOnError>
): RequestResult<
  GetShopProfilesByIdResponses,
  GetShopProfilesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetShopProfilesByIdResponses,
    GetShopProfilesByIdErrors,
    ThrowOnError
  >({ url: '/shop-profiles/{id}', ...options })

/**
 * Receive order webhook from Shopify
 *
 * Webhook called by Shopify when an order is placed on the TennisTalker store. Grants
 * premium membership when the order includes one of the configured premium product
 * IDs. Not part of the app's own client API — authenticated purely via the Shopify
 * HMAC signature (X-Api-Key is not required/used).
 *
 */
export const postShopifyOrder = <ThrowOnError extends boolean = false>(
  options: Options<PostShopifyOrderData, ThrowOnError>
): RequestResult<
  PostShopifyOrderResponses,
  PostShopifyOrderErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostShopifyOrderResponses,
    PostShopifyOrderErrors,
    ThrowOnError
  >({ url: '/shopify/order', ...options })

/**
 * list workouts for the current user
 *
 * Lists workouts synced from the caller's connected smart watch/fitness tracker, newest first, 100 per page.
 */
export const getSmartWatchWorkouts = <ThrowOnError extends boolean = false>(
  options: Options<GetSmartWatchWorkoutsData, ThrowOnError>
): RequestResult<GetSmartWatchWorkoutsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetSmartWatchWorkoutsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/smart_watch_workouts',
    ...options,
  })

/**
 * sync a single workout from device
 *
 * Creates one workout for the caller from a device sync (e.g. HealthKit). The workout starts in `pending` status until it's associated with an Activity or dismissed via `PATCH /smart_watch_workouts/{id}`.
 */
export const postSmartWatchWorkouts = <ThrowOnError extends boolean = false>(
  options: Options<PostSmartWatchWorkoutsData, ThrowOnError>
): RequestResult<
  PostSmartWatchWorkoutsResponses,
  PostSmartWatchWorkoutsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostSmartWatchWorkoutsResponses,
    PostSmartWatchWorkoutsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/smart_watch_workouts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * bulk sync workouts from device
 *
 * Batch version of the single-workout sync, for catching up a device's full history in one call. Uses an upsert-style bulk insert keyed on `(user, platform_id)`, so re-submitting the same `platform_id` for this user is a no-op rather than an error — safe to retry or re-send overlapping batches.
 */
export const postSmartWatchWorkoutsBulk = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostSmartWatchWorkoutsBulkData, ThrowOnError>
): RequestResult<PostSmartWatchWorkoutsBulkResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    PostSmartWatchWorkoutsBulkResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/smart_watch_workouts/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * delete a workout
 *
 * Deletes one of the caller's own workouts.
 */
export const deleteSmartWatchWorkoutsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteSmartWatchWorkoutsByIdData, ThrowOnError>
): RequestResult<
  DeleteSmartWatchWorkoutsByIdResponses,
  DeleteSmartWatchWorkoutsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteSmartWatchWorkoutsByIdResponses,
    DeleteSmartWatchWorkoutsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/smart_watch_workouts/{id}',
    ...options,
  })

/**
 * get a single workout
 *
 * Returns one of the caller's own workouts by id.
 */
export const getSmartWatchWorkoutsById = <ThrowOnError extends boolean = false>(
  options: Options<GetSmartWatchWorkoutsByIdData, ThrowOnError>
): RequestResult<
  GetSmartWatchWorkoutsByIdResponses,
  GetSmartWatchWorkoutsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetSmartWatchWorkoutsByIdResponses,
    GetSmartWatchWorkoutsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/smart_watch_workouts/{id}',
    ...options,
  })

/**
 * associate with an activity or dismiss
 *
 * Resolves a `pending` workout: set `status: associated` with an `activity_id` to attach it to one of the caller's own Activity feed entries (used to show heart-rate/distance stats on a Training or Match), or `status: dismissed` to clear it from the pending queue without linking it.
 */
export const patchSmartWatchWorkoutsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchSmartWatchWorkoutsByIdData, ThrowOnError>
): RequestResult<
  PatchSmartWatchWorkoutsByIdResponses,
  PatchSmartWatchWorkoutsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchSmartWatchWorkoutsByIdResponses,
    PatchSmartWatchWorkoutsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/smart_watch_workouts/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Latest Instagram and TikTok posts
 *
 * Public. The latest posts of the TennisTalker Instagram and TikTok profiles that have a link
 * on Later (the link-in-bio tool), cached for 15 minutes. If Later fails the last good copy
 * is served.
 *
 */
export const getSocialFeed = <ThrowOnError extends boolean = false>(
  options?: Options<GetSocialFeedData, ThrowOnError>
): RequestResult<GetSocialFeedResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetSocialFeedResponses,
    unknown,
    ThrowOnError
  >({ url: '/social-feed', ...options })

/**
 * Get tournament details
 *
 * A tournament is a single gender/age/rankings-category/surface bracket within a
 * parent Competition (e.g. "Men Singles" at the "Rome Open"). Returns the
 * tournament's own metadata, its parent competition (a reduced
 * TournamentCompetition shape), the entry list (`list_participants`, plus
 * `participants_by_rank` grouped by rank bucket), and its draw(s) — each an
 * elimination bracket of matches. When `with_eval` is true, additional computed
 * difficulty/confidence metrics (`absolute_level`, `danger_index`,
 * `personal_difficulty`, `confidence_score`, ...) are included for the caller: this
 * is Radar Tornei, computed only for a Membership user with a linked FIT profile and
 * silently omitted for everyone else.
 *
 */
export const getTournamentsById = <ThrowOnError extends boolean = false>(
  options: Options<GetTournamentsByIdData, ThrowOnError>
): RequestResult<
  GetTournamentsByIdResponses,
  GetTournamentsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTournamentsByIdResponses,
    GetTournamentsByIdErrors,
    ThrowOnError
  >({ url: '/tournaments/{id}', ...options })

/**
 * Create a new training schedule
 *
 * Adds a recurring weekly rule (a TrainingSchedule) to one of the caller's own trainings — used to generate repeat occurrences of that training template. Only one active schedule per day of week is allowed per training; a duplicate `day_of_week` returns 422.
 */
export const postTrainingsByTrainingIdTrainingSchedules = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostTrainingsByTrainingIdTrainingSchedulesData, ThrowOnError>
): RequestResult<
  PostTrainingsByTrainingIdTrainingSchedulesResponses,
  PostTrainingsByTrainingIdTrainingSchedulesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostTrainingsByTrainingIdTrainingSchedulesResponses,
    PostTrainingsByTrainingIdTrainingSchedulesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/trainings/{training_id}/training_schedules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List active training schedules for current user
 *
 * Lists every active recurring schedule across all trainings the caller authored (not just one training).
 */
export const getTrainingSchedules = <ThrowOnError extends boolean = false>(
  options?: Options<GetTrainingSchedulesData, ThrowOnError>
): RequestResult<GetTrainingSchedulesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetTrainingSchedulesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/training_schedules',
    ...options,
  })

/**
 * Deactivate a training schedule (Soft Delete)
 *
 * Soft-deletes a schedule (sets `active: false`) rather than destroying the row, so it stops generating new training occurrences but its history is preserved. The freed-up day of week can then be reused by a new schedule.
 */
export const deleteTrainingSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteTrainingSchedulesByIdData, ThrowOnError>
): RequestResult<
  DeleteTrainingSchedulesByIdResponses,
  DeleteTrainingSchedulesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteTrainingSchedulesByIdResponses,
    DeleteTrainingSchedulesByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/training_schedules/{id}',
    ...options,
  })

/**
 * Update a training schedule
 *
 * Updates a schedule belonging to one of the caller's own trainings (day of week, active window, or active flag). Not found (404) if the schedule doesn't exist or its training belongs to someone else.
 */
export const patchTrainingSchedulesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchTrainingSchedulesByIdData, ThrowOnError>
): RequestResult<
  PatchTrainingSchedulesByIdResponses,
  PatchTrainingSchedulesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchTrainingSchedulesByIdResponses,
    PatchTrainingSchedulesByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/training_schedules/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * get trainings list
 *
 * Lists trainings visible to the caller (their own, plus any they participate in or are the assigned teacher of), newest first, 100 per page.
 */
export const getTrainings = <ThrowOnError extends boolean = false>(
  options: Options<GetTrainingsData, ThrowOnError>
): RequestResult<GetTrainingsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetTrainingsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/trainings',
    ...options,
  })

/**
 * create training
 *
 * Creates a training session with the caller as its author. `teacher_signed_id`
 * (format `"User_123"` / `"FitPlayerProfile_456"`) links an existing app user/player as
 * teacher; if omitted, `teacher_name` is stored as a free-text name instead.
 *
 * Creating a training also creates an Activity feed entry for the author (and one for
 * each participant) — `activity_note`/`activity_visible` control that entry's note and
 * visibility (default: visible, no note).
 *
 */
export const postTrainings = <ThrowOnError extends boolean = false>(
  options: Options<PostTrainingsData, ThrowOnError>
): RequestResult<PostTrainingsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    PostTrainingsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/trainings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * delete training
 *
 * Deletes a training and its associated activities/schedules. Only the training's own author can delete it — anyone else gets a 403.
 */
export const deleteTrainingsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteTrainingsByIdData, ThrowOnError>
): RequestResult<DeleteTrainingsByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteTrainingsByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/trainings/{id}',
    ...options,
  })

/**
 * get training by id
 *
 * Returns a single training by id, with its teacher, author, and participants.
 */
export const getTrainingsById = <ThrowOnError extends boolean = false>(
  options: Options<GetTrainingsByIdData, ThrowOnError>
): RequestResult<GetTrainingsByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetTrainingsByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/trainings/{id}',
    ...options,
  })

/**
 * update training
 *
 * Updates a training. Only the training's own author can update it — anyone else gets a 403. `training_participations_attributes` accepts `_destroy: true` entries to remove a participant.
 */
export const putTrainingsById = <ThrowOnError extends boolean = false>(
  options: Options<PutTrainingsByIdData, ThrowOnError>
): RequestResult<
  PutTrainingsByIdResponses,
  PutTrainingsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutTrainingsByIdResponses,
    PutTrainingsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/trainings/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * contatori della pagina Aggiornamenti
 *
 * Notifiche non viste (messaggi esclusi), conversazioni con messaggi non letti e la loro somma.
 */
export const getUsersUpdatesCounters = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersUpdatesCountersData, ThrowOnError>
): RequestResult<
  GetUsersUpdatesCountersResponses,
  GetUsersUpdatesCountersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersUpdatesCountersResponses,
    GetUsersUpdatesCountersErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/counters',
    ...options,
  })

/**
 * feed delle notifiche
 *
 * Notifiche dell'utente esclusi messaggi ed eliminate, dalla più recente, a pagine con cursore. Non segna niente come letto né come visto.
 */
export const getUsersUpdatesNotifications = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUsersUpdatesNotificationsData, ThrowOnError>
): RequestResult<
  GetUsersUpdatesNotificationsResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersUpdatesNotificationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/notifications',
    ...options,
  })

/**
 * segna viste le notifiche
 *
 * Imposta `seen_at` su tutte le notifiche non viste del feed (messaggi esclusi). Non tocca `read_at`.
 */
export const putUsersUpdatesNotificationsSeen = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PutUsersUpdatesNotificationsSeenData, ThrowOnError>
): RequestResult<
  PutUsersUpdatesNotificationsSeenResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).put<
    PutUsersUpdatesNotificationsSeenResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/notifications/seen',
    ...options,
  })

/**
 * segna tutte come lette
 *
 * Segna lette (e viste) tutte le notifiche del feed. Non tocca messaggi e conversazioni.
 */
export const putUsersUpdatesNotificationsReadAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PutUsersUpdatesNotificationsReadAllData, ThrowOnError>
): RequestResult<
  PutUsersUpdatesNotificationsReadAllResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).put<
    PutUsersUpdatesNotificationsReadAllResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/notifications/read_all',
    ...options,
  })

/**
 * segna letta una notifica
 *
 * Segna letta (e vista) una notifica del feed dell'utente.
 */
export const putUsersUpdatesNotificationsByIdRead = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUsersUpdatesNotificationsByIdReadData, ThrowOnError>
): RequestResult<
  PutUsersUpdatesNotificationsByIdReadResponses,
  PutUsersUpdatesNotificationsByIdReadErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersUpdatesNotificationsByIdReadResponses,
    PutUsersUpdatesNotificationsByIdReadErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/notifications/{id}/read',
    ...options,
  })

/**
 * segna non letta una notifica
 *
 * La riga torna «da leggere». `seen_at` non cambia, quindi i contatori non risalgono.
 */
export const putUsersUpdatesNotificationsByIdUnread = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUsersUpdatesNotificationsByIdUnreadData, ThrowOnError>
): RequestResult<
  PutUsersUpdatesNotificationsByIdUnreadResponses,
  PutUsersUpdatesNotificationsByIdUnreadErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersUpdatesNotificationsByIdUnreadResponses,
    PutUsersUpdatesNotificationsByIdUnreadErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/notifications/{id}/unread',
    ...options,
  })

/**
 * segna lette le notifiche che portano a una destinazione
 *
 * Per il tocco sulla push e per le destinazioni raggiunte da un'altra strada: segna lette TUTTE le notifiche del feed con quella `destination_url` esatta (arrivare in un posto legge ogni notifica che portava lì). I messaggi non sono nel feed e non vengono toccati: le loro notifiche si leggono aprendo la conversazione. Risponde 200 anche se non ne trova.
 */
export const putUsersUpdatesNotificationsReadByDestination = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutUsersUpdatesNotificationsReadByDestinationData,
    ThrowOnError
  >
): RequestResult<
  PutUsersUpdatesNotificationsReadByDestinationResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersUpdatesNotificationsReadByDestinationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/notifications/read_by_destination',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * elimina una notifica
 *
 * Soft delete: la notifica sparisce dal feed, dai contatori e dagli endpoint vecchi. Si ripristina con /restore («Annulla»).
 */
export const deleteUsersUpdatesNotificationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteUsersUpdatesNotificationsByIdData, ThrowOnError>
): RequestResult<
  DeleteUsersUpdatesNotificationsByIdResponses,
  DeleteUsersUpdatesNotificationsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteUsersUpdatesNotificationsByIdResponses,
    DeleteUsersUpdatesNotificationsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/notifications/{id}',
    ...options,
  })

/**
 * ripristina una notifica eliminata
 *
 * «Annulla» dopo l'eliminazione.
 */
export const putUsersUpdatesNotificationsByIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUsersUpdatesNotificationsByIdRestoreData, ThrowOnError>
): RequestResult<
  PutUsersUpdatesNotificationsByIdRestoreResponses,
  PutUsersUpdatesNotificationsByIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersUpdatesNotificationsByIdRestoreResponses,
    PutUsersUpdatesNotificationsByIdRestoreErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/notifications/{id}/restore',
    ...options,
  })

/**
 * non ricevere più notifiche come questa
 *
 * Spegne la preferenza collegata al tipo della notifica (`mutable_setting`), come l'interruttore nelle Impostazioni.
 */
export const putUsersUpdatesNotificationsByIdMute = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUsersUpdatesNotificationsByIdMuteData, ThrowOnError>
): RequestResult<
  PutUsersUpdatesNotificationsByIdMuteResponses,
  PutUsersUpdatesNotificationsByIdMuteErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersUpdatesNotificationsByIdMuteResponses,
    PutUsersUpdatesNotificationsByIdMuteErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/notifications/{id}/mute',
    ...options,
  })

/**
 * conversazioni della scheda Messaggi
 *
 * Conversazioni di tutti i profili dell'utente, dall'ultimo messaggio più recente. Utente e giocatore della stessa persona sono una conversazione sola; circolo e negozio restano separati. Rispondi come `profile` a `counterpart_ref`, aprendo la conversazione con `merged=true`.
 */
export const getUsersUpdatesConversations = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUsersUpdatesConversationsData, ThrowOnError>
): RequestResult<
  GetUsersUpdatesConversationsResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersUpdatesConversationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/updates/conversations',
    ...options,
  })

/**
 * delete a user (admin only)
 *
 * Permanently deletes a user account. Restricted to admin/banner_manager/censor_manager roles; any other caller gets 401.
 */
export const deleteUsersById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUsersByIdData, ThrowOnError>
): RequestResult<
  DeleteUsersByIdResponses,
  DeleteUsersByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteUsersByIdResponses,
    DeleteUsersByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}',
    ...options,
  })

/**
 * get user by id
 *
 * Returns a user profile plus their 5 most recent posts. Public — X-Api-Key is optional and doesn't change the response.
 */
export const getUsersById = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersByIdData, ThrowOnError>
): RequestResult<GetUsersByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetUsersByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}',
    ...options,
  })

/**
 * update a user (admin only)
 *
 * Updates arbitrary attributes on any user. Restricted to admin/banner_manager/censor_manager roles (CanCan `:manage`); any other caller gets 401.
 */
export const patchUsersById = <ThrowOnError extends boolean = false>(
  options: Options<PatchUsersByIdData, ThrowOnError>
): RequestResult<PatchUsersByIdResponses, PatchUsersByIdErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    PatchUsersByIdResponses,
    PatchUsersByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list users (admin only)
 *
 * Paginated listing of every user (20 per page), newest first. Restricted to admin/banner_manager/censor_manager roles.
 */
export const getUsers = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersData, ThrowOnError>
): RequestResult<GetUsersResponses, GetUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetUsersResponses,
    GetUsersErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users',
    ...options,
  })

/**
 * search users
 *
 * Backoffice search: users by email substring, full name, or exact numeric id. Restricted to admin/banner_manager/censor_manager roles. Returns the paginated `{total_pages, page, users}` shape for a non-blank `q`; a blank/missing `q` short-circuits to a bare empty array `[]` instead.
 */
export const getUsersSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersSearchData, ThrowOnError>
): RequestResult<GetUsersSearchResponses, GetUsersSearchErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersSearchResponses,
    GetUsersSearchErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/search',
    ...options,
  })

/**
 * Advanced search for users
 *
 * Paginated, filterable user search, filtering on user fields and, for users with a
 * linked FIT player profile, on the profile (gender, club region/province, age
 * category, rank). Requires X-Api-Key.
 *
 * - Any logged-in user can use the public filters; they only see users who are not
 * banned, not service accounts and not opted out of discovery (`discoverable: false`).
 * - `region`, `province`, `age_categories` and `ranks` are premium filters (403
 * without an active Club Membership), as in the FIT player advanced search.
 * - Admin filters (email, premium, sign-up date, activity, platform, ...), the admin
 * sorts and `with_summary` are reserved to admins: anyone else gets 403 naming the
 * filters. Admins see every user and get the private `admin` block on each result.
 *
 */
export const postUsersAdvancedSearch = <ThrowOnError extends boolean = false>(
  options?: Options<PostUsersAdvancedSearchData, ThrowOnError>
): RequestResult<
  PostUsersAdvancedSearchResponses,
  PostUsersAdvancedSearchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostUsersAdvancedSearchResponses,
    PostUsersAdvancedSearchErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/advanced-search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Filter options for the user advanced search
 *
 * Option lists for the advanced search filters. The admin-only lists (`admin_filters`, `roles`, `platforms`, `login_methods`) are empty and `sorts` has only the public sorts for non-admins. Requires X-Api-Key.
 */
export const getUsersAdvancedSearchFilters = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUsersAdvancedSearchFiltersData, ThrowOnError>
): RequestResult<
  GetUsersAdvancedSearchFiltersResponses,
  GetUsersAdvancedSearchFiltersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersAdvancedSearchFiltersResponses,
    GetUsersAdvancedSearchFiltersErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/advanced-search/filters',
    ...options,
  })

/**
 * Full admin card of a user
 *
 * Admin only (CanCan `:manage` on the user): the user as an admin advanced search result
 * plus activity counters (total, last 30 days, latest), Match Finder matches by status,
 * membership (codes, Recharge subscriptions, Shopify checkouts), FIT card link requests,
 * current sessions with login method, source and client version, and the linked FIT player
 * page (the visit is not recorded). Meant to be loaded when the backoffice opens the user
 * dialog. Requires X-Api-Key.
 *
 */
export const getUsersByIdAdminDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersByIdAdminDetailsData, ThrowOnError>
): RequestResult<
  GetUsersByIdAdminDetailsResponses,
  GetUsersByIdAdminDetailsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUsersByIdAdminDetailsResponses,
    GetUsersByIdAdminDetailsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/admin-details',
    ...options,
  })

/**
 * Notifications received by a user (admin)
 *
 * Admin only: every notification the user received, messages and deleted ones included, newest first, 30 per page, plus counts over all of them. Requires X-Api-Key.
 */
export const getUsersByIdAdminNotifications = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsersByIdAdminNotificationsData, ThrowOnError>
): RequestResult<
  GetUsersByIdAdminNotificationsResponses,
  GetUsersByIdAdminNotificationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUsersByIdAdminNotificationsResponses,
    GetUsersByIdAdminNotificationsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/admin-notifications',
    ...options,
  })

/**
 * Activity timeline of a user (admin)
 *
 * Admin only: what the user did, newest first (sign-up, current sessions, membership codes, Recharge subscriptions, checkouts, FIT card requests, posts, comments, follows, played and organised matches, trainings, workouts, offers, reports, blocks, live event games, ban). Paginated by time. Requires X-Api-Key.
 */
export const getUsersByIdAdminTimeline = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersByIdAdminTimelineData, ThrowOnError>
): RequestResult<
  GetUsersByIdAdminTimelineResponses,
  GetUsersByIdAdminTimelineErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUsersByIdAdminTimelineResponses,
    GetUsersByIdAdminTimelineErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/admin-timeline',
    ...options,
  })

/**
 * find nearby users
 *
 * Experimental: returns up to 20 users within `radius` km of the given point (default 20km). Both `lat` and `lng` are required and must be non-zero.
 */
export const getUsersNearby = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersNearbyData, ThrowOnError>
): RequestResult<GetUsersNearbyResponses, GetUsersNearbyErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersNearbyResponses,
    GetUsersNearbyErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/nearby',
    ...options,
  })

/**
 * get user posts
 *
 * Paginated feed of posts authored by the given user. X-Api-Key is optional.
 */
export const getUsersByIdPosts = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersByIdPostsData, ThrowOnError>
): RequestResult<GetUsersByIdPostsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersByIdPostsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/posts',
    ...options,
  })

/**
 * get user preview
 *
 * Lightweight public preview of a user (name, photo, ...), used where the full profile would be overkill. Public — no X-Api-Key required.
 */
export const getUsersByIdPreview = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersByIdPreviewData, ThrowOnError>
): RequestResult<GetUsersByIdPreviewResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersByIdPreviewResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/preview',
    ...options,
  })

/**
 * get user notifications
 *
 * Paginated notification history for the current user (10 per page), newest first. Side effect: marks every one of the current user's notifications as read and bumps `notifications_last_seen` — calling this "consumes" the unread badge. For a peek that doesn't mark-as-read, use notifications_dropdown instead.
 */
export const getUsersNotifications = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersNotificationsData, ThrowOnError>
): RequestResult<GetUsersNotificationsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersNotificationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/notifications',
    ...options,
  })

/**
 * get user notifications dropdown
 *
 * Unread-only notifications for the header/dropdown widget, newest first. Unlike GET /users/notifications, this does NOT mark them as read.
 */
export const getUsersNotificationsDropdown = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsersNotificationsDropdownData, ThrowOnError>
): RequestResult<
  GetUsersNotificationsDropdownResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUsersNotificationsDropdownResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/notifications_dropdown',
    ...options,
  })

/**
 * clear user notifications by type
 *
 * Marks all of the current user's unread notifications of a given type as read. `type` must be one of a fixed allowlist of notifier class names (see UsersController#clear_notifications_by_type) — anything else returns 400 with success: false.
 */
export const putUsersClearNotificationsByType = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUsersClearNotificationsByTypeData, ThrowOnError>
): RequestResult<
  PutUsersClearNotificationsByTypeResponses,
  PutUsersClearNotificationsByTypeErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersClearNotificationsByTypeResponses,
    PutUsersClearNotificationsByTypeErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/clear_notifications_by_type',
    ...options,
  })

/**
 * mark notification as read
 *
 * Marks a single notification (belonging to the current user) as read by id.
 */
export const putUsersReadNotification = <ThrowOnError extends boolean = false>(
  options: Options<PutUsersReadNotificationData, ThrowOnError>
): RequestResult<
  PutUsersReadNotificationResponses,
  PutUsersReadNotificationErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersReadNotificationResponses,
    PutUsersReadNotificationErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/read_notification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * get user followers list
 *
 * Returns the list of users/fit player profiles following the given user.
 */
export const getUsersFollowersListById = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFollowersListByIdData, ThrowOnError>
): RequestResult<GetUsersFollowersListByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersFollowersListByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/followers_list/{id}',
    ...options,
  })

/**
 * get preferred surfaces
 *
 * Static reference list of court surface options usable as a user's preferred_surface. Public — no X-Api-Key required.
 */
export const getUsersPreferredSurfaces = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersPreferredSurfacesData, ThrowOnError>
): RequestResult<GetUsersPreferredSurfacesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetUsersPreferredSurfacesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/preferred_surfaces',
    ...options,
  })

/**
 * get teacher qualifications
 *
 * Static reference list of qualification options for a teacher_profile. Public — no X-Api-Key required.
 */
export const getUsersTeacherQualifications = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUsersTeacherQualificationsData, ThrowOnError>
): RequestResult<
  GetUsersTeacherQualificationsResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersTeacherQualificationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/teacher_qualifications',
    ...options,
  })

/**
 * get trainer qualifications
 *
 * Static reference list of qualification options for a trainer_profile. Public — no X-Api-Key required.
 */
export const getUsersTrainerQualifications = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUsersTrainerQualificationsData, ThrowOnError>
): RequestResult<
  GetUsersTrainerQualificationsResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersTrainerQualificationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/trainer_qualifications',
    ...options,
  })

/**
 * get facebook info by token
 *
 * Despite the name, `token` here is the account's confirmation_token (not a Facebook access token) — used to prefill the sign-up "additional info" step with the name/photo captured at Facebook login. Returns an empty object if the token doesn't match a user. Public — no X-Api-Key required.
 */
export const getUsersFacebookInfoByToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsersFacebookInfoByTokenData, ThrowOnError>
): RequestResult<GetUsersFacebookInfoByTokenResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersFacebookInfoByTokenResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/facebook-info/{token}',
    ...options,
  })

/**
 * confirm user account
 *
 * Confirms the account matching an unconfirmed user's confirmation_token, then immediately logs them in by creating and returning a new Session — this is effectively the last step of email confirmation from a clicked link. Fails with success: false if the token doesn't match an unconfirmed account. Public — no X-Api-Key required.
 */
export const getUsersConfirmAccountByToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsersConfirmAccountByTokenData, ThrowOnError>
): RequestResult<
  GetUsersConfirmAccountByTokenResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUsersConfirmAccountByTokenResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/confirm-account/{token}',
    ...options,
  })

/**
 * send account confirmation email
 *
 * Re-sends the account confirmation email for the given address. Returns success: false with an error if the email doesn't match any user. Public — no X-Api-Key required.
 */
export const postUsersAccountConfirmationEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUsersAccountConfirmationEmailData, ThrowOnError>
): RequestResult<
  PostUsersAccountConfirmationEmailResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUsersAccountConfirmationEmailResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/account-confirmation-email',
    ...options,
  })

/**
 * get fit player id by token
 *
 * Given a confirmation_token, returns the linked FIT player id for that account (empty string if the token is invalid or no fit player profile is linked yet). Public — no X-Api-Key required.
 */
export const getUsersByTokenFitPlayerId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsersByTokenFitPlayerIdData, ThrowOnError>
): RequestResult<GetUsersByTokenFitPlayerIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersByTokenFitPlayerIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{token}/fit-player-id',
    ...options,
  })

/**
 * get user feed
 *
 * Mixed feed of posts: the caller's own (as the `type`+`id` masqueraded identity — a
 * User or FitPlayerProfile the caller manages) plus posts from followed users/profiles.
 * Pass `all=true` to instead get a global, non-personalized feed (ignores `type`/`id`).
 * `type`/`id` are required and authorized (403/401) when `all` isn't `true`: `id` must
 * be a User or FitPlayerProfile the caller manages.
 *
 */
export const getUsersFeed = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFeedData, ThrowOnError>
): RequestResult<GetUsersFeedResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<GetUsersFeedResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/feed',
    ...options,
  })

/**
 * get user feed posts
 *
 * Like GET /users/feed, but excludes shared news items — posts-only feed. Same `all`/`type`/`id` semantics.
 */
export const getUsersFeedPosts = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFeedPostsData, ThrowOnError>
): RequestResult<GetUsersFeedPostsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersFeedPostsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/feed-posts',
    ...options,
  })

/**
 * get user feed matches
 *
 * Matches feed: all matches involving followed users/profiles, or every match when `all=true`. Unlike the other feed endpoints, `type`/`id` are not actually used to scope this one, despite being accepted.
 */
export const getUsersFeedMatches = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFeedMatchesData, ThrowOnError>
): RequestResult<GetUsersFeedMatchesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersFeedMatchesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/feed-matches',
    ...options,
  })

/**
 * get user feed offers
 *
 * Marketplace offers feed: the caller's own (as the `type`+`id` masqueraded identity) plus offers from followed users/profiles, or every offer when `all=true`. Same authorization rules as GET /users/feed.
 */
export const getUsersFeedOffers = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFeedOffersData, ThrowOnError>
): RequestResult<GetUsersFeedOffersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersFeedOffersResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/feed-offers',
    ...options,
  })

/**
 * get news feed
 *
 * Paginated feed of aggregated tennis news posts (FeedNews), not scoped to the current user's follows.
 */
export const getUsersFeedNews = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFeedNewsData, ThrowOnError>
): RequestResult<GetUsersFeedNewsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersFeedNewsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/feed-news',
    ...options,
  })

/**
 * get user market offers
 *
 * Despite the name, this returns the CURRENT user's own posted offers (not a marketplace browse of others' offers) — a "my listings" view. Optionally filtered by `category_id`.
 */
export const postUsersMarket = <ThrowOnError extends boolean = false>(
  options: Options<PostUsersMarketData, ThrowOnError>
): RequestResult<PostUsersMarketResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    PostUsersMarketResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/market',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * get user matches
 *
 * Paginated, filterable list of self-reported UserMatches involving the current user (as either their User or FitPlayerProfile identity) — played matches, matches to organise and challenges. All query params below are optional filters.
 */
export const getUsersUserMatches = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersUserMatchesData, ThrowOnError>
): RequestResult<GetUsersUserMatchesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetUsersUserMatchesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/user-matches',
    ...options,
  })

/**
 * create user match from user profile
 *
 * Records a self-reported match result. Reference the other players with `opponentable_*`/`teammateable_*`/`second_opponentable_*` (type + id; a User with a FIT profile is stored as the profile); the legacy `*_id` fields are FitPlayerProfile ids. Leave them null and set `opponent_name` instead for an off-platform opponent. `authorable_type`/`authorable_id` optionally set who's recorded as the author (defaults to the current user).
 */
export const postUsersUserMatches = <ThrowOnError extends boolean = false>(
  options: Options<PostUsersUserMatchesData, ThrowOnError>
): RequestResult<PostUsersUserMatchesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    PostUsersUserMatchesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/user-matches',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * accept market conditions
 *
 * Sets market_condition_accepted to true for the current user (one-time acceptance of the marketplace terms, gating access to Offers features).
 */
export const putUsersMarketConditionAccepted = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUsersMarketConditionAcceptedData, ThrowOnError>
): RequestResult<
  PutUsersMarketConditionAcceptedResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersMarketConditionAcceptedResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/market-condition-accepted',
    ...options,
  })

/**
 * check fit club id
 *
 * Checks whether a FIT club id exists and, if the caller already manages a different club, flags that a reassignment would be needed. Always returns success: true (even "not found" is reported via the `error` field, not a failed status). X-Api-Key is not required by this action.
 */
export const postUsersCheckFitClubId = <ThrowOnError extends boolean = false>(
  options?: Options<PostUsersCheckFitClubIdData, ThrowOnError>
): RequestResult<PostUsersCheckFitClubIdResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostUsersCheckFitClubIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/check-fit-club-id',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * check user sessions and status
 *
 * Checks whether the X-Api-Key resolves to a premium user's session. Doesn't 401 on a missing/invalid key — just returns success: false.
 */
export const getUsersCheckStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersCheckStatusData, ThrowOnError>
): RequestResult<GetUsersCheckStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetUsersCheckStatusResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/check-status',
    ...options,
  })

/**
 * sync contacts and create follows
 *
 * Given a device contact list (phone numbers and/or emails), matches them against existing TennisTalker accounts and auto-follows every match on behalf of the current user. Returns success: false (not an error status) when nothing matched.
 */
export const postUsersSyncContacts = <ThrowOnError extends boolean = false>(
  options: Options<PostUsersSyncContactsData, ThrowOnError>
): RequestResult<
  PostUsersSyncContactsResponses,
  PostUsersSyncContactsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUsersSyncContactsResponses,
    PostUsersSyncContactsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/sync_contacts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * redeem a premium token
 *
 * Redeems a premium token code, granting premium status. Note: the `id` in the path is
 * NOT actually used — the token is always applied to the caller (the user identified by
 * X-Api-Key), regardless of what id is in the URL. As a side effect, destroys every
 * other active session for this user.
 *
 */
export const postUsersByIdPremiumize = <ThrowOnError extends boolean = false>(
  options: Options<PostUsersByIdPremiumizeData, ThrowOnError>
): RequestResult<PostUsersByIdPremiumizeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    PostUsersByIdPremiumizeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/premiumize',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * ban a user (admin only)
 *
 * Bans a user and permanently destroys all of their messages, posts and comments. Restricted to admin/banner_manager/censor_manager roles.
 */
export const putUsersByIdBan = <ThrowOnError extends boolean = false>(
  options: Options<PutUsersByIdBanData, ThrowOnError>
): RequestResult<
  PutUsersByIdBanResponses,
  PutUsersByIdBanErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersByIdBanResponses,
    PutUsersByIdBanErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/ban',
    ...options,
  })

/**
 * unban a user (admin only)
 *
 * Lifts a ban (clears banned_at/banned_by/ban_notes) — does not restore the messages/posts/comments deleted at ban time. Restricted to admin/banner_manager/censor_manager roles.
 */
export const putUsersByIdUnban = <ThrowOnError extends boolean = false>(
  options: Options<PutUsersByIdUnbanData, ThrowOnError>
): RequestResult<
  PutUsersByIdUnbanResponses,
  PutUsersByIdUnbanErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersByIdUnbanResponses,
    PutUsersByIdUnbanErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/unban',
    ...options,
  })

/**
 * toggle hidden results for a user (admin only)
 *
 * Flips hidden_results on/off for a user (hides their match results/rank from public view when true). Restricted to admin/banner_manager/censor_manager roles.
 */
export const putUsersByIdMarkAsHiddenResults = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUsersByIdMarkAsHiddenResultsData, ThrowOnError>
): RequestResult<
  PutUsersByIdMarkAsHiddenResultsResponses,
  PutUsersByIdMarkAsHiddenResultsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersByIdMarkAsHiddenResultsResponses,
    PutUsersByIdMarkAsHiddenResultsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/mark-as-hidden-results',
    ...options,
  })

/**
 * toggle premium status for a user (admin only)
 *
 * Flips premium on/off for a simple_user/premium_user (also updates their role accordingly); no-op for other roles like admin. Restricted to admin/banner_manager/censor_manager roles.
 */
export const putUsersByIdMarkAsPremiumUser = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUsersByIdMarkAsPremiumUserData, ThrowOnError>
): RequestResult<
  PutUsersByIdMarkAsPremiumUserResponses,
  PutUsersByIdMarkAsPremiumUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersByIdMarkAsPremiumUserResponses,
    PutUsersByIdMarkAsPremiumUserErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/mark-as-premium-user',
    ...options,
  })

/**
 * mark a user as premium with an expiration date (admin only)
 *
 * Grants premium with an explicit expiration date for a simple_user/premium_user (no-op for other roles), and destroys all of that user's active sessions as a side effect. Restricted to admin/banner_manager/censor_manager roles.
 */
export const putUsersByIdMarkAsPremiumUserWithExpirationDate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutUsersByIdMarkAsPremiumUserWithExpirationDateData,
    ThrowOnError
  >
): RequestResult<
  PutUsersByIdMarkAsPremiumUserWithExpirationDateResponses,
  PutUsersByIdMarkAsPremiumUserWithExpirationDateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersByIdMarkAsPremiumUserWithExpirationDateResponses,
    PutUsersByIdMarkAsPremiumUserWithExpirationDateErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/mark-as-premium-user-with-expiration-date',
    ...options,
  })

/**
 * set the premium expiration date for a user (admin only)
 *
 * Updates just the premium_expiration date on an already-premium user (also sets role to premium_user), without the session-destroying side effect of mark-as-premium-user-with-expiration-date. Restricted to admin/banner_manager/censor_manager roles.
 */
export const putUsersByIdSetPremiumExpirationDate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUsersByIdSetPremiumExpirationDateData, ThrowOnError>
): RequestResult<
  PutUsersByIdSetPremiumExpirationDateResponses,
  PutUsersByIdSetPremiumExpirationDateErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUsersByIdSetPremiumExpirationDateResponses,
    PutUsersByIdSetPremiumExpirationDateErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/set-premium-expiration-date',
    ...options,
  })

/**
 * Versione minima supportata, per piattaforma
 *
 * Returns the minimum app version still supported, per platform, used by the client's
 * forced-update gate at startup (including logged-out users, hence no auth required).
 * Values are read from the `MIN_APP_VERSION_IOS` / `MIN_APP_VERSION_ANDROID` env vars and
 * can be changed without a deploy. If an env var is missing or not a valid `x.y.z` semver
 * string, the response silently falls back to a known-safe floor instead of bricking
 * every client on a typo. Response is cacheable for 5 minutes.
 *
 */
export const getAppVersion = <ThrowOnError extends boolean = false>(
  options?: Options<GetAppVersionData, ThrowOnError>
): RequestResult<GetAppVersionResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetAppVersionResponses,
    unknown,
    ThrowOnError
  >({ url: '/app-version', ...options })

/**
 * Lista i bonus del profilo giocatore corrente
 *
 * I bonus sono punti extra aggiunti manualmente al ranking di un fit_player_profile
 * (es. bonus federali), sommati ai fit_points calcolati automaticamente. Opera sempre
 * sul fit_player_profile collegato all'utente chiamante. Richiede X-Api-Key; risponde
 * 404 se l'utente non ha un profilo giocatore collegato.
 *
 */
export const getBonuses = <ThrowOnError extends boolean = false>(
  options?: Options<GetBonusesData, ThrowOnError>
): RequestResult<GetBonusesResponses, GetBonusesErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetBonusesResponses,
    GetBonusesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/bonuses',
    ...options,
  })

/**
 * Crea un nuovo bonus per il profilo giocatore corrente
 *
 * Aggiunge un bonus al fit_player_profile dell'utente chiamante e invalida la cache
 * dati/statistiche del giocatore per quell'anno. Richiede X-Api-Key; risponde 404 se
 * l'utente non ha un profilo giocatore collegato.
 *
 */
export const postBonuses = <ThrowOnError extends boolean = false>(
  options?: Options<PostBonusesData, ThrowOnError>
): RequestResult<PostBonusesResponses, PostBonusesErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    PostBonusesResponses,
    PostBonusesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/bonuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Elimina un bonus dal profilo giocatore corrente
 *
 * Elimina un bonus del fit_player_profile dell'utente chiamante (un utente non può
 * eliminare i bonus di un altro profilo) e invalida la cache dati/statistiche per
 * quell'anno. Richiede X-Api-Key; risponde 404 se il bonus non esiste o non appartiene
 * al profilo del chiamante.
 *
 */
export const deleteBonusesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteBonusesByIdData, ThrowOnError>
): RequestResult<
  DeleteBonusesByIdResponses,
  DeleteBonusesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteBonusesByIdResponses,
    DeleteBonusesByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/bonuses/{id}',
    ...options,
  })

/**
 * Crea un nuovo commento su un post
 *
 * Adds a comment to a post, on behalf of the entity identified by
 * `masqueraded_type`/`masqueraded_id` (typically the caller's own User). Set
 * `parent_id` to reply to an existing comment on the same post, nesting it under
 * `children`. Requires `X-Api-Key`; validation failures still return HTTP 200 with
 * `success: false` and per-field `errors`, matching this controller's convention.
 *
 */
export const postPostsByPostIdComments = <ThrowOnError extends boolean = false>(
  options: Options<PostPostsByPostIdCommentsData, ThrowOnError>
): RequestResult<PostPostsByPostIdCommentsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<
    PostPostsByPostIdCommentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{post_id}/comments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Elimina un commento
 *
 * Deletes a comment. Requires `X-Api-Key` but, like update, does not currently check comment ownership. Returns 404 for an unknown comment id.
 */
export const deletePostsByPostIdCommentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeletePostsByPostIdCommentsByIdData, ThrowOnError>
): RequestResult<
  DeletePostsByPostIdCommentsByIdResponses,
  DeletePostsByPostIdCommentsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePostsByPostIdCommentsByIdResponses,
    DeletePostsByPostIdCommentsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{post_id}/comments/{id}',
    ...options,
  })

/**
 * Aggiorna un commento
 *
 * Updates a comment's content. Requires `X-Api-Key` but this endpoint does not currently check that the caller authored the comment. As with create, an invalid payload still returns HTTP 200 with `success: false`.
 */
export const patchPostsByPostIdCommentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchPostsByPostIdCommentsByIdData, ThrowOnError>
): RequestResult<
  PatchPostsByPostIdCommentsByIdResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchPostsByPostIdCommentsByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{post_id}/comments/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Restituisce il feed della community
 *
 * Aggregated feed of non-news posts, newest first, 10 per page. `scope` controls
 * which posts are included:
 * - `all` (default): every non-news post, excluding banned authors and posts older
 * than the configured cutoff.
 * - `club`: posts by members of the caller's club (or their fit player profile's
 * club), plus posts published as that club's manager or as the club itself.
 * - `followers`: posts by users the caller follows.
 *
 */
export const getCommunityFeed = <ThrowOnError extends boolean = false>(
  options: Options<GetCommunityFeedData, ThrowOnError>
): RequestResult<
  GetCommunityFeedResponses,
  GetCommunityFeedErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetCommunityFeedResponses,
    GetCommunityFeedErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/community/feed',
    ...options,
  })

/**
 * Invia una richiesta di contatto
 *
 * Support/contact form submission. Delivered asynchronously to Intercom via a
 * background job (CreateIntercomTicketJob); the response does not wait on that
 * delivery, so `success: true` only means the request was accepted and queued, not
 * that any specific field passed validation. Public endpoint: does not require
 * X-Api-Key (accepted here for realism, but not enforced by the controller).
 *
 */
export const postContacts = <ThrowOnError extends boolean = false>(
  options: Options<PostContactsData, ThrowOnError>
): RequestResult<PostContactsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PostContactsResponses, unknown, ThrowOnError>(
    {
      url: '/contacts',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  )

/**
 * Restituisce tutti i custom banners
 *
 * Lista completa (non paginata) di tutti i CustomBanner, piu' recenti prima. Endpoint
 * pubblico: il controller non ha alcun controllo di autenticazione.
 *
 */
export const getCustomBannersAll = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomBannersAllData, ThrowOnError>
): RequestResult<GetCustomBannersAllResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetCustomBannersAllResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners/all',
    ...options,
  })

/**
 * Restituisce i custom banners paginati
 *
 * Lista paginata dei CustomBanner (immagine + URL di destinazione), 20 per pagina.
 * Endpoint pubblico: il controller non ha alcun controllo di autenticazione.
 *
 */
export const getCustomBanners = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomBannersData, ThrowOnError>
): RequestResult<GetCustomBannersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetCustomBannersResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners',
    ...options,
  })

/**
 * Crea un nuovo custom banner
 *
 * Crea un CustomBanner (immagine + URL di destinazione), poi tipicamente assegnato a
 * uno slot tramite POST /positioned-banners. Creazione, modifica ed eliminazione sono
 * riservate a admin/banner_manager/censor_manager.
 *
 */
export const postCustomBanners = <ThrowOnError extends boolean = false>(
  options?: Options<PostCustomBannersData, ThrowOnError>
): RequestResult<
  PostCustomBannersResponses,
  PostCustomBannersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostCustomBannersResponses,
    PostCustomBannersErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Elimina un custom banner
 *
 * Elimina definitivamente un CustomBanner. Nessun controllo di autenticazione o
 * autorizzazione.
 *
 */
export const deleteCustomBannersById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCustomBannersByIdData, ThrowOnError>
): RequestResult<
  DeleteCustomBannersByIdResponses,
  DeleteCustomBannersByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteCustomBannersByIdResponses,
    DeleteCustomBannersByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners/{id}',
    ...options,
  })

/**
 * Mostra un custom banner
 *
 * Dettaglio di un singolo CustomBanner. Endpoint pubblico: nessun controllo di
 * autenticazione.
 *
 */
export const getCustomBannersById = <ThrowOnError extends boolean = false>(
  options: Options<GetCustomBannersByIdData, ThrowOnError>
): RequestResult<
  GetCustomBannersByIdResponses,
  GetCustomBannersByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetCustomBannersByIdResponses,
    GetCustomBannersByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners/{id}',
    ...options,
  })

/**
 * Aggiorna un custom banner
 *
 * Aggiorna (parzialmente) immagine e/o destinazione di un CustomBanner esistente.
 * Nessun controllo di autenticazione o autorizzazione.
 *
 */
export const patchCustomBannersById = <ThrowOnError extends boolean = false>(
  options: Options<PatchCustomBannersByIdData, ThrowOnError>
): RequestResult<
  PatchCustomBannersByIdResponses,
  PatchCustomBannersByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchCustomBannersByIdResponses,
    PatchCustomBannersByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Aggiorna un custom banner
 *
 * Equivalente a PATCH sullo stesso path: entrambi i verbi instradano alla stessa
 * action `update`. Nessun controllo di autenticazione o autorizzazione.
 *
 */
export const putCustomBannersById = <ThrowOnError extends boolean = false>(
  options: Options<PutCustomBannersByIdData, ThrowOnError>
): RequestResult<
  PutCustomBannersByIdResponses,
  PutCustomBannersByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutCustomBannersByIdResponses,
    PutCustomBannersByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Invia un payload di debug a un canale Slack
 *
 * Internal utility endpoint: posts an arbitrary payload to a Slack channel for debugging notification formatting. Not part of the app-facing API contract.
 */
export const postDebugSlack = <ThrowOnError extends boolean = false>(
  options?: Options<PostDebugSlackData, ThrowOnError>
): RequestResult<PostDebugSlackResponses, PostDebugSlackErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    PostDebugSlackResponses,
    PostDebugSlackErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/debug/slack',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Crea un endorsement
 *
 * L'utente chiamante attesta una skill (endorsement_type, es. "dritto potente") su un
 * fit_player_profile di un altro giocatore. Un utente può dare un solo endorsement
 * dello stesso tipo allo stesso giocatore. Risponde comunque 200 anche in caso di
 * errore di validazione: controllare `success`/`errors` nel body. Richiede X-Api-Key.
 *
 */
export const postEndorsements = <ThrowOnError extends boolean = false>(
  options?: Options<PostEndorsementsData, ThrowOnError>
): RequestResult<PostEndorsementsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostEndorsementsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/endorsements',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Elimina un endorsement
 *
 * Ritira un endorsement dato dall'utente chiamante (un utente può eliminare solo i
 * propri endorsement, non quelli di altri). Richiede X-Api-Key; risponde 404 se
 * l'endorsement non esiste o non appartiene al chiamante.
 *
 */
export const deleteEndorsementsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEndorsementsByIdData, ThrowOnError>
): RequestResult<
  DeleteEndorsementsByIdResponses,
  DeleteEndorsementsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteEndorsementsByIdResponses,
    DeleteEndorsementsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/endorsements/{id}',
    ...options,
  })

/**
 * Restituisce le news del feed
 *
 * Public. Lists TennisTalker news articles (posts authored by the official editorial accounts), newest first, 10 per page. `X-Api-Key` is optional and, if present, only affects per-post `liked_by_current_user`.
 */
export const getFeedNews = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeedNewsData, ThrowOnError>
): RequestResult<GetFeedNewsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<GetFeedNewsResponses, unknown, ThrowOnError>({
    url: '/feed_news',
    ...options,
  })

/**
 * Restituisce la lista delle richieste di profilo FIT
 *
 * Le richieste che un utente invia per rivendicare/collegare un profilo giocatore FIT
 * ufficiale al proprio account (vedi PUT /fit-player-profile-requests/{id}/approve e
 * /reject per l'esito). Endpoint di backoffice: richiede un X-Api-Key di un utente
 * admin, banner_manager o censor_manager.
 *
 */
export const getFitPlayerProfileRequests = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetFitPlayerProfileRequestsData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfileRequestsResponses,
  GetFitPlayerProfileRequestsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetFitPlayerProfileRequestsResponses,
    GetFitPlayerProfileRequestsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profile-requests',
    ...options,
  })

/**
 * Approva una richiesta di profilo FIT
 *
 * Approva la richiesta: il profilo FIT viene assegnato all'utente richiedente e le
 * sue sessioni/cache vengono invalidate. Se il profilo e' gia' assegnato allo
 * stesso utente la richiesta viene auto-approvata; se e' assegnato a un altro
 * utente viene auto-rifiutata (con note automatiche al posto di `notes`); se la
 * richiesta non e' piu' pending non cambia nulla. In tutti i casi risponde `200`
 * con la richiesta aggiornata: controllare `status`. Endpoint di backoffice:
 * richiede un utente admin, banner_manager o censor_manager.
 *
 */
export const putFitPlayerProfileRequestsByIdApprove = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutFitPlayerProfileRequestsByIdApproveData, ThrowOnError>
): RequestResult<
  PutFitPlayerProfileRequestsByIdApproveResponses,
  PutFitPlayerProfileRequestsByIdApproveErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutFitPlayerProfileRequestsByIdApproveResponses,
    PutFitPlayerProfileRequestsByIdApproveErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profile-requests/{id}/approve',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Rifiuta una richiesta di profilo FIT
 *
 * Rifiuta la richiesta (anche se era gia' approvata: azzera l'approvazione) e
 * salva `notes` come note di rifiuto. Risponde con la richiesta aggiornata.
 * Endpoint di backoffice: richiede un utente admin, banner_manager o
 * censor_manager.
 *
 */
export const putFitPlayerProfileRequestsByIdReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutFitPlayerProfileRequestsByIdRejectData, ThrowOnError>
): RequestResult<
  PutFitPlayerProfileRequestsByIdRejectResponses,
  PutFitPlayerProfileRequestsByIdRejectErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutFitPlayerProfileRequestsByIdRejectResponses,
    PutFitPlayerProfileRequestsByIdRejectErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profile-requests/{id}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Restituisce gli scontri diretti e gli avversari/circoli in comune con l'utente
 *
 * Come il chiamante si relaziona al giocatore target: scontri diretti (h2h),
 * avversari in comune con le rispettive partite, e compagni di circolo. Feature
 * premium: risponde 403 per utenti non premium. Il chiamante deve avere un
 * fit_player_profile collegato.
 *
 */
export const getFitPlayerProfilesByIdConnections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdConnectionsData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdConnectionsResponses,
  GetFitPlayerProfilesByIdConnectionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdConnectionsResponses,
    GetFitPlayerProfilesByIdConnectionsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/connections',
    ...options,
  })

/**
 * Restituisce i contatori delle connessioni (H2H, avversari in comune, compagni di circolo) tra l'utente e il giocatore target
 *
 * Versione "leggera" di GET /{id}/connections: solo i conteggi (partite/avversari/
 * compagni di circolo in comune), senza le liste complete. Pensata per un badge
 * riassuntivo. Il chiamante deve avere un fit_player_profile collegato.
 *
 */
export const getFitPlayerProfilesByIdConnectionsReduced = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdConnectionsReducedData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdConnectionsReducedResponses,
  GetFitPlayerProfilesByIdConnectionsReducedErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdConnectionsReducedResponses,
    GetFitPlayerProfilesByIdConnectionsReducedErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/connections_reduced',
    ...options,
  })

/**
 * Simulatore premium match tra due giocatori
 *
 * Simula l'esito di un ipotetico match tra il giocatore `id` e `opponent_id`, in
 * base allo storico e alle condizioni indicate (superficie, tipo competizione,
 * tipo campo). Feature premium: risponde 403 per utenti non premium.
 *
 */
export const getFitPlayerProfilesByIdMatchSimulator = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesByIdMatchSimulatorData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesByIdMatchSimulatorResponses,
  GetFitPlayerProfilesByIdMatchSimulatorErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdMatchSimulatorResponses,
    GetFitPlayerProfilesByIdMatchSimulatorErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/match-simulator',
    ...options,
  })

/**
 * Ricerca profili per merge
 *
 * Variante con `q` come segmento di path di GET /fit-player-profiles/search-for-merge
 * (che lo accetta come query string). Stesso scopo: trovare profili duplicati da
 * unire tramite PUT merge/{source}/{destination}.
 *
 */
export const getFitPlayerProfilesSearchForMergeByQ = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetFitPlayerProfilesSearchForMergeByQData, ThrowOnError>
): RequestResult<
  GetFitPlayerProfilesSearchForMergeByQResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetFitPlayerProfilesSearchForMergeByQResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/search-for-merge/{q}',
    ...options,
  })

/**
 * Crea un follow
 *
 * L'utente chiamante inizia a seguire una entità polimorfica (es. un User o un
 * FitPlayerProfile), identificata da `followable_type`/`followable_id`. Invia una
 * notifica asincrona al seguito. Risponde comunque 200 anche in caso di errore di
 * validazione: controllare `success`/`errors` nel body. Richiede X-Api-Key.
 *
 */
export const postFollows = <ThrowOnError extends boolean = false>(
  options: Options<PostFollowsData, ThrowOnError>
): RequestResult<PostFollowsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<PostFollowsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/follows',
    ...options,
  })

/**
 * Rimuove un follow
 *
 * Smette di seguire l'entità indicata da `followable_type`/`followable_id` per conto
 * dell'utente chiamante. Richiede X-Api-Key; risponde 404 se il follow non esiste.
 *
 */
export const postRemoveFollow = <ThrowOnError extends boolean = false>(
  options: Options<PostRemoveFollowData, ThrowOnError>
): RequestResult<
  PostRemoveFollowResponses,
  PostRemoveFollowErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostRemoveFollowResponses,
    PostRemoveFollowErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/remove-follow',
    ...options,
  })

/**
 * Restituisce la conversazione tra due profili
 *
 * Storico dei messaggi tra il profilo `type`/`id` (deve essere gestibile
 * dall'utente corrente, altrimenti `401`) e un eventuale `counterpart_type`/
 * `counterpart_id`; se il counterpart non e' specificato, restituisce l'intera
 * conversazione del profilo con tutti gli interlocutori.
 *
 */
export const getMessagesConversation = <ThrowOnError extends boolean = false>(
  options: Options<GetMessagesConversationData, ThrowOnError>
): RequestResult<GetMessagesConversationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetMessagesConversationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/messages/conversation',
    ...options,
  })

/**
 * Crea un nuovo messaggio
 *
 * Invia un messaggio da un profilo (User o FitPlayerProfile) a un altro. Filtro
 * anti-spam silenzioso: se `content` contiene '.it' o il mittente e' bannato,
 * risponde comunque `200 success: true` ma non crea nulla. Se i due profili non
 * possono contattarsi (`Message.can_contact?`: un blocco in una delle due direzioni)
 * risponde `422` con `error: blocked`, sia a chi e' bloccato sia a chi ha bloccato.
 * A un giocatore FIT senza utente collegato non si può scrivere: `422`.
 *
 */
export const postMessages = <ThrowOnError extends boolean = false>(
  options?: Options<PostMessagesData, ThrowOnError>
): RequestResult<PostMessagesResponses, PostMessagesErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    PostMessagesResponses,
    PostMessagesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/messages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Blocca un messaggio
 *
 * Nasconde un messaggio (imposta `blocked_at`), tipicamente usato dal destinatario
 * per moderare la propria conversazione. Richiede che il chiamante possa gestire il
 * destinatario del messaggio (`current_user.manage?`), altrimenti serve il permesso
 * `authorize! :manage, Message`.
 *
 */
export const putMessagesByIdBlock = <ThrowOnError extends boolean = false>(
  options: Options<PutMessagesByIdBlockData, ThrowOnError>
): RequestResult<PutMessagesByIdBlockResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<
    PutMessagesByIdBlockResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/messages/{id}/block',
    ...options,
  })

/**
 * Lista tutti i messaggi per il backoffice (richiede admin)
 *
 * Lista paginata (50 per pagina di default) di tutti i messaggi della piattaforma,
 * per la moderazione da backoffice, esclusi quelli di un autore interno
 * (`author_id: 9331`). Richiede specificamente il ruolo `admin`
 * (`current_user.admin?`) — a differenza di altri endpoint admin di questa API,
 * banner_manager/censor_manager NON sono sufficienti qui.
 *
 */
export const getMessagesBackoffice = <ThrowOnError extends boolean = false>(
  options?: Options<GetMessagesBackofficeData, ThrowOnError>
): RequestResult<
  GetMessagesBackofficeResponses,
  GetMessagesBackofficeErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetMessagesBackofficeResponses,
    GetMessagesBackofficeErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/messages/backoffice',
    ...options,
  })

/**
 * Restituisce i profili con cui l'utente ha scambiato messaggi
 *
 * Elenco (deduplicato) dei profili con cui il profilo `type`/`id` ha scambiato
 * almeno un messaggio, opzionalmente filtrato per nome. Il profilo deve essere
 * gestibile dall'utente corrente (`current_user.manage?`), altrimenti `401`.
 *
 */
export const getUsersMessagesCounterparts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsersMessagesCounterpartsData, ThrowOnError>
): RequestResult<
  GetUsersMessagesCounterpartsResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUsersMessagesCounterpartsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/messages-counterparts',
    ...options,
  })

/**
 * Restituisce il banner posizionato per slot
 *
 * Restituisce il PositionedBanner assegnato a uno slot (es. `home_top`). Se lo slot
 * contiene piu' CustomBanner, ne viene estratto uno a caso. Endpoint pubblico:
 * nessuna autenticazione richiesta.
 *
 */
export const getPositionedBannersBySlot = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPositionedBannersBySlotData, ThrowOnError>
): RequestResult<
  GetPositionedBannersBySlotResponses,
  GetPositionedBannersBySlotErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPositionedBannersBySlotResponses,
    GetPositionedBannersBySlotErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners/{slot}',
    ...options,
  })

/**
 * Restituisce tutti banners posizionato per slot
 *
 * Come GET /positioned-banners/{slot}, ma restituisce tutti i CustomBanner assegnati
 * allo slot invece di uno solo a caso. Endpoint pubblico: nessuna autenticazione
 * richiesta.
 *
 */
export const getPositionedBannersBySlotAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPositionedBannersBySlotAllData, ThrowOnError>
): RequestResult<
  GetPositionedBannersBySlotAllResponses,
  GetPositionedBannersBySlotAllErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPositionedBannersBySlotAllResponses,
    GetPositionedBannersBySlotAllErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners/{slot}/all',
    ...options,
  })

/**
 * Restituisce i banner posizionati paginati
 *
 * Lista paginata di tutti i PositionedBanner (uno per slot), 20 per pagina. Endpoint
 * pubblico: nessuna autenticazione richiesta.
 *
 */
export const getPositionedBanners = <ThrowOnError extends boolean = false>(
  options?: Options<GetPositionedBannersData, ThrowOnError>
): RequestResult<GetPositionedBannersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetPositionedBannersResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners',
    ...options,
  })

/**
 * Crea un nuovo banner posizionato
 *
 * Crea un PositionedBanner per uno slot e lo collega a uno o piu' CustomBanner
 * tramite `bannerable_id`. Riservato a admin/banner_manager/censor_manager: 401 senza
 * login o per gli altri utenti.
 *
 */
export const postPositionedBanners = <ThrowOnError extends boolean = false>(
  options?: Options<PostPositionedBannersData, ThrowOnError>
): RequestResult<
  PostPositionedBannersResponses,
  PostPositionedBannersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostPositionedBannersResponses,
    PostPositionedBannersErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Restituisce un banner posizionato specifico
 *
 * Restituisce un PositionedBanner per ID (invece che per slot). Endpoint pubblico:
 * nessuna autenticazione richiesta.
 *
 */
export const getPositionedBannersByIdById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPositionedBannersByIdByIdData, ThrowOnError>
): RequestResult<
  GetPositionedBannersByIdByIdResponses,
  GetPositionedBannersByIdByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPositionedBannersByIdByIdResponses,
    GetPositionedBannersByIdByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners/by-id/{id}',
    ...options,
  })

/**
 * Elimina un banner posizionato
 *
 * Elimina definitivamente un PositionedBanner. Riservato a
 * admin/banner_manager/censor_manager.
 *
 */
export const deletePositionedBannersById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeletePositionedBannersByIdData, ThrowOnError>
): RequestResult<DeletePositionedBannersByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<
    DeletePositionedBannersByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners/{id}',
    ...options,
  })

/**
 * Aggiorna un banner posizionato
 *
 * Aggiorna slot e/o collegamenti ai CustomBanner di un PositionedBanner esistente
 * (sostituisce interamente l'associazione `bannerable_id`). Come per la create,
 * riservato a admin/banner_manager/censor_manager.
 *
 */
export const putPositionedBannersById = <ThrowOnError extends boolean = false>(
  options: Options<PutPositionedBannersByIdData, ThrowOnError>
): RequestResult<PutPositionedBannersByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<
    PutPositionedBannersByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Lista i premium tokens
 *
 * Lists premium tokens (20 per page), most recent first, with the associated user.
 * Backoffice only: requires an X-Api-Key of a staff user (admin, banner or censor manager).
 *
 */
export const getPremiumTokens = <ThrowOnError extends boolean = false>(
  options?: Options<GetPremiumTokensData, ThrowOnError>
): RequestResult<
  GetPremiumTokensResponses,
  GetPremiumTokensErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetPremiumTokensResponses,
    GetPremiumTokensErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens',
    ...options,
  })

/**
 * Crea un nuovo premium token
 *
 * Creates a premium token, typically generated after a Shopify membership purchase.
 * Backoffice only: requires an X-Api-Key of a staff user (admin, banner or censor manager).
 *
 */
export const postPremiumTokens = <ThrowOnError extends boolean = false>(
  options?: Options<PostPremiumTokensData, ThrowOnError>
): RequestResult<
  PostPremiumTokensResponses,
  PostPremiumTokensErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostPremiumTokensResponses,
    PostPremiumTokensErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Elimina un premium token
 *
 * Deletes a premium token.
 * Backoffice only: requires an X-Api-Key of a staff user (admin, banner or censor manager).
 *
 */
export const deletePremiumTokensById = <ThrowOnError extends boolean = false>(
  options: Options<DeletePremiumTokensByIdData, ThrowOnError>
): RequestResult<
  DeletePremiumTokensByIdResponses,
  DeletePremiumTokensByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeletePremiumTokensByIdResponses,
    DeletePremiumTokensByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens/{id}',
    ...options,
  })

/**
 * Mostra un premium token specifico
 *
 * Returns a single premium token by id, with its associated user.
 * Backoffice only: requires an X-Api-Key of a staff user (admin, banner or censor manager).
 *
 */
export const getPremiumTokensById = <ThrowOnError extends boolean = false>(
  options: Options<GetPremiumTokensByIdData, ThrowOnError>
): RequestResult<
  GetPremiumTokensByIdResponses,
  GetPremiumTokensByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetPremiumTokensByIdResponses,
    GetPremiumTokensByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens/{id}',
    ...options,
  })

/**
 * Aggiorna un premium token
 *
 * Updates a premium token, e.g. to mark it as `consumed` once redeemed.
 * Backoffice only: requires an X-Api-Key of a staff user (admin, banner or censor manager).
 *
 */
export const putPremiumTokensById = <ThrowOnError extends boolean = false>(
  options: Options<PutPremiumTokensByIdData, ThrowOnError>
): RequestResult<
  PutPremiumTokensByIdResponses,
  PutPremiumTokensByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutPremiumTokensByIdResponses,
    PutPremiumTokensByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Invia email di membership per un premium token
 *
 * Sends the membership activation email for a premium token id, containing a
 * signed token the recipient uses to activate their membership.
 * Backoffice only: requires an X-Api-Key of a staff user (admin, banner or censor manager).
 *
 */
export const postPremiumTokensMembershipEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostPremiumTokensMembershipEmailData, ThrowOnError>
): RequestResult<
  PostPremiumTokensMembershipEmailResponses,
  PostPremiumTokensMembershipEmailErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostPremiumTokensMembershipEmailResponses,
    PostPremiumTokensMembershipEmailErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens/membership_email',
    ...options,
  })

/**
 * Apre un ticket di supporto per una membership non attivata
 *
 * Accoda un `CreateIntercomNotActivatedMembershipJob` che apre un ticket Intercom a
 * nome dell'email indicata (normalizzata: trim + minuscolo) e vi risponde con le
 * istruzioni per attivare la membership. Usato sia dal backoffice (staff) sia come
 * punto d'ingresso del supporto membership. Risponde sempre `{ success: true }`,
 * anche con email vuota. Nessun controllo di autenticazione: X-Api-Key non richiesto.
 *
 */
export const postPremiumTokensCreateTicketForNotActivatedMembership = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    PostPremiumTokensCreateTicketForNotActivatedMembershipData,
    ThrowOnError
  >
): RequestResult<
  PostPremiumTokensCreateTicketForNotActivatedMembershipResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostPremiumTokensCreateTicketForNotActivatedMembershipResponses,
    unknown,
    ThrowOnError
  >({
    url: '/premium_tokens/create_ticket_for_not_activated_membership',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Ottiene la cardinalità del ranking per l'anno corrente
 *
 * Restituisce la prossima "cardinalità" libera per l'anno corrente: un contatore
 * progressivo (1, 2, 3, ...) usato per distinguere più ranking salvati lo stesso anno
 * tramite POST /cardinality/save. Non dipende dall'utente chiamante, solo dall'anno.
 * Richiede X-Api-Key (nessun ruolo specifico).
 *
 */
export const getCardinality = <ThrowOnError extends boolean = false>(
  options?: Options<GetCardinalityData, ThrowOnError>
): RequestResult<GetCardinalityResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetCardinalityResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/cardinality',
    ...options,
  })

/**
 * Salva un nuovo ranking per il giocatore corrente
 *
 * Crea un Ranking per il fit_player_profile dell'utente chiamante alla coppia
 * (year, cardinality) indicata, calcolando rank e fit_points tramite
 * FitPointsCalculator. Ritorna `{ success: false }` (200, non un errore HTTP) se
 * l'utente non ha un fit_player_profile collegato o se esiste già un ranking per
 * quella stessa coppia (year, cardinality). Prima di salvare cancella i ranking di
 * tutti i giocatori per quella coppia: riservato a admin/banner_manager/censor_manager
 * (401 per gli altri utenti).
 *
 */
export const postCardinalitySave = <ThrowOnError extends boolean = false>(
  options: Options<PostCardinalitySaveData, ThrowOnError>
): RequestResult<
  PostCardinalitySaveResponses,
  PostCardinalitySaveErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostCardinalitySaveResponses,
    PostCardinalitySaveErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/cardinality/save',
    ...options,
  })

/**
 * Richiede il reset della password
 *
 * Starts the password-reset flow: if a user exists for the given email, generates a
 * reset token and emails a reset link. Always responds 200/success regardless of whether
 * the email matches an account, to avoid leaking which emails are registered. No
 * X-Api-Key required.
 *
 */
export const putResetPasswordRequest = <ThrowOnError extends boolean = false>(
  options: Options<PutResetPasswordRequestData, ThrowOnError>
): RequestResult<PutResetPasswordRequestResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<
    PutResetPasswordRequestResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reset-password/request',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Resetta la password usando il token
 *
 * Completes the password-reset flow: given the token emailed by
 * `PUT /reset-password/request`, sets a new password. As a side effect, confirms the
 * account if it wasn't already confirmed. Always responds 200/success even for an
 * invalid/expired token, to avoid leaking whether a token is valid. No X-Api-Key
 * required.
 *
 */
export const putResetPassword = <ThrowOnError extends boolean = false>(
  options: Options<PutResetPasswordData, ThrowOnError>
): RequestResult<PutResetPasswordResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<
    PutResetPasswordResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reset-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Elimina la ricerca di competizioni salvata
 *
 * Deletes the caller's saved search. 404 if none exists.
 */
export const deleteSavedCompetitionSearch = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DeleteSavedCompetitionSearchData, ThrowOnError>
): RequestResult<
  DeleteSavedCompetitionSearchResponses,
  DeleteSavedCompetitionSearchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).delete<
    DeleteSavedCompetitionSearchResponses,
    DeleteSavedCompetitionSearchErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/saved-competition-search',
    ...options,
  })

/**
 * Ottiene la ricerca di competizioni salvata dell'utente
 *
 * Each user has at most one saved competition search filter (a singular resource,
 * not a list) — used to match new competitions against for push-notification
 * alerts. 404 if the caller hasn't saved one yet.
 *
 */
export const getSavedCompetitionSearch = <ThrowOnError extends boolean = false>(
  options?: Options<GetSavedCompetitionSearchData, ThrowOnError>
): RequestResult<
  GetSavedCompetitionSearchResponses,
  GetSavedCompetitionSearchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetSavedCompetitionSearchResponses,
    GetSavedCompetitionSearchErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/saved-competition-search',
    ...options,
  })

/**
 * Crea o aggiorna la ricerca di competizioni salvata
 *
 * Upsert: creates the caller's saved search if none exists yet, otherwise
 * overwrites it — there is never more than one per user.
 *
 */
export const postSavedCompetitionSearch = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostSavedCompetitionSearchData, ThrowOnError>
): RequestResult<
  PostSavedCompetitionSearchResponses,
  PostSavedCompetitionSearchErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostSavedCompetitionSearchResponses,
    PostSavedCompetitionSearchErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/saved-competition-search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Lista i prodotti Tennis Warehouse
 *
 * Catalogo Tennis Warehouse Europe, aggiornato ogni notte dal feed TWE.
 * Endpoint pubblico: non richiede X-Api-Key.
 * Restituisce solo i prodotti disponibili (presenti nell'ultimo feed).
 *
 */
export const getTweProducts = <ThrowOnError extends boolean = false>(
  options?: Options<GetTweProductsData, ThrowOnError>
): RequestResult<GetTweProductsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetTweProductsResponses,
    unknown,
    ThrowOnError
  >({ url: '/twe-products', ...options })

/**
 * Dettaglio prodotto con le sue varianti
 *
 * Un prodotto raggruppa le proprie varianti (taglia/colore), ciascuna col suo
 * prezzo e codice EAN. Endpoint pubblico: non richiede X-Api-Key.
 *
 */
export const getTweProductsById = <ThrowOnError extends boolean = false>(
  options: Options<GetTweProductsByIdData, ThrowOnError>
): RequestResult<
  GetTweProductsByIdResponses,
  GetTweProductsByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTweProductsByIdResponses,
    GetTweProductsByIdErrors,
    ThrowOnError
  >({ url: '/twe-products/{id}', ...options })

/**
 * I prodotti piu' cliccati
 *
 * I prodotti disponibili con piu' click, in ordine decrescente, ciascuno con il
 * proprio conteggio (`clicks_count`), piu' un `summary` con i totali sull'intera
 * finestra filtrata (click totali, prodotti distinti cliccati, utenti distinti e
 * `catalogue_products_count`, i prodotti che passano i filtri, cliccati o no),
 * indipendente da `limit`, e `daily`, i click della stessa finestra giorno per giorno
 * (senza `date_from` la serie parte dal primo click). Accetta gli stessi filtri del catalogo, piu'
 * la finestra temporale sui click e `limit`. Analytics riservata al backoffice:
 * richiede un X-Api-Key di un utente amministratore.
 *
 */
export const getTweProductsMostClicked = <ThrowOnError extends boolean = false>(
  options?: Options<GetTweProductsMostClickedData, ThrowOnError>
): RequestResult<
  GetTweProductsMostClickedResponses,
  GetTweProductsMostClickedErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetTweProductsMostClickedResponses,
    GetTweProductsMostClickedErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/twe-products/most_clicked',
    ...options,
  })

/**
 * Carousel personalizzata "Consigliati per te"
 *
 * Prodotti consigliati per il chiamante, in tre segmenti: `profiled` (utente con una
 * marca preferita), `registered` (loggato senza preferenze), `anonymous`. Ogni segmento
 * ha un fallback: la carousel e' sempre piena. Endpoint pubblico: X-Api-Key opzionale,
 * se presente personalizza sul profilo. Il campo `segment` guida la CTA del frontend.
 *
 */
export const getTweProductsForMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetTweProductsForMeData, ThrowOnError>
): RequestResult<GetTweProductsForMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetTweProductsForMeResponses,
    unknown,
    ThrowOnError
  >({ url: '/twe-products/for_me', ...options })

/**
 * Vetrina dei prodotti in evidenza
 *
 * La selezione curata da TWE (`featured` nel feed): ~20 prodotti sui 3300 del catalogo,
 * per lo piu' scarpe e racchette. Stesso payload paginato di GET /twe-products.
 * Endpoint pubblico: non richiede X-Api-Key.
 *
 */
export const getTweProductsFeatured = <ThrowOnError extends boolean = false>(
  options?: Options<GetTweProductsFeaturedData, ThrowOnError>
): RequestResult<GetTweProductsFeaturedResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetTweProductsFeaturedResponses,
    unknown,
    ThrowOnError
  >({ url: '/twe-products/featured', ...options })

/**
 * Registra un click su un prodotto
 *
 * Registra un click sul prodotto, tipicamente prima di aprire il link allo store
 * esterno. Endpoint pubblico: X-Api-Key opzionale. Se presente il click viene
 * attribuito all'utente, altrimenti resta anonimo.
 *
 */
export const postTweProductsByIdClick = <ThrowOnError extends boolean = false>(
  options: Options<PostTweProductsByIdClickData, ThrowOnError>
): RequestResult<
  PostTweProductsByIdClickResponses,
  PostTweProductsByIdClickErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostTweProductsByIdClickResponses,
    PostTweProductsByIdClickErrors,
    ThrowOnError
  >({ url: '/twe-products/{id}/click', ...options })

/**
 * Numero di click su un prodotto
 *
 * Conteggio dei click registrati sul prodotto. Endpoint pubblico: non richiede
 * X-Api-Key.
 *
 */
export const getTweProductsByIdClicks = <ThrowOnError extends boolean = false>(
  options: Options<GetTweProductsByIdClicksData, ThrowOnError>
): RequestResult<GetTweProductsByIdClicksResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<
    GetTweProductsByIdClicksResponses,
    unknown,
    ThrowOnError
  >({ url: '/twe-products/{id}/clicks', ...options })

/**
 * Click di un prodotto giorno per giorno
 *
 * Click registrati sul prodotto nella finestra, in totale e per giorno (fuso di Roma,
 * giorni senza click a 0). Senza `date_from` la serie parte dal primo click.
 * Analytics riservata al backoffice: richiede un X-Api-Key di un utente amministratore.
 *
 */
export const getTweProductsByIdDailyClicks = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTweProductsByIdDailyClicksData, ThrowOnError>
): RequestResult<
  GetTweProductsByIdDailyClicksResponses,
  GetTweProductsByIdDailyClicksErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetTweProductsByIdDailyClicksResponses,
    GetTweProductsByIdDailyClicksErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/twe-products/{id}/daily_clicks',
    ...options,
  })

/**
 * Lista le categorie del catalogo TWE
 *
 * Le categorie provengono dal feed e servono per i filtri della griglia.
 * Endpoint pubblico: non richiede X-Api-Key.
 *
 */
export const getTweProductCategories = <ThrowOnError extends boolean = false>(
  options?: Options<GetTweProductCategoriesData, ThrowOnError>
): RequestResult<GetTweProductCategoriesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetTweProductCategoriesResponses,
    unknown,
    ThrowOnError
  >({ url: '/twe-product-categories', ...options })

/**
 * Lista i marchi del catalogo TWE
 *
 * I marchi dei prodotti disponibili, in ordine alfabetico, con quanti prodotti ha
 * ciascuno. `name` va passato tale e quale al filtro `brand` di /api/twe-products.
 * Endpoint pubblico: non richiede X-Api-Key.
 *
 * Faccetta: accetta gli stessi filtri di /api/twe-products e i conteggi si riferiscono
 * allo scope filtrato, non al catalogo intero. I marchi senza prodotti nello scope non
 * vengono restituiti. Il filtro `brand` NON e' accettato: una faccetta si conta sempre
 * ignorando se stessa, altrimenti selezionando una marca tutte le altre sarebbero a 0.
 *
 */
export const getTweProductBrands = <ThrowOnError extends boolean = false>(
  options?: Options<GetTweProductBrandsData, ThrowOnError>
): RequestResult<GetTweProductBrandsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetTweProductBrandsResponses,
    unknown,
    ThrowOnError
  >({ url: '/twe-product-brands', ...options })

/**
 * Lista gli update tasks (richiede autorizzazione admin)
 *
 * Lista paginata degli UpdateTask (job di manutenzione: import dati, refresh cache,
 * ecc.), piu' recenti prima. Richiede ruolo admin (`authorize! :manage, UpdateTask`).
 *
 */
export const getUpdateTasks = <ThrowOnError extends boolean = false>(
  options?: Options<GetUpdateTasksData, ThrowOnError>
): RequestResult<GetUpdateTasksResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetUpdateTasksResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks',
    ...options,
  })

/**
 * Crea un nuovo update task
 *
 * Crea un UpdateTask caricando un file da processare. Nota: nonostante il titolo
 * parli di "autorizzazione admin" per la lista, questo endpoint non ha alcun
 * `authorize!` — richiede solo di essere autenticati (`verify_login`), qualunque
 * ruolo. Se `run_after_save` e' true, il task viene eseguito subito in background.
 *
 */
export const postUpdateTasks = <ThrowOnError extends boolean = false>(
  options?: Options<PostUpdateTasksData, ThrowOnError>
): RequestResult<PostUpdateTasksResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostUpdateTasksResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Esegue un update task specifico
 *
 * Accoda l'esecuzione (`UpdateTaskJob`) di un update task che sia ancora `pending`;
 * se non e' pending o non esiste, risponde comunque `200` con `success: true` senza
 * fare nulla. Nessun controllo di ruolo: basta essere autenticati.
 *
 */
export const putUpdateTasksByIdRun = <ThrowOnError extends boolean = false>(
  options: Options<PutUpdateTasksByIdRunData, ThrowOnError>
): RequestResult<PutUpdateTasksByIdRunResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<
    PutUpdateTasksByIdRunResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/{id}/run',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Rilancia un update task
 *
 * Rilancia il lavoro di un update task, qualunque sia il suo status (decide l'admin cosa ha senso
 * rilanciare). Un task creato da un job (`job_class` valorizzato) riaccoda lo stesso job con gli
 * stessi argomenti: il job crea un nuovo update task. Un task di import con file viene rielaborato
 * da `UpdateTaskJob` sullo stesso task (`avoid_send_mail` vale solo per questo caso). I file
 * parametri su S3 eventualmente gia' cancellati dal job non vengono ricreati. Richiede ruolo
 * admin (`authorize! :manage, UpdateTask`).
 *
 */
export const postUpdateTasksByIdRerun = <ThrowOnError extends boolean = false>(
  options: Options<PostUpdateTasksByIdRerunData, ThrowOnError>
): RequestResult<
  PostUpdateTasksByIdRerunResponses,
  PostUpdateTasksByIdRerunErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUpdateTasksByIdRerunResponses,
    PostUpdateTasksByIdRerunErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/{id}/rerun',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Imposta un update task come pending
 *
 * Reimposta lo status di un update task a `pending`, tipicamente per ritentare
 * un'esecuzione fallita con `PUT .../run`. Nessun controllo di ruolo: basta essere
 * autenticati.
 *
 */
export const putUpdateTasksByIdSetPending = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUpdateTasksByIdSetPendingData, ThrowOnError>
): RequestResult<
  PutUpdateTasksByIdSetPendingResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUpdateTasksByIdSetPendingResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/{id}/set_pending',
    ...options,
  })

/**
 * Lista i prodotti TWE aggiornati da un update task (richiede autorizzazione admin)
 *
 * Lista paginata dei TweProduct il cui `updated_at` cade nella finestra
 * creazione-aggiornamento del task, utile per verificare l'esito di un import feed
 * TWE. Richiede ruolo admin (`authorize! :manage, TweProduct`).
 *
 */
export const getUpdateTasksByIdTweProducts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUpdateTasksByIdTweProductsData, ThrowOnError>
): RequestResult<
  GetUpdateTasksByIdTweProductsResponses,
  unknown,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUpdateTasksByIdTweProductsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/{id}/twe-products',
    ...options,
  })

/**
 * Elimina un update task
 *
 * Elimina definitivamente un update task. Nessun controllo di ruolo: basta essere
 * autenticati.
 *
 */
export const deleteUpdateTasksById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUpdateTasksByIdData, ThrowOnError>
): RequestResult<
  DeleteUpdateTasksByIdResponses,
  DeleteUpdateTasksByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteUpdateTasksByIdResponses,
    DeleteUpdateTasksByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/{id}',
    ...options,
  })

/**
 * Aggiorna la cache Redis
 *
 * Svuota la cache dell'applicazione (pagine dei giocatori, ricerche, contatori), che poi si
 * ricalcola dal database. Restano i contatori del rate limiting (Rack::Attack) e i dati di
 * rails_performance. Per svuotare tutto c'e' `cache_flush_all`. Solo admin.
 *
 */
export const postUpdateTasksCacheRefresh = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostUpdateTasksCacheRefreshData, ThrowOnError>
): RequestResult<PostUpdateTasksCacheRefreshResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostUpdateTasksCacheRefreshResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/cache_refresh',
    ...options,
  })

/**
 * Svuota tutta la cache Redis (emergenza)
 *
 * Emergenza: svuota tutto quello che l'applicazione tiene in Redis, la cache, i contatori del rate
 * limiting (Rack::Attack) e i dati di rails_performance. La cache si ricalcola dal database. Solo admin.
 *
 */
export const postUpdateTasksCacheFlushAll = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostUpdateTasksCacheFlushAllData, ThrowOnError>
): RequestResult<
  PostUpdateTasksCacheFlushAllResponses,
  PostUpdateTasksCacheFlushAllErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostUpdateTasksCacheFlushAllResponses,
    PostUpdateTasksCacheFlushAllErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/cache_flush_all',
    ...options,
  })

/**
 * Riavvia i server EC2
 *
 * Accoda un `RestartEc2Job` che riavvia i server EC2 dell'infrastruttura. Nessun
 * controllo di ruolo: basta essere autenticati.
 *
 */
export const postUpdateTasksRestartServers = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostUpdateTasksRestartServersData, ThrowOnError>
): RequestResult<
  PostUpdateTasksRestartServersResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostUpdateTasksRestartServersResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/restart_servers',
    ...options,
  })

/**
 * Esegue il ripristino di un dump del database
 *
 * Accoda un `RestoreDumpJob` che ripristina il database da un dump. Distruttivo.
 * Nessun controllo di ruolo: basta essere autenticati.
 *
 */
export const postUpdateTasksRunRestoreDump = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostUpdateTasksRunRestoreDumpData, ThrowOnError>
): RequestResult<
  PostUpdateTasksRunRestoreDumpResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostUpdateTasksRunRestoreDumpResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/run-restore-dump',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Esegue un job asincrono specifico (richiede autorizzazione admin)
 *
 * Accoda dinamicamente un qualsiasi ActiveJob dato il suo nome classe, opzionalmente
 * passando un record (`model_param`) o un parametro scalare (`param`) come argomento.
 * Richiede ruolo admin (`authorize! :manage, UpdateTask`). Risponde `404` se la
 * classe non esiste o non e' un ActiveJob, `400` se il nome manca o gli argomenti
 * non combaciano con la firma di `perform`.
 *
 */
export const postUpdateTasksRunAsyncJob = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUpdateTasksRunAsyncJobData, ThrowOnError>
): RequestResult<
  PostUpdateTasksRunAsyncJobResponses,
  PostUpdateTasksRunAsyncJobErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUpdateTasksRunAsyncJobResponses,
    PostUpdateTasksRunAsyncJobErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/run_async_job',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Lista i match utente
 *
 * Lista paginata degli UserMatch (risultati inseriti manualmente dagli utenti, a
 * differenza dei Match ufficiali) in cui l'utente corrente (o il suo
 * FitPlayerProfile) e' coinvolto come destinatario/oggetto della conferma. Supporta
 * vari filtri via query string.
 *
 */
export const getUserMatches = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserMatchesData, ThrowOnError>
): RequestResult<GetUserMatchesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetUserMatchesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches',
    ...options,
  })

/**
 * Crea un nuovo match utente
 *
 * Registra un match riportato manualmente dall'utente (non un Match ufficiale).
 * L'autore e' normalmente l'utente corrente; puo' essere impostato a un altro
 * User/FitPlayerProfile via `authorable_type`/`authorable_id` solo se si tratta del
 * proprio FitPlayerProfile o si e' admin. Se c'e' un destinatario risolvibile, viene
 * notificato per confermare/rifiutare il match; aggiorna anche ranking/punti dei
 * giocatori coinvolti in modo sincrono.
 *
 */
export const postUserMatches = <ThrowOnError extends boolean = false>(
  options?: Options<PostUserMatchesData, ThrowOnError>
): RequestResult<
  PostUserMatchesResponses,
  PostUserMatchesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostUserMatchesResponses,
    PostUserMatchesErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Elimina un match utente
 *
 * Elimina un UserMatch e ricalcola ranking/punti per i giocatori coinvolti.
 * Ristretto all'autore del match o a un admin (CanCan
 * `load_and_authorize_resource`); altrimenti `401`.
 *
 */
export const deleteUserMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUserMatchesByIdData, ThrowOnError>
): RequestResult<
  DeleteUserMatchesByIdResponses,
  DeleteUserMatchesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteUserMatchesByIdResponses,
    DeleteUserMatchesByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}',
    ...options,
  })

/**
 * Mostra un match utente specifico
 *
 * Dettaglio di un singolo UserMatch. Nessuna restrizione di ownership sulla show:
 * qualunque utente autenticato puo' vedere qualsiasi match utente per ID.
 *
 */
export const getUserMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<GetUserMatchesByIdData, ThrowOnError>
): RequestResult<
  GetUserMatchesByIdResponses,
  GetUserMatchesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUserMatchesByIdResponses,
    GetUserMatchesByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}',
    ...options,
  })

/**
 * Aggiorna un match utente
 *
 * Aggiorna un UserMatch esistente e ricalcola ranking/punti per i giocatori
 * coinvolti (sia i precedenti che i nuovi). Ristretto all'autore del match o a un
 * admin (CanCan `load_and_authorize_resource`); altrimenti `401`.
 *
 * Partita organizzata (aperta o piena, non iniziata): chi crea cambia orario, campo e note,
 * e riempie posti liberi con le chiavi della creazione (`*able_type`/`*able_id` o `*_name`).
 * Un posto preso non si sostituisce (409 `spot_taken`), quello della richiesta in attesa
 * neanche (409 `request_pending`), ne' chi ha gia' una partita a quell'ora (409 `time_conflict`);
 * 422 `unknown_seat|invalid_params|already_seated`. Modifiche e posti si salvano insieme o per niente.
 * Senza posti liberi la partita diventa `full`.
 *
 */
export const putUserMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<PutUserMatchesByIdData, ThrowOnError>
): RequestResult<
  PutUserMatchesByIdResponses,
  PutUserMatchesByIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUserMatchesByIdResponses,
    PutUserMatchesByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Conferma un match utente
 *
 * Conferma un UserMatch riportato da un altro utente (imposta `confirmed_at`, azzera
 * `rejected_at`), aggiorna ranking/punti in background e notifica l'autore
 * originale. Restituisce `404` se il match non esiste o l'utente corrente non ne e'
 * il destinatario/oggetto della conferma. Partita organizzata: conferma chi gioca e non ha
 * inviato l'ultimo risultato (`match_finder.can_confirm_result`), e la notifica va a chi l'ha inviato;
 * Si conferma la versione vista (`result_submitted_at`): 409 `result_changed` se nel frattempo
 * il risultato e' stato corretto.
 *
 */
export const putUserMatchesByIdConfirm = <ThrowOnError extends boolean = false>(
  options: Options<PutUserMatchesByIdConfirmData, ThrowOnError>
): RequestResult<
  PutUserMatchesByIdConfirmResponses,
  PutUserMatchesByIdConfirmErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUserMatchesByIdConfirmResponses,
    PutUserMatchesByIdConfirmErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/confirm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Rifiuta un match utente
 *
 * Rifiuta un UserMatch riportato da un altro utente (imposta `rejected_at`, azzera
 * `confirmed_at`) e notifica l'autore originale. Restituisce `404` se il match non
 * esiste o l'utente corrente non ne e' il destinatario/oggetto della conferma.
 * Partita organizzata: come confirm, con la versione vista (`result_submitted_at`), e 409
 * `result_changed` se il risultato e' stato corretto nel frattempo.
 *
 */
export const putUserMatchesByIdReject = <ThrowOnError extends boolean = false>(
  options: Options<PutUserMatchesByIdRejectData, ThrowOnError>
): RequestResult<
  PutUserMatchesByIdRejectResponses,
  PutUserMatchesByIdRejectErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUserMatchesByIdRejectResponses,
    PutUserMatchesByIdRejectErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Aggiorna il risultato di un match utente
 *
 * Aggiorna il campo `result` di un UserMatch e, se inviati insieme, `duration`, `surface`
 * e `indoor`, senza toccare gli altri campi. Partita giocata: ristretto a chi l'ha inserita e agli
 * admin (`user_match.editable_by?`, lo stesso valore di `is_editable`), altrimenti `403`: gli altri
 * giocatori confermano o rifiutano il risultato. Partita organizzata: lo inserisce o lo corregge
 * chiunque giochi finche' non e' confermato, poi solo un admin (l'ultima versione vince,
 * `match_finder.can_add_result`/`can_edit_result`), e torna
 * da confermare alla squadra avversaria di chi l'ha inserito, nel doppio non al compagno (`can_confirm_result`,
 * `PUT .../confirm|reject`); senza risposta si conferma da solo 24 ore dopo l'ultimo invio
 * (`result_auto_confirms_at`). La correzione di un admin che non gioca resta confermata, e chi l'aveva
 * inserito non cambia. Prima dell'inizio: 422 `not_started`. Validazione fallita: 422 con
 * `{ success: false, errors }` (`ValidationErrorResponse`), e il risultato resta quello di prima. `result` va sempre scritto
 * dal lato di chi crea (autore e compagno prima): `won` lo ricava il server dai set (null a parita'). Su una partita `full` il risultato la porta a `played`; su una
 * partita `open`, `proposed` o `cancelled` risponde `422 not_playable`. Se il body
 * manca di `result` il match resta invariato e la risposta e' `200`.
 *
 */
export const putUserMatchesByIdResult = <ThrowOnError extends boolean = false>(
  options: Options<PutUserMatchesByIdResultData, ThrowOnError>
): RequestResult<
  PutUserMatchesByIdResultResponses,
  PutUserMatchesByIdResultErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUserMatchesByIdResultResponses,
    PutUserMatchesByIdResultErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/result',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Cerca partite aperte
 *
 * Il feed del Match Finder: partite `open` con almeno un posto libero, inizio fra
 * piu' di due ore, create da persone dello stesso genere, escluse le proprie, quelle
 * in cui ha gia' un posto, quelle con persone bloccate (in entrambe le direzioni) e
 * quelle che si sovrappongono a un suo impegno con orario esatto. Restano quelle con
 * una richiesta in corso (`request_pending`). Con `lat`/`lng` filtra per raggio.
 * Ogni partita ha `section` (`club` entro 300 m dai campi del circolo di chi cerca,
 * altrimenti `nearby`) e `distance_km` dal punto inviato o, senza `lat`/`lng`, dal
 * circolo (null se non c'e' nessuno dei due). Ordine: circolo, chi crea e' Member,
 * campo prenotato, distanza, inizio. 20 per pagina. 422 `profile_incomplete` (con
 * `missing`) se il profilo non e' completo.
 *
 */
export const getUserMatchesOpen = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserMatchesOpenData, ThrowOnError>
): RequestResult<
  GetUserMatchesOpenResponses,
  GetUserMatchesOpenErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUserMatchesOpenResponses,
    GetUserMatchesOpenErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/open',
    ...options,
  })

/**
 * Ritira la richiesta del posto
 *
 * Solo chi ha fatto la richiesta viva. Errore: 422 `not_requester`.
 */
export const deleteUserMatchesByIdRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteUserMatchesByIdRequestData, ThrowOnError>
): RequestResult<
  DeleteUserMatchesByIdRequestResponses,
  DeleteUserMatchesByIdRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteUserMatchesByIdRequestResponses,
    DeleteUserMatchesByIdRequestErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/request',
    ...options,
  })

/**
 * Chiedi un posto in una partita aperta
 *
 * Mette la richiesta del posto: lo occupa solo chi organizza, accettando
 * (`POST .../request/accept`). Chi richiede di nuovo sovrascrive la propria richiesta.
 * `starts_at`/`ends_at` propongono una fascia dentro la finestra della partita.
 * Errori: 403 `own_match|blocked|gender_mismatch`; 422
 * `profile_incomplete` (con `missing`)`|unknown_seat|invalid_slot|already_seated`;
 * 410 `expired`; 409 `not_open|spot_taken` (con `free_seats`)`|request_pending|time_conflict`
 * (`time_conflict`: ha gia' una partita con orario esatto che si sovrappone, contando lo slot
 * proposto). `note` (max 280) la legge chi organizza in `match_finder.request.note`;
 * piu' lunga: 422 `invalid_params`.
 *
 */
export const postUserMatchesByIdRequest = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUserMatchesByIdRequestData, ThrowOnError>
): RequestResult<
  PostUserMatchesByIdRequestResponses,
  PostUserMatchesByIdRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUserMatchesByIdRequestResponses,
    PostUserMatchesByIdRequestErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/request',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Accetta la richiesta del posto
 *
 * Solo chi organizza. Assegna il posto a chi l'ha chiesto; l'ultimo posto porta la
 * partita a `full`. Il body identifica la richiesta vista (`request_user_id`,
 * `requested_at`): se sulla riga ce n'e' un'altra risponde 409 `request_changed`.
 * Errori: 403 `forbidden`; 422 `invalid_params|no_request`; 410 `expired`;
 * 409 `spot_taken` (con `free_seats`)`|request_changed|time_conflict` (chi ha chiesto e' gia'
 * impegnato in quell'orario).
 *
 */
export const postUserMatchesByIdRequestAccept = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUserMatchesByIdRequestAcceptData, ThrowOnError>
): RequestResult<
  PostUserMatchesByIdRequestAcceptResponses,
  PostUserMatchesByIdRequestAcceptErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUserMatchesByIdRequestAcceptResponses,
    PostUserMatchesByIdRequestAcceptErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/request/accept',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Rifiuta la richiesta del posto
 *
 * Solo chi organizza. Il body identifica la richiesta vista, come per accept. Errori: 403 `forbidden`; 422 `invalid_params|no_request`; 409 `request_changed`.
 */
export const postUserMatchesByIdRequestReject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUserMatchesByIdRequestRejectData, ThrowOnError>
): RequestResult<
  PostUserMatchesByIdRequestRejectResponses,
  PostUserMatchesByIdRequestRejectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUserMatchesByIdRequestRejectResponses,
    PostUserMatchesByIdRequestRejectErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/request/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Lascia il posto
 *
 * Libera il posto dell'utente corrente; una partita `full` torna `open`. Errori: 422 `not_seated|started` (la partita e' gia' iniziata).
 */
export const deleteUserMatchesByIdSeat = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUserMatchesByIdSeatData, ThrowOnError>
): RequestResult<
  DeleteUserMatchesByIdSeatResponses,
  DeleteUserMatchesByIdSeatErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteUserMatchesByIdSeatResponses,
    DeleteUserMatchesByIdSeatErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/seat',
    ...options,
  })

/**
 * Annulla una partita da organizzare
 *
 * Solo l'organizzatore (altrimenti 403 `forbidden`). Porta la partita a `cancelled` e cancella la richiesta in attesa; una partita gia' `played` non si annulla (`422`).
 */
export const postUserMatchesByIdCancel = <ThrowOnError extends boolean = false>(
  options: Options<PostUserMatchesByIdCancelData, ThrowOnError>
): RequestResult<
  PostUserMatchesByIdCancelResponses,
  PostUserMatchesByIdCancelErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUserMatchesByIdCancelResponses,
    PostUserMatchesByIdCancelErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Le mie partite da organizzare
 *
 * Partite da organizzare che creo, in cui sono seduto o ho una richiesta viva: `open` e `proposed` non ancora iniziate, `full`, `played` degli ultimi 7 giorni e, solo a chi crea o e' seduto, `cancelled` degli ultimi 7 giorni (con `cancel_reason`). Per `starts_at` crescente. Senza paginazione.
 */
export const getUserMatchesMine = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserMatchesMineData, ThrowOnError>
): RequestResult<GetUserMatchesMineResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetUserMatchesMineResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/mine',
    ...options,
  })

/**
 * Giocano vicino a te
 *
 * Chi si fa trovare (`discoverable: true`) vicino a chi chiede, per la sezione sotto il feed:
 * stesso genere, nessun blocco in nessuna direzione, escluso chi chiede. Prima chi ha l'attivita'
 * piu' recente (`last_played_at`), poi il piu' vicino; 20 al massimo. Punto e raggio come il feed:
 * `lat`/`lng` oppure la citta' del profilo, `radius_km` default 25. Se chi chiede non si fa trovare
 * risponde `locked: true` senza persone, con solo `count` per la lista sfocata. 422
 * `profile_incomplete` (con `missing`) se il profilo non e' completo.
 *
 */
export const getUserMatchesPlayersNearby = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUserMatchesPlayersNearbyData, ThrowOnError>
): RequestResult<GetUserMatchesPlayersNearbyResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetUserMatchesPlayersNearbyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/players-nearby',
    ...options,
  })

/**
 * Attiva o disattiva il promemoria
 *
 * Solo chi partecipa (organizzatore o seduto).
 */
export const putUserMatchesByIdReminder = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUserMatchesByIdReminderData, ThrowOnError>
): RequestResult<
  PutUserMatchesByIdReminderResponses,
  PutUserMatchesByIdReminderErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutUserMatchesByIdReminderResponses,
    PutUserMatchesByIdReminderErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/reminder',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Segna la partita come festeggiata
 *
 * Idempotente. Solo chi partecipa (organizzatore o seduto).
 */
export const postUserMatchesByIdCelebrated = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUserMatchesByIdCelebratedData, ThrowOnError>
): RequestResult<
  PostUserMatchesByIdCelebratedResponses,
  PostUserMatchesByIdCelebratedErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUserMatchesByIdCelebratedResponses,
    PostUserMatchesByIdCelebratedErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/celebrated',
    ...options,
  })

/**
 * Accetta una sfida
 *
 * Solo chi e' sfidato (posto opponent o second_opponent, non il compagno di chi sfida), su una partita `proposed` non ancora iniziata. La porta a `full`. `409 not_open` se nel frattempo e' stata ritirata o ha gia' una risposta, `422 started` dopo l'inizio.
 */
export const postUserMatchesByIdAccept = <ThrowOnError extends boolean = false>(
  options: Options<PostUserMatchesByIdAcceptData, ThrowOnError>
): RequestResult<
  PostUserMatchesByIdAcceptResponses,
  PostUserMatchesByIdAcceptErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUserMatchesByIdAcceptResponses,
    PostUserMatchesByIdAcceptErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/accept',
    ...options,
  })

/**
 * Rifiuta una sfida
 *
 * Solo chi e' sfidato (posto opponent o second_opponent, non il compagno di chi sfida), su una partita `proposed` non ancora iniziata. La porta a `cancelled` e imposta rejected_at. `409 not_open` se nel frattempo e' stata ritirata o ha gia' una risposta, `422 started` dopo l'inizio.
 */
export const postUserMatchesByIdDecline = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostUserMatchesByIdDeclineData, ThrowOnError>
): RequestResult<
  PostUserMatchesByIdDeclineResponses,
  PostUserMatchesByIdDeclineErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostUserMatchesByIdDeclineResponses,
    PostUserMatchesByIdDeclineErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/decline',
    ...options,
  })
